<script>
var addressData = {
  data: [
    {
      label: "北京",
      value: "北京",
      children: [
        {
          label: "朝陽區",
          value: "朝陽區",
          children: [
            { label: "三環以內", value: "三環以內" },
            { label: "三環到四環之間", value: "三環到四環之間" },
            { label: "四環到五環之間", value: "四環到五環之間" },
            { label: "五環到六環之間", value: "五環到六環之間" },
            { label: "管庄", value: "管庄" },
            { label: "北苑", value: "北苑" },
            { label: "定福庄", value: "定福庄" }
          ]
        },
        {
          label: "海淀區",
          value: "海淀區",
          children: [
            { label: "三環以內", value: "三環以內" },
            { label: "三環到四環之間", value: "三環到四環之間" },
            { label: "四環到五環之間", value: "四環到五環之間" },
            { label: "五環到六環之間", value: "五環到六環之間" },
            { label: "六環以外", value: "六環以外" },
            { label: "西三旗", value: "西三旗" },
            { label: "西二旗", value: "西二旗" }
          ]
        },
        {
          label: "西城區",
          value: "西城區",
          children: [
            { label: "內環到二環里", value: "內環到二環里" },
            { label: "二環到三環", value: "二環到三環" }
          ]
        },
        {
          label: "東城區",
          value: "東城區",
          children: [{ label: "內環到三環里", value: "內環到三環里" }]
        },
        {
          label: "崇文區",
          value: "崇文區",
          children: [
            { label: "一環到二環", value: "一環到二環" },
            { label: "二環到三環", value: "二環到三環" }
          ]
        },
        {
          label: "宣武區",
          value: "宣武區",
          children: [{ label: "內環到三環里", value: "內環到三環里" }]
        },
        {
          label: "丰台區",
          value: "丰台區",
          children: [
            { label: "四環到五環之間", value: "四環到五環之間" },
            { label: "二環到三環", value: "二環到三環" },
            { label: "三環到四環之間", value: "三環到四環之間" },
            { label: "五環到六環之間", value: "五環到六環之間" },
            { label: "六環之外", value: "六環之外" }
          ]
        },
        {
          label: "石景山區",
          value: "石景山區",
          children: [
            { label: "四環到五環內", value: "四環到五環內" },
            { label: "石景山城區", value: "石景山城區" },
            { label: "八大處科技園區", value: "八大處科技園區" }
          ]
        },
        {
          label: "門頭溝",
          value: "門頭溝",
          children: [
            { label: "城區", value: "城區" },
            { label: "龍泉鎮", value: "龍泉鎮" },
            { label: "永定鎮", value: "永定鎮" },
            { label: "大台鎮", value: "大台鎮" },
            { label: "潭柘寺鎮", value: "潭柘寺鎮" },
            { label: "王平鎮", value: "王平鎮" },
            { label: "軍庄鎮", value: "軍庄鎮" },
            { label: "妙峰山鎮", value: "妙峰山鎮" },
            { label: "雁翅鎮", value: "雁翅鎮" },
            { label: "齋堂鎮", value: "齋堂鎮" },
            { label: "清水鎮", value: "清水鎮" }
          ]
        },
        {
          label: "房山區",
          value: "房山區",
          children: [
            { label: "城區", value: "城區" },
            { label: "大安山鄉", value: "大安山鄉" },
            { label: "大石窩鎮", value: "大石窩鎮" },
            { label: "竇店鎮", value: "竇店鎮" },
            { label: "佛子庄鄉", value: "佛子庄鄉" },
            { label: "韓村河鎮", value: "韓村河鎮" },
            { label: "河北鎮", value: "河北鎮" },
            { label: "良鄉鎮", value: "良鄉鎮" },
            { label: "琉璃河鎮", value: "琉璃河鎮" },
            { label: "南窖鄉", value: "南窖鄉" },
            { label: "蒲窪鄉", value: "蒲窪鄉" },
            { label: "青龍湖鎮", value: "青龍湖鎮" },
            { label: "十渡鎮", value: "十渡鎮" },
            { label: "石樓鎮", value: "石樓鎮" },
            { label: "史家營鄉", value: "史家營鄉" },
            { label: "霞雲嶺鄉", value: "霞雲嶺鄉" },
            { label: "新鎮", value: "新鎮" },
            { label: "閻村鎮", value: "閻村鎮" },
            { label: "燕山地區", value: "燕山地區" },
            { label: "張坊鎮", value: "張坊鎮" },
            { label: "長溝鎮", value: "長溝鎮" },
            { label: "長陽鎮", value: "長陽鎮" },
            { label: "周口店鎮", value: "周口店鎮" }
          ]
        },
        {
          label: "通州區",
          value: "通州區",
          children: [
            { label: "六環內（馬駒橋鎮）", value: "六環內（馬駒橋鎮）" },
            { label: "六環外（馬駒橋鎮）", value: "六環外（馬駒橋鎮）" },
            { label: "永順鎮", value: "永順鎮" },
            { label: "梨園鎮", value: "梨園鎮" },
            { label: "宋庄鎮", value: "宋庄鎮" },
            { label: "漷縣鎮", value: "漷縣鎮" },
            { label: "張家灣鎮", value: "張家灣鎮" },
            { label: "西集鎮", value: "西集鎮" },
            { label: "永樂店鎮", value: "永樂店鎮" },
            { label: "潞城鎮", value: "潞城鎮" },
            { label: "台湖鎮", value: "台湖鎮" },
            { label: "於家務鄉", value: "於家務鄉" },
            { label: "中倉街道", value: "中倉街道" },
            { label: "新華街道", value: "新華街道" },
            { label: "玉橋街道", value: "玉橋街道" },
            { label: "北苑街道", value: "北苑街道" },
            { label: "次渠鎮", value: "次渠鎮" }
          ]
        },
        {
          label: "大興區",
          value: "大興區",
          children: [
            { label: "四環至五環之間", value: "四環至五環之間" },
            { label: "六環以外", value: "六環以外" },
            { label: "五環至六環之間", value: "五環至六環之間" },
            { label: "亦庄經濟開發區", value: "亦庄經濟開發區" }
          ]
        },
        {
          label: "順義區",
          value: "順義區",
          children: [
            { label: "北石槽鎮", value: "北石槽鎮" },
            { label: "北務鎮", value: "北務鎮" },
            { label: "北小營鎮", value: "北小營鎮" },
            { label: "大孫各庄鎮", value: "大孫各庄鎮" },
            { label: "高麗營鎮", value: "高麗營鎮" },
            { label: "光明街道", value: "光明街道" },
            { label: "後沙峪地區", value: "後沙峪地區" },
            { label: "空港街道", value: "空港街道" },
            { label: "李橋鎮", value: "李橋鎮" },
            { label: "李遂鎮", value: "李遂鎮" },
            { label: "龍灣屯鎮", value: "龍灣屯鎮" },
            { label: "馬坡地區", value: "馬坡地區" },
            { label: "木林鎮", value: "木林鎮" },
            { label: "南彩鎮", value: "南彩鎮" },
            { label: "南法信地區", value: "南法信地區" },
            { label: "牛欄山地區", value: "牛欄山地區" },
            { label: "仁和地區", value: "仁和地區" },
            { label: "勝利街道", value: "勝利街道" },
            { label: "石園街道", value: "石園街道" },
            { label: "雙豐街道", value: "雙豐街道" },
            { label: "天竺地區", value: "天竺地區" },
            { label: "旺泉街道", value: "旺泉街道" },
            { label: "楊鎮地區", value: "楊鎮地區" },
            { label: "張鎮", value: "張鎮" },
            { label: "趙全營鎮", value: "趙全營鎮" }
          ]
        },
        {
          label: "懷柔區",
          value: "懷柔區",
          children: [
            { label: "郊區", value: "郊區" },
            { label: "城區以內", value: "城區以內" }
          ]
        },
        {
          label: "密雲區",
          value: "密雲區",
          children: [
            { label: "城區以外", value: "城區以外" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "昌平區",
          value: "昌平區",
          children: [
            { label: "城區以外", value: "城區以外" },
            { label: "六環以內", value: "六環以內" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "平谷區",
          value: "平谷區",
          children: [
            { label: "城區以外", value: "城區以外" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "延慶縣",
          value: "延慶縣",
          children: [
            { label: "延慶鎮", value: "延慶鎮" },
            { label: "城區", value: "城區" },
            { label: "康莊鎮", value: "康莊鎮" },
            { label: "八達嶺鎮", value: "八達嶺鎮" },
            { label: "永寧鎮", value: "永寧鎮" },
            { label: "舊縣鎮", value: "舊縣鎮" },
            { label: "張山營鎮", value: "張山營鎮" },
            { label: "四海鎮", value: "四海鎮" },
            { label: "千家店鎮", value: "千家店鎮" },
            { label: "沈家營鎮", value: "沈家營鎮" },
            { label: "大榆樹鎮", value: "大榆樹鎮" },
            { label: "井庄鎮", value: "井庄鎮" },
            { label: "大庄科鄉", value: "大庄科鄉" },
            { label: "劉斌堡鄉", value: "劉斌堡鄉" },
            { label: "香營鄉", value: "香營鄉" },
            { label: "珍珠泉鄉", value: "珍珠泉鄉" }
          ]
        }
      ]
    },
    {
      label: "上海",
      value: "上海",
      children: [
        {
          label: "黃浦區",
          value: "黃浦區",
          children: [{ label: "城區", value: "城區" }]
        },
        {
          label: "徐匯區",
          value: "徐匯區",
          children: [{ label: "城區", value: "城區" }]
        },
        {
          label: "長寧區",
          value: "長寧區",
          children: [{ label: "城區", value: "城區" }]
        },
        {
          label: "靜安區",
          value: "靜安區",
          children: [{ label: "城區", value: "城區" }]
        },
        {
          label: "閘北區",
          value: "閘北區",
          children: [{ label: "城區", value: "城區" }]
        },
        {
          label: "虹口區",
          value: "虹口區",
          children: [{ label: "城區", value: "城區" }]
        },
        {
          label: "楊浦區",
          value: "楊浦區",
          children: [{ label: "城區", value: "城區" }]
        },
        {
          label: "寶山區",
          value: "寶山區",
          children: [
            { label: "羅店鎮", value: "羅店鎮" },
            { label: "大場鎮", value: "大場鎮" },
            { label: "楊行鎮", value: "楊行鎮" },
            { label: "月浦鎮", value: "月浦鎮" },
            { label: "羅涇鎮", value: "羅涇鎮" },
            { label: "顧村鎮", value: "顧村鎮" },
            { label: "高境鎮", value: "高境鎮" },
            { label: "廟行鎮", value: "廟行鎮" },
            { label: "淞南鎮", value: "淞南鎮" },
            { label: "寶山城市工業園區", value: "寶山城市工業園區" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "閔行區",
          value: "閔行區",
          children: [
            { label: "城區", value: "城區" },
            { label: "莘庄鎮", value: "莘庄鎮" },
            { label: "七寶鎮", value: "七寶鎮" },
            { label: "浦江鎮", value: "浦江鎮" },
            { label: "梅隴鎮", value: "梅隴鎮" },
            { label: "虹橋鎮", value: "虹橋鎮" },
            { label: "馬橋鎮", value: "馬橋鎮" },
            { label: "吳涇鎮", value: "吳涇鎮" },
            { label: "華漕鎮", value: "華漕鎮" },
            { label: "顓橋鎮", value: "顓橋鎮" }
          ]
        },
        {
          label: "嘉定區",
          value: "嘉定區",
          children: [
            { label: "城區", value: "城區" },
            { label: "南翔鎮", value: "南翔鎮" },
            { label: "馬陸鎮", value: "馬陸鎮" },
            { label: "華亭鎮", value: "華亭鎮" },
            { label: "江橋鎮", value: "江橋鎮" },
            { label: "菊園新區", value: "菊園新區" },
            { label: "安亭鎮", value: "安亭鎮" },
            { label: "徐行鎮", value: "徐行鎮" },
            { label: "外岡鎮", value: "外岡鎮" },
            { label: "嘉定工業區", value: "嘉定工業區" }
          ]
        },
        {
          label: "浦東新區",
          value: "浦東新區",
          children: [
            { label: "城區", value: "城區" },
            { label: "川沙新鎮", value: "川沙新鎮" },
            { label: "高橋鎮", value: "高橋鎮" },
            { label: "北蔡鎮", value: "北蔡鎮" },
            { label: "合慶鎮", value: "合慶鎮" },
            { label: "唐鎮", value: "唐鎮" },
            { label: "曹路鎮", value: "曹路鎮" },
            { label: "金橋鎮", value: "金橋鎮" },
            { label: "高行鎮", value: "高行鎮" },
            { label: "高東鎮", value: "高東鎮" },
            { label: "張江鎮", value: "張江鎮" },
            { label: "三林鎮", value: "三林鎮" },
            { label: "南匯新城鎮", value: "南匯新城鎮" },
            { label: "祝橋鎮", value: "祝橋鎮" },
            { label: "新場鎮", value: "新場鎮" },
            { label: "惠南鎮", value: "惠南鎮" },
            { label: "康橋鎮", value: "康橋鎮" },
            { label: "宣橋鎮", value: "宣橋鎮" },
            { label: "書院鎮", value: "書院鎮" },
            { label: "大團鎮", value: "大團鎮" },
            { label: "周浦鎮", value: "周浦鎮" },
            { label: "蘆潮港鎮", value: "蘆潮港鎮" },
            { label: "泥城鎮", value: "泥城鎮" },
            { label: "航頭鎮", value: "航頭鎮" },
            { label: "萬祥鎮", value: "萬祥鎮" },
            { label: "老港鎮", value: "老港鎮" }
          ]
        },
        {
          label: "青浦區",
          value: "青浦區",
          children: [
            { label: "朱家角鎮", value: "朱家角鎮" },
            { label: "趙巷鎮", value: "趙巷鎮" },
            { label: "徐涇鎮", value: "徐涇鎮" },
            { label: "華新鎮", value: "華新鎮" },
            { label: "重固鎮", value: "重固鎮" },
            { label: "白鶴鎮", value: "白鶴鎮" },
            { label: "練塘鎮", value: "練塘鎮" },
            { label: "金澤鎮", value: "金澤鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "松江區",
          value: "松江區",
          children: [
            { label: "城區", value: "城區" },
            { label: "泗涇鎮", value: "泗涇鎮" },
            { label: "佘山鎮", value: "佘山鎮" },
            { label: "車墩鎮", value: "車墩鎮" },
            { label: "新橋鎮", value: "新橋鎮" },
            { label: "洞涇鎮", value: "洞涇鎮" },
            { label: "九亭鎮", value: "九亭鎮" },
            { label: "泖港鎮", value: "泖港鎮" },
            { label: "石湖盪鎮", value: "石湖盪鎮" },
            { label: "新浜鎮", value: "新浜鎮" },
            { label: "葉榭鎮", value: "葉榭鎮" },
            { label: "小崑山鎮", value: "小崑山鎮" }
          ]
        },
        {
          label: "金山區",
          value: "金山區",
          children: [
            { label: "城區", value: "城區" },
            { label: "金山工業區", value: "金山工業區" },
            { label: "朱涇鎮", value: "朱涇鎮" },
            { label: "楓涇鎮", value: "楓涇鎮" },
            { label: "張堰鎮", value: "張堰鎮" },
            { label: "亭林鎮", value: "亭林鎮" },
            { label: "呂巷鎮", value: "呂巷鎮" },
            { label: "廊下鎮", value: "廊下鎮" },
            { label: "金山衛鎮", value: "金山衛鎮" },
            { label: "漕涇鎮", value: "漕涇鎮" },
            { label: "山陽鎮", value: "山陽鎮" }
          ]
        },
        {
          label: "奉賢區",
          value: "奉賢區",
          children: [
            { label: "南橋鎮", value: "南橋鎮" },
            { label: "奉城鎮", value: "奉城鎮" },
            { label: "四團鎮", value: "四團鎮" },
            { label: "柘林鎮", value: "柘林鎮" },
            { label: "庄行鎮", value: "庄行鎮" },
            { label: "金匯鎮", value: "金匯鎮" },
            { label: "青村鎮", value: "青村鎮" },
            { label: "海灣鎮", value: "海灣鎮" }
          ]
        },
        {
          label: "普陀區",
          value: "普陀區",
          children: [{ label: "城區", value: "城區" }]
        },
        {
          label: "崇明縣",
          value: "崇明縣",
          children: [
            { label: "堡鎮", value: "堡鎮" },
            { label: "廟鎮", value: "廟鎮" },
            { label: "陳家鎮", value: "陳家鎮" },
            { label: "城橋鎮", value: "城橋鎮" },
            { label: "東平鎮", value: "東平鎮" },
            { label: "港西鎮", value: "港西鎮" },
            { label: "港沿鎮", value: "港沿鎮" },
            { label: "建設鎮", value: "建設鎮" },
            { label: "綠華鎮", value: "綠華鎮" },
            { label: "三星鎮", value: "三星鎮" },
            { label: "豎新鎮", value: "豎新鎮" },
            { label: "向化鎮", value: "向化鎮" },
            { label: "新海鎮", value: "新海鎮" },
            { label: "新河鎮", value: "新河鎮" },
            { label: "中興鎮", value: "中興鎮" },
            { label: "長興鄉", value: "長興鄉" },
            { label: "橫沙鄉", value: "橫沙鄉" },
            { label: "新村鄉", value: "新村鄉" }
          ]
        }
      ]
    },
    {
      label: "天津",
      value: "天津",
      children: [
        {
          label: "東麗區",
          value: "東麗區",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "和平區",
          value: "和平區",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "河北區",
          value: "河北區",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "河東區",
          value: "河東區",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "河西區",
          value: "河西區",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "紅橋區",
          value: "紅橋區",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "薊縣",
          value: "薊縣",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "靜海縣",
          value: "靜海縣",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "南開區",
          value: "南開區",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "塘沽區",
          value: "塘沽區",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "西青區",
          value: "西青區",
          children: [
            { label: "其它地區", value: "其它地區" },
            {
              label: "楊柳青,中北,精武,大寺鎮,環外海泰及外環內",
              value: "楊柳青,中北,精武,大寺鎮,環外海泰及外環內"
            }
          ]
        },
        {
          label: "武清區",
          value: "武清區",
          children: [
            { label: "楊村鎮、下朱庄內", value: "楊村鎮、下朱庄內" },
            { label: "其它地區", value: "其它地區" }
          ]
        },
        {
          label: "津南區",
          value: "津南區",
          children: [
            {
              label: "鹹水沽鎮、海河教育園，海河科技園",
              value: "鹹水沽鎮、海河教育園，海河科技園"
            },
            { label: "雙港，辛庄", value: "雙港，辛庄" },
            { label: "其他地區", value: "其他地區" }
          ]
        },
        {
          label: "漢沽區",
          value: "漢沽區",
          children: [
            {
              label: "漢沽區街里、漢沽開發區",
              value: "漢沽區街里、漢沽開發區"
            },
            { label: "其它地區", value: "其它地區" }
          ]
        },
        {
          label: "大港區",
          value: "大港區",
          children: [
            { label: "大港油田", value: "大港油田" },
            { label: "主城區內", value: "主城區內" },
            { label: "主城區外", value: "主城區外" }
          ]
        },
        {
          label: "北辰區",
          value: "北辰區",
          children: [
            { label: "外環內", value: "外環內" },
            {
              label: "外環外雙街鎮，河北工大新校，屈店工業園",
              value: "外環外雙街鎮，河北工大新校，屈店工業園"
            },
            { label: "外環外其它地區", value: "外環外其它地區" }
          ]
        },
        {
          label: "寶坻區",
          value: "寶坻區",
          children: [
            {
              label: "城關鎮、馬家店開發區、天寶工業園",
              value: "城關鎮、馬家店開發區、天寶工業園"
            },
            { label: "其它地區", value: "其它地區" }
          ]
        },
        {
          label: "寧河縣",
          value: "寧河縣",
          children: [
            {
              label: "蘆台鎮、經濟開發區、貿易開發區",
              value: "蘆台鎮、經濟開發區、貿易開發區"
            },
            { label: "其它地區", value: "其它地區" }
          ]
        }
      ]
    },
    {
      label: "重慶",
      value: "重慶",
      children: [
        {
          label: "萬州區",
          value: "萬州區",
          children: [
            { label: "白土鎮", value: "白土鎮" },
            { label: "白羊鎮", value: "白羊鎮" },
            { label: "大周鎮", value: "大周鎮" },
            { label: "彈子鎮", value: "彈子鎮" },
            { label: "分水鎮", value: "分水鎮" },
            { label: "甘寧鎮", value: "甘寧鎮" },
            { label: "高峰鎮", value: "高峰鎮" },
            { label: "高梁鎮", value: "高梁鎮" },
            { label: "後山鎮", value: "後山鎮" },
            { label: "李河鎮", value: "李河鎮" },
            { label: "龍駒鎮", value: "龍駒鎮" },
            { label: "龍沙鎮", value: "龍沙鎮" },
            { label: "羅田鎮", value: "羅田鎮" },
            { label: "孫家鎮", value: "孫家鎮" },
            { label: "太安鎮", value: "太安鎮" },
            { label: "太龍鎮", value: "太龍鎮" },
            { label: "天城鎮", value: "天城鎮" },
            { label: "武陵鎮", value: "武陵鎮" },
            { label: "響水鎮", value: "響水鎮" },
            { label: "小周鎮", value: "小周鎮" },
            { label: "新田鎮", value: "新田鎮" },
            { label: "新鄉鎮", value: "新鄉鎮" },
            { label: "熊家鎮", value: "熊家鎮" },
            { label: "余家鎮", value: "余家鎮" },
            { label: "長嶺鎮", value: "長嶺鎮" },
            { label: "長坪鎮", value: "長坪鎮" },
            { label: "長灘鎮", value: "長灘鎮" },
            { label: "走馬鎮", value: "走馬鎮" },
            { label: "瀼渡鎮", value: "瀼渡鎮" },
            { label: "茨竹鄉", value: "茨竹鄉" },
            { label: "柱山鄉", value: "柱山鄉" },
            { label: "燕山鄉", value: "燕山鄉" },
            { label: "溪口鄉", value: "溪口鄉" },
            { label: "普子鄉", value: "普子鄉" },
            { label: "地寶鄉", value: "地寶鄉" },
            { label: "鐵峰鄉", value: "鐵峰鄉" },
            { label: "黃柏鄉", value: "黃柏鄉" },
            { label: "九池鄉", value: "九池鄉" },
            { label: "梨樹鄉", value: "梨樹鄉" },
            { label: "郭村鄉", value: "郭村鄉" },
            { label: "恆合鄉", value: "恆合鄉" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "涪陵區",
          value: "涪陵區",
          children: [
            { label: "李渡鎮", value: "李渡鎮" },
            { label: "白濤鎮", value: "白濤鎮" },
            { label: "百勝鎮", value: "百勝鎮" },
            { label: "堡子鎮", value: "堡子鎮" },
            { label: "焦石鎮", value: "焦石鎮" },
            { label: "藺市鎮", value: "藺市鎮" },
            { label: "龍橋鎮", value: "龍橋鎮" },
            { label: "龍潭鎮", value: "龍潭鎮" },
            { label: "馬武鎮", value: "馬武鎮" },
            { label: "南沱鎮", value: "南沱鎮" },
            { label: "青羊鎮", value: "青羊鎮" },
            { label: "清溪鎮", value: "清溪鎮" },
            { label: "石沱鎮", value: "石沱鎮" },
            { label: "新妙鎮", value: "新妙鎮" },
            { label: "義和鎮", value: "義和鎮" },
            { label: "增福鄉", value: "增福鄉" },
            { label: "珍溪鎮", value: "珍溪鎮" },
            { label: "鎮安鎮", value: "鎮安鎮" },
            { label: "致韓鎮", value: "致韓鎮" },
            { label: "土地坡鄉", value: "土地坡鄉" },
            { label: "武陵山鄉", value: "武陵山鄉" },
            { label: "中峰鄉", value: "中峰鄉" },
            { label: "梓里鄉", value: "梓里鄉" },
            { label: "叢林鄉", value: "叢林鄉" },
            { label: "大木鄉", value: "大木鄉" },
            { label: "惠民鄉", value: "惠民鄉" },
            { label: "酒店鄉", value: "酒店鄉" },
            { label: "聚寶鄉", value: "聚寶鄉" },
            { label: "卷洞鄉", value: "卷洞鄉" },
            { label: "兩匯鄉", value: "兩匯鄉" },
            { label: "羅雲鄉", value: "羅雲鄉" },
            { label: "明家鄉", value: "明家鄉" },
            { label: "仁義鄉", value: "仁義鄉" },
            { label: "山窩鄉", value: "山窩鄉" },
            { label: "石和鄉", value: "石和鄉" },
            { label: "石龍鄉", value: "石龍鄉" },
            { label: "太和鄉", value: "太和鄉" },
            { label: "天台鄉", value: "天台鄉" },
            { label: "同樂鄉", value: "同樂鄉" },
            { label: "新村鄉", value: "新村鄉" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "梁平縣",
          value: "梁平縣",
          children: [
            { label: "梁山鎮", value: "梁山鎮" },
            { label: "柏家鎮", value: "柏家鎮" },
            { label: "碧山鎮", value: "碧山鎮" },
            { label: "大觀鎮", value: "大觀鎮" },
            { label: "福祿鎮", value: "福祿鎮" },
            { label: "合興鎮", value: "合興鎮" },
            { label: "和林鎮", value: "和林鎮" },
            { label: "虎城鎮", value: "虎城鎮" },
            { label: "回龍鎮", value: "回龍鎮" },
            { label: "金帶鎮", value: "金帶鎮" },
            { label: "聚奎鎮", value: "聚奎鎮" },
            { label: "禮讓鎮", value: "禮讓鎮" },
            { label: "龍門鎮", value: "龍門鎮" },
            { label: "明達鎮", value: "明達鎮" },
            { label: "蟠龍鎮", value: "蟠龍鎮" },
            { label: "屏錦鎮", value: "屏錦鎮" },
            { label: "仁賢鎮", value: "仁賢鎮" },
            { label: "石安鎮", value: "石安鎮" },
            { label: "文化鎮", value: "文化鎮" },
            { label: "新盛鎮", value: "新盛鎮" },
            { label: "蔭平鎮", value: "蔭平鎮" },
            { label: "袁驛鎮", value: "袁驛鎮" },
            { label: "雲龍鎮", value: "雲龍鎮" },
            { label: "竹山鎮", value: "竹山鎮" },
            { label: "安勝鄉", value: "安勝鄉" },
            { label: "鐵門鄉", value: "鐵門鄉" },
            { label: "紫照鄉", value: "紫照鄉" },
            { label: "曲水鄉", value: "曲水鄉" },
            { label: "龍勝鄉", value: "龍勝鄉" },
            { label: "城北鄉", value: "城北鄉" },
            { label: "城東鄉", value: "城東鄉" },
            { label: "復平鄉", value: "復平鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "南川區",
          value: "南川區",
          children: [
            { label: "太平場鎮", value: "太平場鎮" },
            { label: "大觀鎮", value: "大觀鎮" },
            { label: "大有鎮", value: "大有鎮" },
            { label: "合溪鎮", value: "合溪鎮" },
            { label: "金山鎮", value: "金山鎮" },
            { label: "鳴玉鎮", value: "鳴玉鎮" },
            { label: "南平鎮", value: "南平鎮" },
            { label: "三泉鎮", value: "三泉鎮" },
            { label: "神童鎮", value: "神童鎮" },
            { label: "石牆鎮", value: "石牆鎮" },
            { label: "水江鎮", value: "水江鎮" },
            { label: "頭渡鎮", value: "頭渡鎮" },
            { label: "興隆鎮", value: "興隆鎮" },
            { label: "冷水關鄉", value: "冷水關鄉" },
            { label: "德隆鄉", value: "德隆鄉" },
            { label: "峰岩鄉", value: "峰岩鄉" },
            { label: "福壽鄉", value: "福壽鄉" },
            { label: "古花鄉", value: "古花鄉" },
            { label: "河圖鄉", value: "河圖鄉" },
            { label: "民主鄉", value: "民主鄉" },
            { label: "木涼鄉", value: "木涼鄉" },
            { label: "乾豐鄉", value: "乾豐鄉" },
            { label: "慶元鄉", value: "慶元鄉" },
            { label: "石蓮鄉", value: "石蓮鄉" },
            { label: "石溪鄉", value: "石溪鄉" },
            { label: "鐵村鄉", value: "鐵村鄉" },
            { label: "土溪鄉", value: "土溪鄉" },
            { label: "魚泉鄉", value: "魚泉鄉" },
            { label: "中橋鄉", value: "中橋鄉" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "潼南縣",
          value: "潼南縣",
          children: [
            { label: "柏梓鎮", value: "柏梓鎮" },
            { label: "寶龍鎮", value: "寶龍鎮" },
            { label: "崇龕鎮", value: "崇龕鎮" },
            { label: "古溪鎮", value: "古溪鎮" },
            { label: "龍形鎮", value: "龍形鎮" },
            { label: "米心鎮", value: "米心鎮" },
            { label: "群力鎮", value: "群力鎮" },
            { label: "上和鎮", value: "上和鎮" },
            { label: "雙江鎮", value: "雙江鎮" },
            { label: "太安鎮", value: "太安鎮" },
            { label: "塘壩鎮", value: "塘壩鎮" },
            { label: "卧佛鎮", value: "卧佛鎮" },
            { label: "五桂鎮", value: "五桂鎮" },
            { label: "小渡鎮", value: "小渡鎮" },
            { label: "新勝鎮", value: "新勝鎮" },
            { label: "玉溪鎮", value: "玉溪鎮" },
            { label: "別口鄉", value: "別口鄉" },
            { label: "田家鄉", value: "田家鄉" },
            { label: "壽橋鄉", value: "壽橋鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "大足區",
          value: "大足區",
          children: [
            { label: "龍灘子鎮", value: "龍灘子鎮" },
            { label: "龍水鎮", value: "龍水鎮" },
            { label: "智鳳鎮", value: "智鳳鎮" },
            { label: "寶頂鎮", value: "寶頂鎮" },
            { label: "中敖鎮", value: "中敖鎮" },
            { label: "三驅鎮", value: "三驅鎮" },
            { label: "寶興鎮", value: "寶興鎮" },
            { label: "玉龍鎮", value: "玉龍鎮" },
            { label: "石馬鎮", value: "石馬鎮" },
            { label: "拾萬鎮", value: "拾萬鎮" },
            { label: "回龍鎮", value: "回龍鎮" },
            { label: "金山鎮", value: "金山鎮" },
            { label: "萬古鎮", value: "萬古鎮" },
            { label: "國梁鎮", value: "國梁鎮" },
            { label: "雍溪鎮", value: "雍溪鎮" },
            { label: "珠溪鎮", value: "珠溪鎮" },
            { label: "龍石鎮", value: "龍石鎮" },
            { label: "郵亭鎮", value: "郵亭鎮" },
            { label: "鐵山鎮", value: "鐵山鎮" },
            { label: "高升鎮", value: "高升鎮" },
            { label: "季家鎮", value: "季家鎮" },
            { label: "古龍鎮", value: "古龍鎮" },
            { label: "高坪鎮", value: "高坪鎮" },
            { label: "雙路鎮", value: "雙路鎮" },
            { label: "通橋鎮", value: "通橋鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "黔江區",
          value: "黔江區",
          children: [
            { label: "正陽鎮", value: "正陽鎮" },
            { label: "舟白鎮", value: "舟白鎮" },
            { label: "阿蓬江鎮", value: "阿蓬江鎮" },
            { label: "小南海鎮", value: "小南海鎮" },
            { label: "鵝池鎮", value: "鵝池鎮" },
            { label: "馮家鎮", value: "馮家鎮" },
            { label: "黑溪鎮", value: "黑溪鎮" },
            { label: "黃溪鎮", value: "黃溪鎮" },
            { label: "金溪鎮", value: "金溪鎮" },
            { label: "黎水鎮", value: "黎水鎮" },
            { label: "鄰鄂鎮", value: "鄰鄂鎮" },
            { label: "馬喇鎮", value: "馬喇鎮" },
            { label: "石會鎮", value: "石會鎮" },
            { label: "石家鎮", value: "石家鎮" },
            { label: "濯水鎮", value: "濯水鎮" },
            { label: "白石鄉", value: "白石鄉" },
            { label: "白土鄉", value: "白土鄉" },
            { label: "金洞鄉", value: "金洞鄉" },
            { label: "蓬東鄉", value: "蓬東鄉" },
            { label: "沙壩鄉", value: "沙壩鄉" },
            { label: "杉嶺鄉", value: "杉嶺鄉" },
            { label: "水市鄉", value: "水市鄉" },
            { label: "水田鄉", value: "水田鄉" },
            { label: "太極鄉", value: "太極鄉" },
            { label: "五里鄉", value: "五里鄉" },
            { label: "新華鄉", value: "新華鄉" },
            { label: "中塘鄉", value: "中塘鄉" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "武隆縣",
          value: "武隆縣",
          children: [
            { label: "仙女山鎮", value: "仙女山鎮" },
            { label: "巷口鎮", value: "巷口鎮" },
            { label: "白馬鎮", value: "白馬鎮" },
            { label: "火爐鎮", value: "火爐鎮" },
            { label: "江口鎮", value: "江口鎮" },
            { label: "平橋鎮", value: "平橋鎮" },
            { label: "桐梓鎮", value: "桐梓鎮" },
            { label: "土坎鎮", value: "土坎鎮" },
            { label: "鴨江鎮", value: "鴨江鎮" },
            { label: "羊角鎮", value: "羊角鎮" },
            { label: "長壩鎮", value: "長壩鎮" },
            { label: "白雲鄉", value: "白雲鄉" },
            { label: "滄溝鄉", value: "滄溝鄉" },
            { label: "鳳來鄉", value: "鳳來鄉" },
            { label: "浩口鄉", value: "浩口鄉" },
            { label: "和順鄉", value: "和順鄉" },
            { label: "後坪鄉", value: "後坪鄉" },
            { label: "黃鶯鄉", value: "黃鶯鄉" },
            { label: "接龍鄉", value: "接龍鄉" },
            { label: "廟埡鄉", value: "廟埡鄉" },
            { label: "石橋鄉", value: "石橋鄉" },
            { label: "雙河鄉", value: "雙河鄉" },
            { label: "鐵礦鄉", value: "鐵礦鄉" },
            { label: "土地鄉", value: "土地鄉" },
            { label: "文復鄉", value: "文復鄉" },
            { label: "趙家鄉", value: "趙家鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "豐都縣",
          value: "豐都縣",
          children: [
            { label: "南天湖鎮", value: "南天湖鎮" },
            { label: "許明寺鎮", value: "許明寺鎮" },
            { label: "包鸞鎮", value: "包鸞鎮" },
            { label: "董家鎮", value: "董家鎮" },
            { label: "高家鎮", value: "高家鎮" },
            { label: "虎威鎮", value: "虎威鎮" },
            { label: "江池鎮", value: "江池鎮" },
            { label: "龍河鎮", value: "龍河鎮" },
            { label: "名山鎮", value: "名山鎮" },
            { label: "三元鎮", value: "三元鎮" },
            { label: "社壇鎮", value: "社壇鎮" },
            { label: "十直鎮", value: "十直鎮" },
            { label: "樹人鎮", value: "樹人鎮" },
            { label: "雙路鎮", value: "雙路鎮" },
            { label: "武平鎮", value: "武平鎮" },
            { label: "興義鎮", value: "興義鎮" },
            { label: "湛普鎮", value: "湛普鎮" },
            { label: "鎮江鎮", value: "鎮江鎮" },
            { label: "太平壩鄉", value: "太平壩鄉" },
            { label: "雙龍場鄉", value: "雙龍場鄉" },
            { label: "保合鄉", value: "保合鄉" },
            { label: "崇興鄉", value: "崇興鄉" },
            { label: "都督鄉", value: "都督鄉" },
            { label: "暨龍鄉", value: "暨龍鄉" },
            { label: "栗子鄉", value: "栗子鄉" },
            { label: "龍孔鄉", value: "龍孔鄉" },
            { label: "青龍鄉", value: "青龍鄉" },
            { label: "仁沙鄉", value: "仁沙鄉" },
            { label: "三壩鄉", value: "三壩鄉" },
            { label: "三建鄉", value: "三建鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "奉節縣",
          value: "奉節縣",
          children: [
            { label: "永安鎮", value: "永安鎮" },
            { label: "白帝鎮", value: "白帝鎮" },
            { label: "草堂鎮", value: "草堂鎮" },
            { label: "大樹鎮", value: "大樹鎮" },
            { label: "汾河鎮", value: "汾河鎮" },
            { label: "公平鎮", value: "公平鎮" },
            { label: "甲高鎮", value: "甲高鎮" },
            { label: "康樂鎮", value: "康樂鎮" },
            { label: "青龍鎮", value: "青龍鎮" },
            { label: "吐祥鎮", value: "吐祥鎮" },
            { label: "新民鎮", value: "新民鎮" },
            { label: "興隆鎮", value: "興隆鎮" },
            { label: "羊市鎮", value: "羊市鎮" },
            { label: "朱衣鎮", value: "朱衣鎮" },
            { label: "竹園鎮", value: "竹園鎮" },
            { label: "安坪鄉", value: "安坪鄉" },
            { label: "馮坪鄉", value: "馮坪鄉" },
            { label: "鶴峰鄉", value: "鶴峰鄉" },
            { label: "紅土鄉", value: "紅土鄉" },
            { label: "康坪鄉", value: "康坪鄉" },
            { label: "龍橋鄉", value: "龍橋鄉" },
            { label: "平安鄉", value: "平安鄉" },
            { label: "石崗鄉", value: "石崗鄉" },
            { label: "太和鄉", value: "太和鄉" },
            { label: "五馬鄉", value: "五馬鄉" },
            { label: "新政鄉", value: "新政鄉" },
            { label: "岩灣鄉", value: "岩灣鄉" },
            { label: "雲霧鄉", value: "雲霧鄉" },
            { label: "長安鄉", value: "長安鄉" },
            { label: "縣城內", value: "縣城內" },
            { label: "永樂鎮", value: "永樂鎮" }
          ]
        },
        {
          label: "開縣",
          value: "開縣",
          children: [
            { label: "九龍山鎮", value: "九龍山鎮" },
            { label: "大進鎮", value: "大進鎮" },
            { label: "敦好鎮", value: "敦好鎮" },
            { label: "高橋鎮", value: "高橋鎮" },
            { label: "郭家鎮", value: "郭家鎮" },
            { label: "和謙鎮", value: "和謙鎮" },
            { label: "河堰鎮", value: "河堰鎮" },
            { label: "厚壩鎮", value: "厚壩鎮" },
            { label: "臨江鎮", value: "臨江鎮" },
            { label: "南門鎮", value: "南門鎮" },
            { label: "南雅鎮", value: "南雅鎮" },
            { label: "渠口鎮", value: "渠口鎮" },
            { label: "鐵橋鎮", value: "鐵橋鎮" },
            { label: "溫泉鎮", value: "溫泉鎮" },
            { label: "義和鎮", value: "義和鎮" },
            { label: "長沙鎮", value: "長沙鎮" },
            { label: "趙家鎮", value: "趙家鎮" },
            { label: "鎮安鎮", value: "鎮安鎮" },
            { label: "中和鎮", value: "中和鎮" },
            { label: "竹溪鎮", value: "竹溪鎮" },
            { label: "三匯口鄉", value: "三匯口鄉" },
            { label: "白橋鄉", value: "白橋鄉" },
            { label: "大德鄉", value: "大德鄉" },
            { label: "關面鄉", value: "關面鄉" },
            { label: "金峰鄉", value: "金峰鄉" },
            { label: "麻柳鄉", value: "麻柳鄉" },
            { label: "滿月鄉", value: "滿月鄉" },
            { label: "譚家鄉", value: "譚家鄉" },
            { label: "天和鄉", value: "天和鄉" },
            { label: "巫山鎮", value: "巫山鎮" },
            { label: "五通鄉", value: "五通鄉" },
            { label: "紫水鄉", value: "紫水鄉" },
            { label: "縣城內", value: "縣城內" },
            { label: "白橋鎮", value: "白橋鎮" },
            { label: "大德鎮", value: "大德鎮" },
            { label: "金峰鎮", value: "金峰鎮" },
            { label: "譚家鎮", value: "譚家鎮" },
            { label: "天和鎮", value: "天和鎮" },
            { label: "白泉鄉", value: "白泉鄉" },
            { label: "岳溪鎮", value: "岳溪鎮" }
          ]
        },
        {
          label: "雲陽縣",
          value: "雲陽縣",
          children: [
            { label: "雲陽鎮", value: "雲陽鎮" },
            { label: "巴陽鎮", value: "巴陽鎮" },
            { label: "鳳鳴鎮", value: "鳳鳴鎮" },
            { label: "高陽鎮", value: "高陽鎮" },
            { label: "故陵鎮", value: "故陵鎮" },
            { label: "紅獅鎮", value: "紅獅鎮" },
            { label: "黃石鎮", value: "黃石鎮" },
            { label: "江口鎮", value: "江口鎮" },
            { label: "龍角鎮", value: "龍角鎮" },
            { label: "路陽鎮", value: "路陽鎮" },
            { label: "南溪鎮", value: "南溪鎮" },
            { label: "農壩鎮", value: "農壩鎮" },
            { label: "盤龍鎮", value: "盤龍鎮" },
            { label: "平安鎮", value: "平安鎮" },
            { label: "渠馬鎮", value: "渠馬鎮" },
            { label: "人和鎮", value: "人和鎮" },
            { label: "桑坪鎮", value: "桑坪鎮" },
            { label: "沙市鎮", value: "沙市鎮" },
            { label: "雙土鎮", value: "雙土鎮" },
            { label: "魚泉鎮", value: "魚泉鎮" },
            { label: "雲安鎮", value: "雲安鎮" },
            { label: "洞鹿鄉", value: "洞鹿鄉" },
            { label: "後葉鄉", value: "後葉鄉" },
            { label: "龍洞鄉", value: "龍洞鄉" },
            { label: "毛壩鄉", value: "毛壩鄉" },
            { label: "泥溪鄉", value: "泥溪鄉" },
            { label: "票草鄉", value: "票草鄉" },
            { label: "普安鄉", value: "普安鄉" },
            { label: "棲霞鄉", value: "棲霞鄉" },
            { label: "清水鄉", value: "清水鄉" },
            { label: "上壩鄉", value: "上壩鄉" },
            { label: "石門鄉", value: "石門鄉" },
            { label: "雙龍鄉", value: "雙龍鄉" },
            { label: "水口鄉", value: "水口鄉" },
            { label: "外郎鄉", value: "外郎鄉" },
            { label: "新津鄉", value: "新津鄉" },
            { label: "堰坪鄉", value: "堰坪鄉" },
            { label: "養鹿鄉", value: "養鹿鄉" },
            { label: "耀靈鄉", value: "耀靈鄉" },
            { label: "雲硐鄉", value: "雲硐鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "忠縣",
          value: "忠縣",
          children: [
            { label: "忠州鎮", value: "忠州鎮" },
            { label: "拔山鎮", value: "拔山鎮" },
            { label: "白石鎮", value: "白石鎮" },
            { label: "東溪鎮", value: "東溪鎮" },
            { label: "復興鎮", value: "復興鎮" },
            { label: "官壩鎮", value: "官壩鎮" },
            { label: "花橋鎮", value: "花橋鎮" },
            { label: "黃金鎮", value: "黃金鎮" },
            { label: "金雞鎮", value: "金雞鎮" },
            { label: "馬灌鎮", value: "馬灌鎮" },
            { label: "任家鎮", value: "任家鎮" },
            { label: "汝溪鎮", value: "汝溪鎮" },
            { label: "三匯鎮", value: "三匯鎮" },
            { label: "石寶鎮", value: "石寶鎮" },
            { label: "石黃鎮", value: "石黃鎮" },
            { label: "雙桂鎮", value: "雙桂鎮" },
            { label: "烏楊鎮", value: "烏楊鎮" },
            { label: "新生鎮", value: "新生鎮" },
            { label: "洋渡鎮", value: "洋渡鎮" },
            { label: "野鶴鎮", value: "野鶴鎮" },
            { label: "永豐鎮", value: "永豐鎮" },
            { label: "金聲鄉", value: "金聲鄉" },
            { label: "磨子鄉", value: "磨子鄉" },
            { label: "善廣鄉", value: "善廣鄉" },
            { label: "石子鄉", value: "石子鄉" },
            { label: "塗井鄉", value: "塗井鄉" },
            { label: "興峰鄉", value: "興峰鄉" },
            { label: "新立鎮", value: "新立鎮" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "巫溪縣",
          value: "巫溪縣",
          children: [
            { label: "城廂鎮", value: "城廂鎮" },
            { label: "鳳凰鎮", value: "鳳凰鎮" },
            { label: "古路鎮", value: "古路鎮" },
            { label: "尖山鎮", value: "尖山鎮" },
            { label: "寧廠鎮", value: "寧廠鎮" },
            { label: "上磺鎮", value: "上磺鎮" },
            { label: "文峰鎮", value: "文峰鎮" },
            { label: "下堡鎮", value: "下堡鎮" },
            { label: "徐家鎮", value: "徐家鎮" },
            { label: "朝陽洞鄉", value: "朝陽洞鄉" },
            { label: "大河鄉", value: "大河鄉" },
            { label: "峰靈鄉", value: "峰靈鄉" },
            { label: "花台鄉", value: "花台鄉" },
            { label: "蘭英鄉", value: "蘭英鄉" },
            { label: "菱角鄉", value: "菱角鄉" },
            { label: "蒲蓮鄉", value: "蒲蓮鄉" },
            { label: "勝利鄉", value: "勝利鄉" },
            { label: "雙陽鄉", value: "雙陽鄉" },
            { label: "塘坊鄉", value: "塘坊鄉" },
            { label: "天星鄉", value: "天星鄉" },
            { label: "天元鄉", value: "天元鄉" },
            { label: "田壩鄉", value: "田壩鄉" },
            { label: "通城鄉", value: "通城鄉" },
            { label: "土城鄉", value: "土城鄉" },
            { label: "烏龍鄉", value: "烏龍鄉" },
            { label: "魚鱗鄉", value: "魚鱗鄉" },
            { label: "長桂鄉", value: "長桂鄉" },
            { label: "中崗鄉", value: "中崗鄉" },
            { label: "中梁鄉", value: "中梁鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "巫山縣",
          value: "巫山縣",
          children: [
            { label: "巫峽鎮", value: "巫峽鎮" },
            { label: "大昌鎮", value: "大昌鎮" },
            { label: "福田鎮", value: "福田鎮" },
            { label: "官渡鎮", value: "官渡鎮" },
            { label: "官陽鎮", value: "官陽鎮" },
            { label: "龍溪鎮", value: "龍溪鎮" },
            { label: "騾坪鎮", value: "騾坪鎮" },
            { label: "廟堂鄉", value: "廟堂鄉" },
            { label: "廟宇鎮", value: "廟宇鎮" },
            { label: "雙龍鎮", value: "雙龍鎮" },
            { label: "銅鼓鎮", value: "銅鼓鎮" },
            { label: "抱龍鎮", value: "抱龍鎮" },
            { label: "大溪鄉", value: "大溪鄉" },
            { label: "當陽鄉", value: "當陽鄉" },
            { label: "鄧家鄉", value: "鄧家鄉" },
            { label: "篤坪鄉", value: "篤坪鄉" },
            { label: "紅椿鄉", value: "紅椿鄉" },
            { label: "建平鄉", value: "建平鄉" },
            { label: "金坪鄉", value: "金坪鄉" },
            { label: "兩坪鄉", value: "兩坪鄉" },
            { label: "龍井鄉", value: "龍井鄉" },
            { label: "培石鄉", value: "培石鄉" },
            { label: "平河鄉", value: "平河鄉" },
            { label: "曲尺鄉", value: "曲尺鄉" },
            { label: "三溪鄉", value: "三溪鄉" },
            { label: "竹賢鄉", value: "竹賢鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "石柱縣",
          value: "石柱縣",
          children: [
            { label: "南賓鎮", value: "南賓鎮" },
            { label: "黃水鎮", value: "黃水鎮" },
            { label: "臨溪鎮", value: "臨溪鎮" },
            { label: "龍沙鎮", value: "龍沙鎮" },
            { label: "馬武鎮", value: "馬武鎮" },
            { label: "沙子鎮", value: "沙子鎮" },
            { label: "王場鎮", value: "王場鎮" },
            { label: "西沱鎮", value: "西沱鎮" },
            { label: "下路鎮", value: "下路鎮" },
            { label: "沿溪鎮", value: "沿溪鎮" },
            { label: "漁池鎮", value: "漁池鎮" },
            { label: "悅崍鎮", value: "悅崍鎮" },
            { label: "大歇鄉", value: "大歇鄉" },
            { label: "楓木鄉", value: "楓木鄉" },
            { label: "河嘴鄉", value: "河嘴鄉" },
            { label: "黃鶴鄉", value: "黃鶴鄉" },
            { label: "金鈴鄉", value: "金鈴鄉" },
            { label: "金竹鄉", value: "金竹鄉" },
            { label: "冷水鄉", value: "冷水鄉" },
            { label: "黎場鄉", value: "黎場鄉" },
            { label: "六塘鄉", value: "六塘鄉" },
            { label: "龍潭鄉", value: "龍潭鄉" },
            { label: "橋頭鄉", value: "橋頭鄉" },
            { label: "三河鄉", value: "三河鄉" },
            { label: "三益鄉", value: "三益鄉" },
            { label: "石家鄉", value: "石家鄉" },
            { label: "萬朝鄉", value: "萬朝鄉" },
            { label: "王家鄉", value: "王家鄉" },
            { label: "洗新鄉", value: "洗新鄉" },
            { label: "新樂鄉", value: "新樂鄉" },
            { label: "中益鄉", value: "中益鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "彭水縣",
          value: "彭水縣",
          children: [
            { label: "保家鎮", value: "保家鎮" },
            { label: "高谷鎮", value: "高谷鎮" },
            { label: "黃家鎮", value: "黃家鎮" },
            { label: "連湖鎮", value: "連湖鎮" },
            { label: "龍射鎮", value: "龍射鎮" },
            { label: "鹿角鎮", value: "鹿角鎮" },
            { label: "普子鎮", value: "普子鎮" },
            { label: "桑柘鎮", value: "桑柘鎮" },
            { label: "萬足鎮", value: "萬足鎮" },
            { label: "郁山鎮", value: "郁山鎮" },
            { label: "梅子埡鄉", value: "梅子埡鄉" },
            { label: "鞍子鄉", value: "鞍子鄉" },
            { label: "大埡鄉", value: "大埡鄉" },
            { label: "棣棠鄉", value: "棣棠鄉" },
            { label: "靛水鄉", value: "靛水鄉" },
            { label: "朗溪鄉", value: "朗溪鄉" },
            { label: "聯合鄉", value: "聯合鄉" },
            { label: "龍塘鄉", value: "龍塘鄉" },
            { label: "龍溪鄉", value: "龍溪鄉" },
            { label: "蘆塘鄉", value: "蘆塘鄉" },
            { label: "鹿鳴鄉", value: "鹿鳴鄉" },
            { label: "平安鄉", value: "平安鄉" },
            { label: "遷喬鄉", value: "遷喬鄉" },
            { label: "喬梓鄉", value: "喬梓鄉" },
            { label: "潤溪鄉", value: "潤溪鄉" },
            { label: "三義鄉", value: "三義鄉" },
            { label: "善感鄉", value: "善感鄉" },
            { label: "石柳鄉", value: "石柳鄉" },
            { label: "石盤鄉", value: "石盤鄉" },
            { label: "雙龍鄉", value: "雙龍鄉" },
            { label: "太原鄉", value: "太原鄉" },
            { label: "桐樓鄉", value: "桐樓鄉" },
            { label: "小廠鄉", value: "小廠鄉" },
            { label: "新田鄉", value: "新田鄉" },
            { label: "岩東鄉", value: "岩東鄉" },
            { label: "長灘鄉", value: "長灘鄉" },
            { label: "諸佛鄉", value: "諸佛鄉" },
            { label: "走馬鄉", value: "走馬鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "墊江縣",
          value: "墊江縣",
          children: [
            { label: "桂溪鎮", value: "桂溪鎮" },
            { label: "澄溪鎮", value: "澄溪鎮" },
            { label: "高安鎮", value: "高安鎮" },
            { label: "高峰鎮", value: "高峰鎮" },
            { label: "鶴游鎮", value: "鶴游鎮" },
            { label: "普順鎮", value: "普順鎮" },
            { label: "沙坪鎮", value: "沙坪鎮" },
            { label: "太平鎮", value: "太平鎮" },
            { label: "五洞鎮", value: "五洞鎮" },
            { label: "新民鎮", value: "新民鎮" },
            { label: "硯台鎮", value: "硯台鎮" },
            { label: "永安鎮", value: "永安鎮" },
            { label: "周嘉鎮", value: "周嘉鎮" },
            { label: "白家鄉", value: "白家鄉" },
            { label: "包家鄉", value: "包家鄉" },
            { label: "曹回鄉", value: "曹回鄉" },
            { label: "大石鄉", value: "大石鄉" },
            { label: "杠家鄉", value: "杠家鄉" },
            { label: "黃沙鄉", value: "黃沙鄉" },
            { label: "裴興鄉", value: "裴興鄉" },
            { label: "三溪鄉", value: "三溪鄉" },
            { label: "沙河鄉", value: "沙河鄉" },
            { label: "永平鄉", value: "永平鄉" },
            { label: "長龍鄉", value: "長龍鄉" },
            { label: "坪山鎮", value: "坪山鎮" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "酉陽縣",
          value: "酉陽縣",
          children: [
            { label: "鍾多鎮", value: "鍾多鎮" },
            { label: "蒼嶺鎮", value: "蒼嶺鎮" },
            { label: "車田鄉", value: "車田鄉" },
            { label: "大溪鎮", value: "大溪鎮" },
            { label: "丁市鎮", value: "丁市鎮" },
            { label: "泔溪鎮", value: "泔溪鎮" },
            { label: "龔灘鎮", value: "龔灘鎮" },
            { label: "黑水鎮", value: "黑水鎮" },
            { label: "後溪鎮", value: "後溪鎮" },
            { label: "李溪鎮", value: "李溪鎮" },
            { label: "龍潭鎮", value: "龍潭鎮" },
            { label: "麻旺鎮", value: "麻旺鎮" },
            { label: "小河鎮", value: "小河鎮" },
            { label: "興隆鎮", value: "興隆鎮" },
            { label: "酉酬鎮", value: "酉酬鎮" },
            { label: "南腰界鄉", value: "南腰界鄉" },
            { label: "後坪壩鄉", value: "後坪壩鄉" },
            { label: "板溪鄉", value: "板溪鄉" },
            { label: "官清鄉", value: "官清鄉" },
            { label: "花田鄉", value: "花田鄉" },
            { label: "江豐鄉", value: "江豐鄉" },
            { label: "可大鄉", value: "可大鄉" },
            { label: "浪坪鄉", value: "浪坪鄉" },
            { label: "兩罾鄉", value: "兩罾鄉" },
            { label: "毛壩鄉", value: "毛壩鄉" },
            { label: "廟溪鄉", value: "廟溪鄉" },
            { label: "木葉鄉", value: "木葉鄉" },
            { label: "楠木鄉", value: "楠木鄉" },
            { label: "偏柏鄉", value: "偏柏鄉" },
            { label: "清泉鄉", value: "清泉鄉" },
            { label: "雙泉鄉", value: "雙泉鄉" },
            { label: "天館鄉", value: "天館鄉" },
            { label: "銅鼓鄉", value: "銅鼓鄉" },
            { label: "塗市鄉", value: "塗市鄉" },
            { label: "萬木鄉", value: "萬木鄉" },
            { label: "五福鄉", value: "五福鄉" },
            { label: "宜居鄉", value: "宜居鄉" },
            { label: "腴地鄉", value: "腴地鄉" },
            { label: "板橋鄉", value: "板橋鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "秀山縣",
          value: "秀山縣",
          children: [
            { label: "清溪場鎮", value: "清溪場鎮" },
            { label: "中和鎮", value: "中和鎮" },
            { label: "隘口鎮", value: "隘口鎮" },
            { label: "峨溶鎮", value: "峨溶鎮" },
            { label: "官莊鎮", value: "官莊鎮" },
            { label: "洪安鎮", value: "洪安鎮" },
            { label: "蘭橋鎮", value: "蘭橋鎮" },
            { label: "龍池鎮", value: "龍池鎮" },
            { label: "梅江鎮", value: "梅江鎮" },
            { label: "平凱鎮", value: "平凱鎮" },
            { label: "溶溪鎮", value: "溶溪鎮" },
            { label: "石堤鎮", value: "石堤鎮" },
            { label: "石耶鎮", value: "石耶鎮" },
            { label: "雅江鎮", value: "雅江鎮" },
            { label: "巴家鄉", value: "巴家鄉" },
            { label: "保安鄉", value: "保安鄉" },
            { label: "岑溪鄉", value: "岑溪鄉" },
            { label: "大溪鄉", value: "大溪鄉" },
            { label: "干川鄉", value: "干川鄉" },
            { label: "膏田鄉", value: "膏田鄉" },
            { label: "官舟鄉", value: "官舟鄉" },
            { label: "海洋鄉", value: "海洋鄉" },
            { label: "里仁鄉", value: "里仁鄉" },
            { label: "妙泉鄉", value: "妙泉鄉" },
            { label: "平馬鄉", value: "平馬鄉" },
            { label: "宋農鄉", value: "宋農鄉" },
            { label: "溪口鄉", value: "溪口鄉" },
            { label: "孝溪鄉", value: "孝溪鄉" },
            { label: "涌洞鄉", value: "涌洞鄉" },
            { label: "中平鄉", value: "中平鄉" },
            { label: "鍾靈鄉", value: "鍾靈鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "城口縣",
          value: "城口縣",
          children: [
            { label: "葛城鎮", value: "葛城鎮" },
            { label: "巴山鎮", value: "巴山鎮" },
            { label: "高觀鎮", value: "高觀鎮" },
            { label: "廟壩鎮", value: "廟壩鎮" },
            { label: "明通鎮", value: "明通鎮" },
            { label: "坪壩鎮", value: "坪壩鎮" },
            { label: "修齊鎮", value: "修齊鎮" },
            { label: "北屏鄉", value: "北屏鄉" },
            { label: "東安鄉", value: "東安鄉" },
            { label: "高楠鄉", value: "高楠鄉" },
            { label: "高燕鄉", value: "高燕鄉" },
            { label: "河魚鄉", value: "河魚鄉" },
            { label: "厚坪鄉", value: "厚坪鄉" },
            { label: "雞鳴鄉", value: "雞鳴鄉" },
            { label: "嵐天鄉", value: "嵐天鄉" },
            { label: "蓼子鄉", value: "蓼子鄉" },
            { label: "龍田鄉", value: "龍田鄉" },
            { label: "明中鄉", value: "明中鄉" },
            { label: "雙河鄉", value: "雙河鄉" },
            { label: "咸宜鄉", value: "咸宜鄉" },
            { label: "沿河鄉", value: "沿河鄉" },
            { label: "治平鄉", value: "治平鄉" },
            { label: "周溪鄉", value: "周溪鄉" },
            { label: "左嵐鄉", value: "左嵐鄉" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "璧山縣",
          value: "璧山縣",
          children: [
            { label: "縣城內", value: "縣城內" },
            { label: "青杠鎮", value: "青杠鎮" },
            { label: "來鳳鎮", value: "來鳳鎮" },
            { label: "丁家鎮", value: "丁家鎮" },
            { label: "大路鎮", value: "大路鎮" },
            { label: "八塘鎮", value: "八塘鎮" },
            { label: "七塘鎮", value: "七塘鎮" },
            { label: "河邊鎮", value: "河邊鎮" },
            { label: "福祿鎮", value: "福祿鎮" },
            { label: "大興鎮", value: "大興鎮" },
            { label: "正興鎮", value: "正興鎮" },
            { label: "廣普鎮", value: "廣普鎮" },
            { label: "三合鎮", value: "三合鎮" },
            { label: "健龍鎮", value: "健龍鎮" }
          ]
        },
        {
          label: "榮昌縣",
          value: "榮昌縣",
          children: [
            { label: "縣城內", value: "縣城內" },
            { label: "廣順鎮", value: "廣順鎮" },
            { label: "安富鎮", value: "安富鎮" },
            { label: "峰高鎮", value: "峰高鎮" },
            { label: "雙河鎮", value: "雙河鎮" },
            { label: "直升鎮", value: "直升鎮" },
            { label: "路孔鎮", value: "路孔鎮" },
            { label: "清江鎮", value: "清江鎮" },
            { label: "仁義鎮", value: "仁義鎮" },
            { label: "河包鎮", value: "河包鎮" },
            { label: "古昌鎮", value: "古昌鎮" },
            { label: "吳家鎮", value: "吳家鎮" },
            { label: "觀勝鎮", value: "觀勝鎮" },
            { label: "銅鼓鎮", value: "銅鼓鎮" },
            { label: "清流鎮", value: "清流鎮" },
            { label: "盤龍鎮", value: "盤龍鎮" },
            { label: "遠覺鎮", value: "遠覺鎮" },
            { label: "清升鎮", value: "清升鎮" },
            { label: "榮隆鎮", value: "榮隆鎮" },
            { label: "龍集鎮", value: "龍集鎮" }
          ]
        },
        {
          label: "銅梁縣",
          value: "銅梁縣",
          children: [
            { label: "縣城內", value: "縣城內" },
            { label: "土橋鎮", value: "土橋鎮" },
            { label: "二坪鎮", value: "二坪鎮" },
            { label: "水口鎮", value: "水口鎮" },
            { label: "安居鎮", value: "安居鎮" },
            { label: "白羊鎮", value: "白羊鎮" },
            { label: "平灘鎮", value: "平灘鎮" },
            { label: "石魚鎮", value: "石魚鎮" },
            { label: "福果鎮", value: "福果鎮" },
            { label: "維新鎮", value: "維新鎮" },
            { label: "高樓鎮", value: "高樓鎮" },
            { label: "大廟鎮", value: "大廟鎮" },
            { label: "圍龍鎮", value: "圍龍鎮" },
            { label: "華興鎮", value: "華興鎮" },
            { label: "永嘉鎮", value: "永嘉鎮" },
            { label: "安溪鎮", value: "安溪鎮" },
            { label: "西河鎮", value: "西河鎮" },
            { label: "太平鎮", value: "太平鎮" },
            { label: "舊縣鎮", value: "舊縣鎮" },
            { label: "虎峰鎮", value: "虎峰鎮" },
            { label: "少雲鎮", value: "少雲鎮" },
            { label: "蒲呂鎮", value: "蒲呂鎮" },
            { label: "侶俸鎮", value: "侶俸鎮" },
            { label: "小林鄉", value: "小林鄉" },
            { label: "雙山鄉", value: "雙山鄉" },
            { label: "慶隆鄉", value: "慶隆鄉" }
          ]
        },
        {
          label: "合川區",
          value: "合川區",
          children: [
            { label: "草街鎮", value: "草街鎮" },
            { label: "鹽井鎮", value: "鹽井鎮" },
            { label: "雲門鎮", value: "雲門鎮" },
            { label: "大石鎮", value: "大石鎮" },
            { label: "沙魚鎮", value: "沙魚鎮" },
            { label: "官渡鎮", value: "官渡鎮" },
            { label: "淶灘鎮", value: "淶灘鎮" },
            { label: "肖家鎮", value: "肖家鎮" },
            { label: "古樓鎮", value: "古樓鎮" },
            { label: "三廟鎮", value: "三廟鎮" },
            { label: "二郎鎮", value: "二郎鎮" },
            { label: "龍鳳鎮", value: "龍鳳鎮" },
            { label: "隆興鎮", value: "隆興鎮" },
            { label: "銅溪鎮", value: "銅溪鎮" },
            { label: "雙鳳鎮", value: "雙鳳鎮" },
            { label: "獅灘鎮", value: "獅灘鎮" },
            { label: "清平鎮", value: "清平鎮" },
            { label: "土場鎮", value: "土場鎮" },
            { label: "小沔鎮", value: "小沔鎮" },
            { label: "三匯鎮", value: "三匯鎮" },
            { label: "香龍鎮", value: "香龍鎮" },
            { label: "錢塘鎮", value: "錢塘鎮" },
            { label: "龍市鎮", value: "龍市鎮" },
            { label: "燕窩鎮", value: "燕窩鎮" },
            { label: "太和鎮", value: "太和鎮" },
            { label: "渭沱鎮", value: "渭沱鎮" },
            { label: "雙槐鎮", value: "雙槐鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "巴南區",
          value: "巴南區",
          children: [
            { label: "南泉鎮", value: "南泉鎮" },
            { label: "一品鎮", value: "一品鎮" },
            { label: "南彭鎮", value: "南彭鎮" },
            { label: "惠民鎮", value: "惠民鎮" },
            { label: "麻柳嘴鎮", value: "麻柳嘴鎮" },
            { label: "天星寺鎮", value: "天星寺鎮" },
            { label: "雙河口鎮", value: "雙河口鎮" },
            { label: "界石鎮", value: "界石鎮" },
            { label: "安瀾鎮", value: "安瀾鎮" },
            { label: "跳石鎮", value: "跳石鎮" },
            { label: "木洞鎮", value: "木洞鎮" },
            { label: "豐盛鎮", value: "豐盛鎮" },
            { label: "二聖鎮", value: "二聖鎮" },
            { label: "東泉鎮", value: "東泉鎮" },
            { label: "姜家鎮", value: "姜家鎮" },
            { label: "接龍鎮", value: "接龍鎮" },
            { label: "石灘鎮", value: "石灘鎮" },
            { label: "石龍鎮", value: "石龍鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "北碚區",
          value: "北碚區",
          children: [
            { label: "東陽鎮", value: "東陽鎮" },
            { label: "蔡家崗鎮", value: "蔡家崗鎮" },
            { label: "童家溪鎮", value: "童家溪鎮" },
            { label: "施家梁鎮", value: "施家梁鎮" },
            { label: "金刀峽鎮", value: "金刀峽鎮" },
            { label: "澄江鎮", value: "澄江鎮" },
            { label: "水土鎮", value: "水土鎮" },
            { label: "歇馬鎮", value: "歇馬鎮" },
            { label: "天府鎮", value: "天府鎮" },
            { label: "復興鎮", value: "復興鎮" },
            { label: "靜觀鎮", value: "靜觀鎮" },
            { label: "柳蔭鎮", value: "柳蔭鎮" },
            { label: "三聖鎮", value: "三聖鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "江津區",
          value: "江津區",
          children: [
            { label: "四面山鎮", value: "四面山鎮" },
            { label: "支坪鎮", value: "支坪鎮" },
            { label: "白沙鎮", value: "白沙鎮" },
            { label: "珞璜鎮", value: "珞璜鎮" },
            { label: "柏林鎮", value: "柏林鎮" },
            { label: "蔡家鎮", value: "蔡家鎮" },
            { label: "慈雲鎮", value: "慈雲鎮" },
            { label: "杜市鎮", value: "杜市鎮" },
            { label: "廣興鎮", value: "廣興鎮" },
            { label: "嘉平鎮", value: "嘉平鎮" },
            { label: "賈嗣鎮", value: "賈嗣鎮" },
            { label: "李市鎮", value: "李市鎮" },
            { label: "龍華鎮", value: "龍華鎮" },
            { label: "石蟆鎮", value: "石蟆鎮" },
            { label: "石門鎮", value: "石門鎮" },
            { label: "塘河鎮", value: "塘河鎮" },
            { label: "吳灘鎮", value: "吳灘鎮" },
            { label: "西湖鎮", value: "西湖鎮" },
            { label: "夏壩鎮", value: "夏壩鎮" },
            { label: "先鋒鎮", value: "先鋒鎮" },
            { label: "永興鎮", value: "永興鎮" },
            { label: "油溪鎮", value: "油溪鎮" },
            { label: "中山鎮", value: "中山鎮" },
            { label: "朱楊鎮", value: "朱楊鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "渝北區",
          value: "渝北區",
          children: [
            { label: "禮嘉鎮", value: "禮嘉鎮" },
            { label: "兩路鎮", value: "兩路鎮" },
            { label: "王家鎮", value: "王家鎮" },
            { label: "悅來鎮", value: "悅來鎮" },
            { label: "玉峰山鎮", value: "玉峰山鎮" },
            { label: "茨竹鎮", value: "茨竹鎮" },
            { label: "大盛鎮", value: "大盛鎮" },
            { label: "大塆鎮", value: "大塆鎮" },
            { label: "古路鎮", value: "古路鎮" },
            { label: "龍興鎮", value: "龍興鎮" },
            { label: "洛磧鎮", value: "洛磧鎮" },
            { label: "木耳鎮", value: "木耳鎮" },
            { label: "石船鎮", value: "石船鎮" },
            { label: "統景鎮", value: "統景鎮" },
            { label: "興隆鎮", value: "興隆鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "長壽區",
          value: "長壽區",
          children: [
            { label: "長壽湖鎮", value: "長壽湖鎮" },
            { label: "鄰封鎮", value: "鄰封鎮" },
            { label: "但渡鎮", value: "但渡鎮" },
            { label: "雲集鎮", value: "雲集鎮" },
            { label: "雙龍鎮", value: "雙龍鎮" },
            { label: "龍河鎮", value: "龍河鎮" },
            { label: "石堰鎮", value: "石堰鎮" },
            { label: "雲台鎮", value: "雲台鎮" },
            { label: "海棠鎮", value: "海棠鎮" },
            { label: "葛蘭鎮", value: "葛蘭鎮" },
            { label: "新市鎮", value: "新市鎮" },
            { label: "八顆鎮", value: "八顆鎮" },
            { label: "洪湖鎮", value: "洪湖鎮" },
            { label: "萬順鎮", value: "萬順鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "永川區",
          value: "永川區",
          children: [
            { label: "雙竹鎮", value: "雙竹鎮" },
            { label: "三教鎮", value: "三教鎮" },
            { label: "大安鎮", value: "大安鎮" },
            { label: "陳食鎮", value: "陳食鎮" },
            { label: "板橋鎮", value: "板橋鎮" },
            { label: "寶峰鎮", value: "寶峰鎮" },
            { label: "臨江鎮", value: "臨江鎮" },
            { label: "紅爐鎮", value: "紅爐鎮" },
            { label: "吉安鎮", value: "吉安鎮" },
            { label: "金龍鎮", value: "金龍鎮" },
            { label: "來蘇鎮", value: "來蘇鎮" },
            { label: "青峰鎮", value: "青峰鎮" },
            { label: "雙石鎮", value: "雙石鎮" },
            { label: "松溉鎮", value: "松溉鎮" },
            { label: "五間鎮", value: "五間鎮" },
            { label: "仙龍鎮", value: "仙龍鎮" },
            { label: "永榮鎮", value: "永榮鎮" },
            { label: "朱沱鎮", value: "朱沱鎮" },
            { label: "何埂鎮", value: "何埂鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "江北區",
          value: "江北區",
          children: [
            { label: "內環以內", value: "內環以內" },
            { label: "寸灘鎮", value: "寸灘鎮" },
            { label: "郭家沱鎮", value: "郭家沱鎮" },
            { label: "鐵山坪鎮", value: "鐵山坪鎮" },
            { label: "魚嘴鎮", value: "魚嘴鎮" },
            { label: "復盛鎮", value: "復盛鎮" },
            { label: "五寶鎮", value: "五寶鎮" },
            { label: "大石壩鎮", value: "大石壩鎮" }
          ]
        },
        {
          label: "南岸區",
          value: "南岸區",
          children: [
            { label: "內環以內", value: "內環以內" },
            { label: "茶園新區", value: "茶園新區" },
            { label: "雞冠石鎮", value: "雞冠石鎮" },
            { label: "長生橋鎮", value: "長生橋鎮" },
            { label: "峽口鎮", value: "峽口鎮" },
            { label: "廣陽鎮", value: "廣陽鎮" },
            { label: "迎龍鎮", value: "迎龍鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "九龍坡區",
          value: "九龍坡區",
          children: [
            { label: "內環以內", value: "內環以內" },
            { label: "白市驛鎮", value: "白市驛鎮" },
            { label: "銅罐驛鎮", value: "銅罐驛鎮" },
            { label: "華岩鎮", value: "華岩鎮" },
            { label: "巴福鎮", value: "巴福鎮" },
            { label: "含谷鎮", value: "含谷鎮" },
            { label: "金鳳鎮", value: "金鳳鎮" },
            { label: "石板鎮", value: "石板鎮" },
            { label: "陶家鎮", value: "陶家鎮" },
            { label: "西彭鎮", value: "西彭鎮" },
            { label: "走馬鎮", value: "走馬鎮" }
          ]
        },
        {
          label: "沙坪壩區",
          value: "沙坪壩區",
          children: [
            { label: "內環以內", value: "內環以內" },
            { label: "陳家橋鎮", value: "陳家橋鎮" },
            { label: "歌樂山鎮", value: "歌樂山鎮" },
            { label: "青木關鎮", value: "青木關鎮" },
            { label: "回龍壩鎮", value: "回龍壩鎮" },
            { label: "大學城", value: "大學城" },
            { label: "虎溪鎮", value: "虎溪鎮" },
            { label: "西永鎮", value: "西永鎮" },
            { label: "土主鎮", value: "土主鎮" },
            { label: "井口鎮", value: "井口鎮" },
            { label: "曾家鎮", value: "曾家鎮" },
            { label: "鳳凰鎮", value: "鳳凰鎮" },
            { label: "中梁鎮", value: "中梁鎮" }
          ]
        },
        {
          label: "大渡口區",
          value: "大渡口區",
          children: [
            { label: "內環以內", value: "內環以內" },
            { label: "茄子溪鎮", value: "茄子溪鎮" },
            { label: "建勝鎮", value: "建勝鎮" },
            { label: "跳磴鎮", value: "跳磴鎮" }
          ]
        },
        {
          label: "綦江區",
          value: "綦江區",
          children: [
            { label: "三江鎮", value: "三江鎮" },
            { label: "安穩鎮", value: "安穩鎮" },
            { label: "打通鎮", value: "打通鎮" },
            { label: "丁山鎮", value: "丁山鎮" },
            { label: "東溪鎮", value: "東溪鎮" },
            { label: "扶歡鎮", value: "扶歡鎮" },
            { label: "趕水鎮", value: "趕水鎮" },
            { label: "郭扶鎮", value: "郭扶鎮" },
            { label: "橫山鎮", value: "橫山鎮" },
            { label: "隆盛鎮", value: "隆盛鎮" },
            { label: "三角鎮", value: "三角鎮" },
            { label: "石壕鎮", value: "石壕鎮" },
            { label: "石角鎮", value: "石角鎮" },
            { label: "新盛鎮", value: "新盛鎮" },
            { label: "永城鎮", value: "永城鎮" },
            { label: "永新鎮", value: "永新鎮" },
            { label: "中峰鎮", value: "中峰鎮" },
            { label: "篆塘鎮", value: "篆塘鎮" },
            { label: "叢林鎮", value: "叢林鎮" },
            { label: "關壩鎮", value: "關壩鎮" },
            { label: "黑山鎮", value: "黑山鎮" },
            { label: "金橋鎮", value: "金橋鎮" },
            { label: "南桐鎮", value: "南桐鎮" },
            { label: "青年鎮", value: "青年鎮" },
            { label: "石林鎮", value: "石林鎮" },
            { label: "萬東鎮", value: "萬東鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "渝中區",
          value: "渝中區",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "高新區",
          value: "高新區",
          children: [{ label: "全境", value: "全境" }]
        },
        {
          label: "北部新區",
          value: "北部新區",
          children: [{ label: "全境", value: "全境" }]
        }
      ]
    },
    {
      label: "河北",
      value: "河北",
      children: [
        {
          label: "石家莊市",
          value: "石家莊市",
          children: [
            { label: "辛集市", value: "辛集市" },
            { label: "晉州市", value: "晉州市" },
            { label: "新樂市", value: "新樂市" },
            { label: "井陘縣", value: "井陘縣" },
            { label: "欒城縣", value: "欒城縣" },
            { label: "行唐縣", value: "行唐縣" },
            { label: "靈壽縣", value: "靈壽縣" },
            { label: "高邑縣", value: "高邑縣" },
            { label: "趙縣", value: "趙縣" },
            { label: "贊皇縣", value: "贊皇縣" },
            { label: "深澤縣", value: "深澤縣" },
            { label: "無極縣", value: "無極縣" },
            { label: "元氏縣", value: "元氏縣" },
            { label: "井陘礦區", value: "井陘礦區" },
            { label: "平山縣", value: "平山縣" },
            { label: "藁城市", value: "藁城市" },
            { label: "鹿泉市", value: "鹿泉市" },
            { label: "正定縣", value: "正定縣" },
            { label: "新華區", value: "新華區" },
            { label: "橋西區", value: "橋西區" },
            { label: "橋東區", value: "橋東區" },
            { label: "裕華區", value: "裕華區" },
            { label: "長安區", value: "長安區" }
          ]
        },
        {
          label: "邯鄲市",
          value: "邯鄲市",
          children: [
            { label: "邯鄲縣", value: "邯鄲縣" },
            { label: "峰峰礦區", value: "峰峰礦區" },
            { label: "曲周縣", value: "曲周縣" },
            { label: "館陶縣", value: "館陶縣" },
            { label: "魏縣", value: "魏縣" },
            { label: "成安縣", value: "成安縣" },
            { label: "大名縣", value: "大名縣" },
            { label: "涉縣", value: "涉縣" },
            { label: "雞澤縣", value: "雞澤縣" },
            { label: "邱縣", value: "邱縣" },
            { label: "廣平縣", value: "廣平縣" },
            { label: "肥鄉縣", value: "肥鄉縣" },
            { label: "磁縣", value: "磁縣" },
            { label: "臨漳縣", value: "臨漳縣" },
            { label: "永年縣", value: "永年縣" },
            { label: "叢台區", value: "叢台區" },
            { label: "邯山區", value: "邯山區" },
            { label: "復興區", value: "復興區" },
            { label: "武安市", value: "武安市" }
          ]
        },
        {
          label: "邢台市",
          value: "邢台市",
          children: [
            { label: "邢台縣", value: "邢台縣" },
            { label: "南宮市", value: "南宮市" },
            { label: "沙河市", value: "沙河市" },
            { label: "柏鄉縣", value: "柏鄉縣" },
            { label: "任縣", value: "任縣" },
            { label: "清河縣", value: "清河縣" },
            { label: "隆堯縣", value: "隆堯縣" },
            { label: "臨城縣", value: "臨城縣" },
            { label: "廣宗縣", value: "廣宗縣" },
            { label: "臨西縣", value: "臨西縣" },
            { label: "內丘縣", value: "內丘縣" },
            { label: "平鄉縣", value: "平鄉縣" },
            { label: "巨鹿縣", value: "巨鹿縣" },
            { label: "新河縣", value: "新河縣" },
            { label: "南和縣", value: "南和縣" },
            { label: "寧晉縣", value: "寧晉縣" },
            { label: "威縣", value: "威縣" },
            { label: "橋西區", value: "橋西區" },
            { label: "橋東區", value: "橋東區" }
          ]
        },
        {
          label: "保定市",
          value: "保定市",
          children: [
            { label: "安國市", value: "安國市" },
            { label: "滿城縣", value: "滿城縣" },
            { label: "清苑縣", value: "清苑縣" },
            { label: "淶水縣", value: "淶水縣" },
            { label: "阜平縣", value: "阜平縣" },
            { label: "定興縣", value: "定興縣" },
            { label: "唐縣", value: "唐縣" },
            { label: "高陽縣", value: "高陽縣" },
            { label: "容城縣", value: "容城縣" },
            { label: "淶源縣", value: "淶源縣" },
            { label: "望都縣", value: "望都縣" },
            { label: "易縣", value: "易縣" },
            { label: "曲陽縣", value: "曲陽縣" },
            { label: "蠡縣", value: "蠡縣" },
            { label: "順平縣", value: "順平縣" },
            { label: "博野縣", value: "博野縣" },
            { label: "雄縣", value: "雄縣" },
            { label: "新市區", value: "新市區" },
            { label: "北市區", value: "北市區" },
            { label: "南市區", value: "南市區" },
            { label: "安新縣", value: "安新縣" },
            { label: "涿州市", value: "涿州市" },
            { label: "定州市", value: "定州市" },
            { label: "徐水縣", value: "徐水縣" },
            { label: "高碑店市", value: "高碑店市" }
          ]
        },
        {
          label: "張家口市",
          value: "張家口市",
          children: [
            { label: "宣化縣", value: "宣化縣" },
            { label: "康保縣", value: "康保縣" },
            { label: "張北縣", value: "張北縣" },
            { label: "陽原縣", value: "陽原縣" },
            { label: "赤城縣", value: "赤城縣" },
            { label: "懷安縣", value: "懷安縣" },
            { label: "懷來縣", value: "懷來縣" },
            { label: "崇禮縣", value: "崇禮縣" },
            { label: "尚義縣", value: "尚義縣" },
            { label: "蔚縣", value: "蔚縣" },
            { label: "涿鹿縣", value: "涿鹿縣" },
            { label: "萬全縣", value: "萬全縣" },
            { label: "下花園區", value: "下花園區" },
            { label: "沽源縣", value: "沽源縣" },
            { label: "宣化區", value: "宣化區" },
            { label: "橋西區", value: "橋西區" },
            { label: "橋東區", value: "橋東區" }
          ]
        },
        {
          label: "承德市",
          value: "承德市",
          children: [
            { label: "興隆縣", value: "興隆縣" },
            { label: "平泉縣", value: "平泉縣" },
            { label: "灤平縣", value: "灤平縣" },
            { label: "豐寧縣", value: "豐寧縣" },
            { label: "圍場縣", value: "圍場縣" },
            { label: "寬城縣", value: "寬城縣" },
            { label: "隆化縣", value: "隆化縣" },
            { label: "承德縣", value: "承德縣" },
            { label: "雙灤區", value: "雙灤區" },
            { label: "鷹手營子礦區", value: "鷹手營子礦區" },
            { label: "雙橋區", value: "雙橋區" }
          ]
        },
        {
          label: "秦皇島市",
          value: "秦皇島市",
          children: [
            { label: "盧龍縣", value: "盧龍縣" },
            { label: "青龍縣", value: "青龍縣" },
            { label: "昌黎縣", value: "昌黎縣" },
            { label: "北戴河區", value: "北戴河區" },
            { label: "撫寧縣", value: "撫寧縣" },
            { label: "海港區", value: "海港區" },
            { label: "山海關區", value: "山海關區" }
          ]
        },
        {
          label: "唐山市",
          value: "唐山市",
          children: [
            { label: "遵化市", value: "遵化市" },
            { label: "丰南區", value: "丰南區" },
            { label: "遷西縣", value: "遷西縣" },
            { label: "灤南縣", value: "灤南縣" },
            { label: "玉田縣", value: "玉田縣" },
            { label: "曹妃甸區", value: "曹妃甸區" },
            { label: "樂亭縣", value: "樂亭縣" },
            { label: "灤縣", value: "灤縣" },
            { label: "古冶區", value: "古冶區" },
            { label: "開平區", value: "開平區" },
            { label: "路北區", value: "路北區" },
            { label: "路南區", value: "路南區" },
            { label: "遷安市", value: "遷安市" },
            { label: "豐潤區", value: "豐潤區" }
          ]
        },
        {
          label: "滄州市",
          value: "滄州市",
          children: [
            { label: "滄縣", value: "滄縣" },
            { label: "泊頭市", value: "泊頭市" },
            { label: "河間市", value: "河間市" },
            { label: "獻縣", value: "獻縣" },
            { label: "肅寧縣", value: "肅寧縣" },
            { label: "青縣", value: "青縣" },
            { label: "東光縣", value: "東光縣" },
            { label: "吳橋縣", value: "吳橋縣" },
            { label: "南皮縣", value: "南皮縣" },
            { label: "鹽山縣", value: "鹽山縣" },
            { label: "海興縣", value: "海興縣" },
            { label: "孟村縣", value: "孟村縣" },
            { label: "運河區", value: "運河區" },
            { label: "新華區", value: "新華區" },
            { label: "任丘市", value: "任丘市" },
            { label: "黃驊市", value: "黃驊市" }
          ]
        },
        {
          label: "廊坊市",
          value: "廊坊市",
          children: [
            { label: "固安縣", value: "固安縣" },
            { label: "永清縣", value: "永清縣" },
            { label: "香河縣", value: "香河縣" },
            { label: "大城縣", value: "大城縣" },
            { label: "文安縣", value: "文安縣" },
            { label: "大廠縣", value: "大廠縣" },
            { label: "安次區", value: "安次區" },
            { label: "廣陽區", value: "廣陽區" },
            { label: "開發區", value: "開發區" },
            { label: "三河市", value: "三河市" },
            { label: "霸州市", value: "霸州市" }
          ]
        },
        {
          label: "衡水市",
          value: "衡水市",
          children: [
            { label: "冀州市", value: "冀州市" },
            { label: "深州市", value: "深州市" },
            { label: "饒陽縣", value: "饒陽縣" },
            { label: "棗強縣", value: "棗強縣" },
            { label: "故城縣", value: "故城縣" },
            { label: "阜城縣", value: "阜城縣" },
            { label: "安平縣", value: "安平縣" },
            { label: "武邑縣", value: "武邑縣" },
            { label: "景縣", value: "景縣" },
            { label: "武強縣", value: "武強縣" },
            { label: "桃城區", value: "桃城區" }
          ]
        }
      ]
    },
    {
      label: "山西",
      value: "山西",
      children: [
        {
          label: "太原市",
          value: "太原市",
          children: [
            { label: "陽曲縣", value: "陽曲縣" },
            { label: "古交市", value: "古交市" },
            { label: "婁煩縣", value: "婁煩縣" },
            { label: "清徐縣", value: "清徐縣" },
            { label: "小店區", value: "小店區" },
            { label: "迎澤區", value: "迎澤區" },
            { label: "晉源區", value: "晉源區" },
            { label: "萬柏林區", value: "萬柏林區" },
            { label: "尖草坪區", value: "尖草坪區" },
            { label: "杏花嶺區", value: "杏花嶺區" }
          ]
        },
        {
          label: "大同市",
          value: "大同市",
          children: [
            { label: "大同縣", value: "大同縣" },
            { label: "天鎮縣", value: "天鎮縣" },
            { label: "靈丘縣", value: "靈丘縣" },
            { label: "陽高縣", value: "陽高縣" },
            { label: "左雲縣", value: "左雲縣" },
            { label: "渾源縣", value: "渾源縣" },
            { label: "廣靈縣", value: "廣靈縣" },
            { label: "新榮區", value: "新榮區" },
            { label: "南郊區", value: "南郊區" },
            { label: "礦區", value: "礦區" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "陽泉市",
          value: "陽泉市",
          children: [
            { label: "盂縣", value: "盂縣" },
            { label: "平定縣", value: "平定縣" },
            { label: "郊區", value: "郊區" },
            { label: "礦區", value: "礦區" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "晉城市",
          value: "晉城市",
          children: [
            { label: "高平市", value: "高平市" },
            { label: "陽城縣", value: "陽城縣" },
            { label: "沁水縣", value: "沁水縣" },
            { label: "陵川縣", value: "陵川縣" },
            { label: "澤州縣", value: "澤州縣" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "朔州市",
          value: "朔州市",
          children: [
            { label: "山陰縣", value: "山陰縣" },
            { label: "右玉縣", value: "右玉縣" },
            { label: "應縣", value: "應縣" },
            { label: "懷仁縣", value: "懷仁縣" },
            { label: "朔城區", value: "朔城區" },
            { label: "平魯區", value: "平魯區" }
          ]
        },
        {
          label: "晉中市",
          value: "晉中市",
          children: [
            { label: "介休市", value: "介休市" },
            { label: "昔陽縣", value: "昔陽縣" },
            { label: "祁縣", value: "祁縣" },
            { label: "左權縣", value: "左權縣" },
            { label: "壽陽縣", value: "壽陽縣" },
            { label: "太谷縣", value: "太谷縣" },
            { label: "和順縣", value: "和順縣" },
            { label: "靈石縣", value: "靈石縣" },
            { label: "平遙縣", value: "平遙縣" },
            { label: "榆社縣", value: "榆社縣" },
            { label: "榆次區", value: "榆次區" }
          ]
        },
        {
          label: "忻州市",
          value: "忻州市",
          children: [
            { label: "原平市", value: "原平市" },
            { label: "代縣", value: "代縣" },
            { label: "神池縣", value: "神池縣" },
            { label: "五寨縣", value: "五寨縣" },
            { label: "五台縣", value: "五台縣" },
            { label: "偏關縣", value: "偏關縣" },
            { label: "寧武縣", value: "寧武縣" },
            { label: "靜樂縣", value: "靜樂縣" },
            { label: "繁峙縣", value: "繁峙縣" },
            { label: "河曲縣", value: "河曲縣" },
            { label: "保德縣", value: "保德縣" },
            { label: "定襄縣", value: "定襄縣" },
            { label: "忻府區", value: "忻府區" },
            { label: "岢嵐縣", value: "岢嵐縣" }
          ]
        },
        {
          label: "呂梁市",
          value: "呂梁市",
          children: [
            { label: "離石區", value: "離石區" },
            { label: "孝義市", value: "孝義市" },
            { label: "汾陽市", value: "汾陽市" },
            { label: "文水縣", value: "文水縣" },
            { label: "中陽縣", value: "中陽縣" },
            { label: "興縣", value: "興縣" },
            { label: "臨縣", value: "臨縣" },
            { label: "方山縣", value: "方山縣" },
            { label: "柳林縣", value: "柳林縣" },
            { label: "嵐縣", value: "嵐縣" },
            { label: "交口縣", value: "交口縣" },
            { label: "交城縣", value: "交城縣" },
            { label: "石樓縣", value: "石樓縣" }
          ]
        },
        {
          label: "臨汾市",
          value: "臨汾市",
          children: [
            { label: "侯馬市", value: "侯馬市" },
            { label: "霍州市", value: "霍州市" },
            { label: "汾西縣", value: "汾西縣" },
            { label: "吉縣", value: "吉縣" },
            { label: "安澤縣", value: "安澤縣" },
            { label: "浮山縣", value: "浮山縣" },
            { label: "大寧縣", value: "大寧縣" },
            { label: "古縣", value: "古縣" },
            { label: "隰縣", value: "隰縣" },
            { label: "襄汾縣", value: "襄汾縣" },
            { label: "翼城縣", value: "翼城縣" },
            { label: "永和縣", value: "永和縣" },
            { label: "鄉寧縣", value: "鄉寧縣" },
            { label: "洪洞縣", value: "洪洞縣" },
            { label: "蒲縣", value: "蒲縣" },
            { label: "曲沃縣", value: "曲沃縣" },
            { label: "堯都區", value: "堯都區" }
          ]
        },
        {
          label: "運城市",
          value: "運城市",
          children: [
            { label: "永濟市", value: "永濟市" },
            { label: "新絳縣", value: "新絳縣" },
            { label: "平陸縣", value: "平陸縣" },
            { label: "垣曲縣", value: "垣曲縣" },
            { label: "絳縣", value: "絳縣" },
            { label: "稷山縣", value: "稷山縣" },
            { label: "芮城縣", value: "芮城縣" },
            { label: "夏縣", value: "夏縣" },
            { label: "臨猗縣", value: "臨猗縣" },
            { label: "萬榮縣", value: "萬榮縣" },
            { label: "聞喜縣", value: "聞喜縣" },
            { label: "鹽湖區", value: "鹽湖區" }
          ]
        },
        {
          label: "長治市",
          value: "長治市",
          children: [
            { label: "長治縣", value: "長治縣" },
            { label: "潞城市", value: "潞城市" },
            { label: "郊區", value: "郊區" },
            { label: "襄垣縣", value: "襄垣縣" },
            { label: "屯留縣", value: "屯留縣" },
            { label: "平順縣", value: "平順縣" },
            { label: "黎城縣", value: "黎城縣" },
            { label: "壺關縣", value: "壺關縣" },
            { label: "長子縣", value: "長子縣" },
            { label: "武鄉縣", value: "武鄉縣" },
            { label: "沁縣", value: "沁縣" },
            { label: "沁源縣", value: "沁源縣" }
          ]
        }
      ]
    },
    {
      label: "河南",
      value: "河南",
      children: [
        {
          label: "鄭州市",
          value: "鄭州市",
          children: [
            { label: "新密市", value: "新密市" },
            { label: "登封市", value: "登封市" },
            { label: "上街區", value: "上街區" },
            { label: "惠濟區", value: "惠濟區" },
            { label: "金水區", value: "金水區" },
            { label: "管城區", value: "管城區" },
            { label: "二七區", value: "二七區" },
            { label: "中原區", value: "中原區" },
            { label: "鄭東新區", value: "鄭東新區" },
            { label: "新鄭市", value: "新鄭市" },
            { label: "鞏義市", value: "鞏義市" },
            { label: "滎陽市", value: "滎陽市" },
            { label: "中牟縣", value: "中牟縣" },
            { label: "經濟開發區", value: "經濟開發區" },
            { label: "高新技術開發區", value: "高新技術開發區" }
          ]
        },
        {
          label: "開封市",
          value: "開封市",
          children: [
            { label: "開封縣", value: "開封縣" },
            { label: "杞縣", value: "杞縣" },
            { label: "蘭考縣", value: "蘭考縣" },
            { label: "尉氏縣", value: "尉氏縣" },
            { label: "通許縣", value: "通許縣" },
            { label: "金明區", value: "金明區" },
            { label: "龍亭區", value: "龍亭區" },
            { label: "順河區", value: "順河區" },
            { label: "鼓樓區", value: "鼓樓區" },
            { label: "禹王台區", value: "禹王台區" }
          ]
        },
        {
          label: "洛陽市",
          value: "洛陽市",
          children: [
            { label: "偃師市", value: "偃師市" },
            { label: "孟津縣", value: "孟津縣" },
            { label: "汝陽縣", value: "汝陽縣" },
            { label: "伊川縣", value: "伊川縣" },
            { label: "洛寧縣", value: "洛寧縣" },
            { label: "宜陽縣", value: "宜陽縣" },
            { label: "欒川縣", value: "欒川縣" },
            { label: "新安縣", value: "新安縣" },
            { label: "吉利區", value: "吉利區" },
            { label: "澗西區", value: "澗西區" },
            { label: "瀍河區", value: "瀍河區" },
            { label: "老城區", value: "老城區" },
            { label: "西工區", value: "西工區" },
            { label: "嵩縣", value: "嵩縣" },
            { label: "伊濱區", value: "伊濱區" },
            { label: "洛龍區", value: "洛龍區" }
          ]
        },
        {
          label: "平頂山市",
          value: "平頂山市",
          children: [
            { label: "汝州市", value: "汝州市" },
            { label: "舞鋼市", value: "舞鋼市" },
            { label: "郟縣", value: "郟縣" },
            { label: "葉縣", value: "葉縣" },
            { label: "魯山縣", value: "魯山縣" },
            { label: "寶豐縣", value: "寶豐縣" },
            { label: "石龍區", value: "石龍區" },
            { label: "湛河區", value: "湛河區" },
            { label: "衛東區", value: "衛東區" },
            { label: "新華區", value: "新華區" }
          ]
        },
        {
          label: "焦作市",
          value: "焦作市",
          children: [
            { label: "沁陽市", value: "沁陽市" },
            { label: "孟州市", value: "孟州市" },
            { label: "修武縣", value: "修武縣" },
            { label: "溫縣", value: "溫縣" },
            { label: "武陟縣", value: "武陟縣" },
            { label: "博愛縣", value: "博愛縣" },
            { label: "山陽區", value: "山陽區" },
            { label: "馬村區", value: "馬村區" },
            { label: "中站區", value: "中站區" }
          ]
        },
        {
          label: "鶴壁市",
          value: "鶴壁市",
          children: [
            { label: "浚縣", value: "浚縣" },
            { label: "淇縣", value: "淇縣" },
            { label: "鶴山區", value: "鶴山區" },
            { label: "山城區", value: "山城區" },
            { label: "淇濱區", value: "淇濱區" }
          ]
        },
        {
          label: "新鄉市",
          value: "新鄉市",
          children: [
            { label: "衛輝市", value: "衛輝市" },
            { label: "輝縣市", value: "輝縣市" },
            { label: "新鄉縣", value: "新鄉縣" },
            { label: "獲嘉縣", value: "獲嘉縣" },
            { label: "原陽縣", value: "原陽縣" },
            { label: "長垣縣", value: "長垣縣" },
            { label: "延津縣", value: "延津縣" },
            { label: "封丘縣", value: "封丘縣" },
            { label: "鳳泉區", value: "鳳泉區" },
            { label: "牧野區", value: "牧野區" },
            { label: "紅旗區", value: "紅旗區" }
          ]
        },
        {
          label: "安陽市",
          value: "安陽市",
          children: [
            { label: "林州市", value: "林州市" },
            { label: "安陽縣", value: "安陽縣" },
            { label: "滑縣", value: "滑縣" },
            { label: "湯陰縣", value: "湯陰縣" },
            { label: "內黃縣", value: "內黃縣" },
            { label: "龍安區", value: "龍安區" },
            { label: "殷都區", value: "殷都區" },
            { label: "文峰區", value: "文峰區" },
            { label: "開發區", value: "開發區" },
            { label: "北關區", value: "北關區" }
          ]
        },
        {
          label: "濮陽市",
          value: "濮陽市",
          children: [
            { label: "濮陽縣", value: "濮陽縣" },
            { label: "南樂縣", value: "南樂縣" },
            { label: "台前縣", value: "台前縣" },
            { label: "清豐縣", value: "清豐縣" },
            { label: "范縣", value: "范縣" },
            { label: "華龍區", value: "華龍區" }
          ]
        },
        {
          label: "許昌市",
          value: "許昌市",
          children: [
            { label: "禹州市", value: "禹州市" },
            { label: "長葛市", value: "長葛市" },
            { label: "許昌縣", value: "許昌縣" },
            { label: "鄢陵縣", value: "鄢陵縣" },
            { label: "襄城縣", value: "襄城縣" },
            { label: "魏都區", value: "魏都區" }
          ]
        },
        {
          label: "漯河市",
          value: "漯河市",
          children: [
            { label: "郾城區", value: "郾城區" },
            { label: "臨潁縣", value: "臨潁縣" },
            { label: "召陵區", value: "召陵區" },
            { label: "舞陽縣", value: "舞陽縣" },
            { label: "源匯區", value: "源匯區" }
          ]
        },
        {
          label: "三門峽市",
          value: "三門峽市",
          children: [
            {
              label: "義馬市",
              value: "義馬市",
              children: [{ label: "城區", value: "52573" }]
            },
            { label: "靈寶市", value: "靈寶市" },
            { label: "陝縣", value: "陝縣" },
            { label: "盧氏縣", value: "盧氏縣" },
            { label: "澠池縣", value: "澠池縣" },
            { label: "湖濱區", value: "湖濱區" }
          ]
        },
        {
          label: "南陽市",
          value: "南陽市",
          children: [
            { label: "鄧州市", value: "鄧州市" },
            { label: "桐柏縣", value: "桐柏縣" },
            { label: "方城縣", value: "方城縣" },
            { label: "淅川縣", value: "淅川縣" },
            { label: "鎮平縣", value: "鎮平縣" },
            { label: "唐河縣", value: "唐河縣" },
            { label: "南召縣", value: "南召縣" },
            { label: "內鄉縣", value: "內鄉縣" },
            { label: "新野縣", value: "新野縣" },
            { label: "社旗縣", value: "社旗縣" },
            { label: "西峽縣", value: "西峽縣" },
            { label: "卧龍區", value: "卧龍區" },
            { label: "宛城區", value: "宛城區" }
          ]
        },
        {
          label: "商丘市",
          value: "商丘市",
          children: [
            { label: "永城市", value: "永城市" },
            { label: "寧陵縣", value: "寧陵縣" },
            { label: "虞城縣", value: "虞城縣" },
            { label: "民權縣", value: "民權縣" },
            { label: "夏邑縣", value: "夏邑縣" },
            { label: "柘城縣", value: "柘城縣" },
            { label: "睢縣", value: "睢縣" },
            { label: "睢陽區", value: "睢陽區" },
            { label: "梁園區", value: "梁園區" }
          ]
        },
        {
          label: "周口市",
          value: "周口市",
          children: [
            { label: "項城市", value: "項城市" },
            { label: "商水縣", value: "商水縣" },
            { label: "淮陽縣", value: "淮陽縣" },
            { label: "太康縣", value: "太康縣" },
            { label: "鹿邑縣", value: "鹿邑縣" },
            { label: "西華縣", value: "西華縣" },
            { label: "扶溝縣", value: "扶溝縣" },
            { label: "沈丘縣", value: "沈丘縣" },
            { label: "鄲城縣", value: "鄲城縣" },
            { label: "東新區", value: "東新區" },
            { label: "經濟開發區", value: "經濟開發區" },
            { label: "川匯區", value: "川匯區" }
          ]
        },
        {
          label: "駐馬店市",
          value: "駐馬店市",
          children: [
            { label: "確山縣", value: "確山縣" },
            { label: "新蔡縣", value: "新蔡縣" },
            { label: "上蔡縣", value: "上蔡縣" },
            { label: "泌陽縣", value: "泌陽縣" },
            { label: "西平縣", value: "西平縣" },
            { label: "遂平縣", value: "遂平縣" },
            { label: "汝南縣", value: "汝南縣" },
            { label: "平輿縣", value: "平輿縣" },
            { label: "正陽縣", value: "正陽縣" },
            { label: "驛城區", value: "驛城區" }
          ]
        },
        {
          label: "信陽市",
          value: "信陽市",
          children: [
            { label: "潢川縣", value: "潢川縣" },
            { label: "淮濱縣", value: "淮濱縣" },
            { label: "息縣", value: "息縣" },
            { label: "新縣", value: "新縣" },
            { label: "固始縣", value: "固始縣" },
            { label: "羅山縣", value: "羅山縣" },
            { label: "光山縣", value: "光山縣" },
            { label: "商城縣", value: "商城縣" },
            { label: "平橋區", value: "平橋區" },
            { label: "浉河區", value: "浉河區" }
          ]
        },
        {
          label: "濟源市",
          value: "濟源市",
          children: [
            { label: "五龍口鎮", value: "五龍口鎮" },
            { label: "下冶鎮", value: "下冶鎮" },
            { label: "軹城鎮", value: "軹城鎮" },
            { label: "王屋鎮", value: "王屋鎮" },
            { label: "思禮鎮", value: "思禮鎮" },
            { label: "邵原鎮", value: "邵原鎮" },
            { label: "坡頭鎮", value: "坡頭鎮" },
            { label: "梨林鎮", value: "梨林鎮" },
            { label: "克井鎮", value: "克井鎮" },
            { label: "大峪鎮", value: "大峪鎮" },
            { label: "承留鎮", value: "承留鎮" },
            { label: "城區", value: "城區" }
          ]
        }
      ]
    },
    {
      label: "遼寧",
      value: "遼寧",
      children: [
        {
          label: "瀋陽市",
          value: "瀋陽市",
          children: [
            { label: "蘇家屯區", value: "蘇家屯區" },
            { label: "新民市", value: "新民市" },
            { label: "法庫縣", value: "法庫縣" },
            { label: "遼中縣", value: "遼中縣" },
            { label: "康平縣", value: "康平縣" },
            { label: "皇姑區", value: "皇姑區" },
            { label: "鐵西區", value: "鐵西區" },
            { label: "大東區", value: "大東區" },
            { label: "瀋河區", value: "瀋河區" },
            { label: "東陵區", value: "東陵區" },
            { label: "于洪區", value: "于洪區" },
            { label: "和平區", value: "和平區" },
            { label: "渾南新區", value: "渾南新區" },
            { label: "沈北新區", value: "沈北新區" }
          ]
        },
        {
          label: "大連市",
          value: "大連市",
          children: [
            { label: "普蘭店市", value: "普蘭店市" },
            { label: "瓦房店市", value: "瓦房店市" },
            { label: "庄河市", value: "庄河市" },
            { label: "長海縣", value: "長海縣" },
            { label: "沙河口區", value: "沙河口區" },
            { label: "西崗區", value: "西崗區" },
            { label: "中山區", value: "中山區" },
            { label: "甘井子區", value: "甘井子區" },
            { label: "高新園區", value: "高新園區" },
            { label: "大連開發區", value: "大連開發區" },
            { label: "金州區", value: "金州區" },
            { label: "旅順口區", value: "旅順口區" }
          ]
        },
        {
          label: "鞍山市",
          value: "鞍山市",
          children: [
            { label: "台安縣", value: "台安縣" },
            { label: "海城市", value: "海城市" },
            { label: "岫岩縣", value: "岫岩縣" },
            { label: "鐵東區", value: "鐵東區" },
            { label: "立山區", value: "立山區" },
            { label: "鐵西區", value: "鐵西區" },
            { label: "千山區", value: "千山區" }
          ]
        },
        {
          label: "撫順市",
          value: "撫順市",
          children: [
            { label: "撫順縣", value: "撫順縣" },
            { label: "新賓縣", value: "新賓縣" },
            { label: "清原縣", value: "清原縣" },
            { label: "望花區", value: "望花區" },
            { label: "東洲區", value: "東洲區" },
            { label: "新撫區", value: "新撫區" },
            { label: "順城區", value: "順城區" }
          ]
        },
        {
          label: "本溪市",
          value: "本溪市",
          children: [
            { label: "桓仁縣", value: "桓仁縣" },
            { label: "南芬區", value: "南芬區" },
            { label: "本溪縣", value: "本溪縣" },
            { label: "平山區", value: "平山區" },
            { label: "溪湖區", value: "溪湖區" },
            { label: "明山區", value: "明山區" }
          ]
        },
        {
          label: "丹東市",
          value: "丹東市",
          children: [
            { label: "寬甸縣", value: "寬甸縣" },
            { label: "元寶區", value: "元寶區" },
            { label: "振興區", value: "振興區" },
            { label: "振安區", value: "振安區" },
            { label: "東港市", value: "東港市" },
            { label: "鳳城市", value: "鳳城市" }
          ]
        },
        {
          label: "錦州市",
          value: "錦州市",
          children: [
            { label: "義縣", value: "義縣" },
            { label: "凌海市", value: "凌海市" },
            { label: "北鎮市", value: "北鎮市" },
            { label: "黑山縣", value: "黑山縣" },
            { label: "古塔區", value: "古塔區" },
            { label: "凌河區", value: "凌河區" },
            { label: "太和區", value: "太和區" },
            { label: "經濟技術開發區", value: "經濟技術開發區" }
          ]
        },
        {
          label: "葫蘆島市",
          value: "葫蘆島市",
          children: [
            { label: "綏中縣", value: "綏中縣" },
            { label: "建昌縣", value: "建昌縣" },
            { label: "南票區", value: "南票區" },
            { label: "龍港區", value: "龍港區" },
            { label: "連山區", value: "連山區" },
            { label: "興城市", value: "興城市" }
          ]
        },
        {
          label: "營口市",
          value: "營口市",
          children: [
            { label: "大石橋市", value: "大石橋市" },
            { label: "蓋州市", value: "蓋州市" },
            { label: "老邊區", value: "老邊區" },
            {
              label: "西市區",
              value: "西市區",
              children: [
                { label: "高新技術產業區", value: "20288" },
                { label: "城區", value: "52461" }
              ]
            },
            { label: "站前區", value: "站前區" },
            { label: "鮁魚圈區", value: "鮁魚圈區" }
          ]
        },
        {
          label: "盤錦市",
          value: "盤錦市",
          children: [
            { label: "盤山縣", value: "盤山縣" },
            { label: "大窪縣", value: "大窪縣" },
            { label: "興隆台區", value: "興隆台區" },
            {
              label: "阜新市",
              value: "阜新市",
              children: [
                { label: "阜新縣", value: "618" },
                { label: "彰武縣", value: "619" },
                { label: "清河門區", value: "3286" },
                { label: "新邱區", value: "3288" },
                { label: "海州區", value: "20658" },
                { label: "太平區", value: "20659" },
                { label: "細河區", value: "20660" }
              ]
            },
            {
              label: "遼陽市",
              value: "遼陽市",
              children: [
                { label: "遼陽縣", value: "623" },
                { label: "太子河區", value: "3290" },
                { label: "弓長嶺區", value: "3291" },
                { label: "宏偉區", value: "3292" },
                { label: "白塔區", value: "43963" },
                { label: "文聖區", value: "43964" },
                { label: "燈塔市", value: "43965" }
              ]
            },
            {
              label: "朝陽市",
              value: "朝陽市",
              children: [
                { label: "凌源市", value: "633" },
                { label: "北票市", value: "634" },
                { label: "喀喇沁左翼縣", value: "635" },
                { label: "朝陽縣", value: "636" },
                { label: "建平縣", value: "637" },
                { label: "龍城區", value: "3299" },
                { label: "雙塔區", value: "20348" }
              ]
            },
            { label: "鐵嶺市", value: "鐵嶺市" },
            { label: "清河區", value: "清河區" },
            { label: "開原市", value: "開原市" },
            { label: "鐵嶺縣", value: "鐵嶺縣" },
            { label: "西豐縣", value: "西豐縣" },
            { label: "昌圖縣", value: "昌圖縣" },
            { label: "調兵山市", value: "調兵山市" }
          ]
        }
      ]
    },
    {
      label: "吉林",
      value: "吉林",
      children: [
        {
          label: "長春市",
          value: "長春市",
          children: [
            { label: "榆樹市", value: "榆樹市" },
            { label: "九台市", value: "九台市" },
            { label: "農安縣", value: "農安縣" },
            { label: "德惠市", value: "德惠市" },
            { label: "雙陽區", value: "雙陽區" },
            { label: "朝陽區", value: "朝陽區" },
            { label: "南關區", value: "南關區" },
            { label: "寬城區", value: "寬城區" },
            { label: "二道區", value: "二道區" },
            { label: "綠園區", value: "綠園區" },
            { label: "凈月區", value: "凈月區" },
            { label: "汽車產業開發區", value: "汽車產業開發區" },
            { label: "高新技術開發區", value: "高新技術開發區" },
            { label: "經濟技術開發區", value: "經濟技術開發區" }
          ]
        },
        {
          label: "吉林市",
          value: "吉林市",
          children: [
            { label: "舒蘭市", value: "舒蘭市" },
            { label: "樺甸市", value: "樺甸市" },
            { label: "蛟河市", value: "蛟河市" },
            { label: "磐石市", value: "磐石市" },
            { label: "永吉縣", value: "永吉縣" },
            { label: "昌邑區", value: "昌邑區" },
            { label: "龍潭區", value: "龍潭區" },
            { label: "船營區", value: "船營區" },
            { label: "豐滿區", value: "豐滿區" }
          ]
        },
        {
          label: "四平市",
          value: "四平市",
          children: [
            { label: "公主嶺市", value: "公主嶺市" },
            { label: "雙遼市", value: "雙遼市" },
            { label: "梨樹縣", value: "梨樹縣" },
            { label: "伊通縣", value: "伊通縣" },
            { label: "鐵東區", value: "鐵東區" },
            { label: "鐵西區", value: "鐵西區" }
          ]
        },
        {
          label: "通化市",
          value: "通化市",
          children: [
            { label: "梅河口市", value: "梅河口市" },
            { label: "集安市", value: "集安市" },
            { label: "通化縣", value: "通化縣" },
            { label: "輝南縣", value: "輝南縣" },
            { label: "柳河縣", value: "柳河縣" },
            { label: "二道江區", value: "二道江區" },
            { label: "東昌區", value: "東昌區" }
          ]
        },
        {
          label: "白山市",
          value: "白山市",
          children: [
            { label: "臨江市", value: "臨江市" },
            { label: "江源區", value: "江源區" },
            { label: "靖宇縣", value: "靖宇縣" },
            { label: "撫松縣", value: "撫松縣" },
            { label: "長白縣", value: "長白縣" },
            { label: "渾江區", value: "渾江區" }
          ]
        },
        {
          label: "松原市",
          value: "松原市",
          children: [
            { label: "乾安縣", value: "乾安縣" },
            { label: "長嶺縣", value: "長嶺縣" },
            { label: "扶余縣", value: "扶余縣" },
            { label: "寧江區", value: "寧江區" },
            { label: "前郭縣", value: "前郭縣" }
          ]
        },
        {
          label: "白城市",
          value: "白城市",
          children: [
            { label: "大安市", value: "大安市" },
            { label: "洮南市", value: "洮南市" },
            { label: "通榆縣", value: "通榆縣" },
            { label: "鎮賚縣", value: "鎮賚縣" },
            { label: "洮北區", value: "洮北區" }
          ]
        },
        {
          label: "延邊州",
          value: "延邊州",
          children: [
            { label: "圖們市", value: "圖們市" },
            { label: "敦化市", value: "敦化市" },
            { label: "琿春市", value: "琿春市" },
            { label: "龍井市", value: "龍井市" },
            { label: "和龍市", value: "和龍市" },
            { label: "汪清縣", value: "汪清縣" },
            { label: "安圖縣", value: "安圖縣" },
            { label: "延吉市", value: "延吉市" }
          ]
        },
        {
          label: "遼源市",
          value: "遼源市",
          children: [
            { label: "龍山區", value: "龍山區" },
            { label: "西安區", value: "西安區" },
            { label: "東豐縣", value: "東豐縣" },
            { label: "東遼縣", value: "東遼縣" }
          ]
        }
      ]
    },
    {
      label: "黑龍江",
      value: "黑龍江",
      children: [
        {
          label: "哈爾濱市",
          value: "哈爾濱市",
          children: [
            { label: "阿城區", value: "阿城區" },
            { label: "尚志市", value: "尚志市" },
            { label: "雙城市", value: "雙城市" },
            { label: "五常市", value: "五常市" },
            { label: "方正縣", value: "方正縣" },
            { label: "賓縣", value: "賓縣" },
            { label: "依蘭縣", value: "依蘭縣" },
            { label: "巴彥縣", value: "巴彥縣" },
            { label: "通河縣", value: "通河縣" },
            { label: "木蘭縣", value: "木蘭縣" },
            { label: "延壽縣", value: "延壽縣" },
            { label: "呼蘭區", value: "呼蘭區" },
            { label: "松北區", value: "松北區" },
            { label: "道里區", value: "道里區" },
            { label: "南崗區", value: "南崗區" },
            { label: "道外區", value: "道外區" },
            { label: "香坊區", value: "香坊區" },
            { label: "平房區", value: "平房區" }
          ]
        },
        {
          label: "齊齊哈爾市",
          value: "齊齊哈爾市",
          children: [
            { label: "梅里斯區", value: "梅里斯區" },
            { label: "昂昂溪區", value: "昂昂溪區" },
            { label: "富拉爾基區", value: "富拉爾基區" },
            { label: "碾子山區", value: "碾子山區" },
            { label: "訥河市", value: "訥河市" },
            { label: "富裕縣", value: "富裕縣" },
            { label: "拜泉縣", value: "拜泉縣" },
            { label: "甘南縣", value: "甘南縣" },
            { label: "依安縣", value: "依安縣" },
            { label: "克山縣", value: "克山縣" },
            { label: "龍江縣", value: "龍江縣" },
            { label: "克東縣", value: "克東縣" },
            { label: "泰來縣", value: "泰來縣" },
            { label: "建華區", value: "建華區" },
            { label: "龍沙區", value: "龍沙區" },
            { label: "鐵鋒區", value: "鐵鋒區" }
          ]
        },
        {
          label: "鶴崗市",
          value: "鶴崗市",
          children: [
            { label: "蘿北縣", value: "蘿北縣" },
            { label: "綏濱縣", value: "綏濱縣" },
            { label: "興山區", value: "興山區" },
            { label: "向陽區", value: "向陽區" },
            { label: "工農區", value: "工農區" },
            { label: "南山區", value: "南山區" },
            { label: "興安區", value: "興安區" },
            { label: "東山區", value: "東山區" }
          ]
        },
        {
          label: "雙鴨山市",
          value: "雙鴨山市",
          children: [
            { label: "集賢縣", value: "集賢縣" },
            { label: "寶清縣", value: "寶清縣" },
            { label: "友誼縣", value: "友誼縣" },
            { label: "饒河縣", value: "饒河縣" },
            { label: "尖山區", value: "尖山區" },
            { label: "嶺東區", value: "嶺東區" },
            { label: "四方台區", value: "四方台區" },
            { label: "寶山區", value: "寶山區" }
          ]
        },
        {
          label: "雞西市",
          value: "雞西市",
          children: [
            { label: "密山市", value: "密山市" },
            { label: "虎林市", value: "虎林市" },
            { label: "雞東縣", value: "雞東縣" },
            { label: "恆山區", value: "恆山區" },
            { label: "滴道區", value: "滴道區" },
            { label: "梨樹區", value: "梨樹區" },
            { label: "城子河區", value: "城子河區" },
            { label: "麻山區", value: "麻山區" },
            { label: "雞冠區", value: "雞冠區" }
          ]
        },
        {
          label: "大慶市",
          value: "大慶市",
          children: [
            { label: "薩爾圖區", value: "薩爾圖區" },
            { label: "龍鳳區", value: "龍鳳區" },
            { label: "讓胡路區", value: "讓胡路區" },
            { label: "紅崗區", value: "紅崗區" },
            { label: "大同區", value: "大同區" },
            { label: "林甸縣", value: "林甸縣" },
            { label: "肇州縣", value: "肇州縣" },
            { label: "肇源縣", value: "肇源縣" },
            { label: "杜爾伯特縣", value: "杜爾伯特縣" }
          ]
        },
        {
          label: "伊春市",
          value: "伊春市",
          children: [
            { label: "鐵力市", value: "鐵力市" },
            { label: "嘉蔭縣", value: "嘉蔭縣" },
            { label: "伊春區", value: "伊春區" },
            { label: "南岔區", value: "南岔區" },
            { label: "友好區", value: "友好區" },
            { label: "西林區", value: "西林區" },
            { label: "翠巒區", value: "翠巒區" },
            { label: "新青區", value: "新青區" },
            { label: "美溪區", value: "美溪區" },
            { label: "金山屯區", value: "金山屯區" },
            { label: "五營區", value: "五營區" },
            { label: "烏馬河區", value: "烏馬河區" },
            { label: "湯旺河區", value: "湯旺河區" },
            { label: "帶嶺區", value: "帶嶺區" },
            { label: "烏伊嶺區", value: "烏伊嶺區" },
            { label: "紅星區", value: "紅星區" },
            { label: "上甘嶺區", value: "上甘嶺區" }
          ]
        },
        {
          label: "牡丹江市",
          value: "牡丹江市",
          children: [
            { label: "海林市", value: "海林市" },
            { label: "寧安市", value: "寧安市" },
            { label: "穆棱市", value: "穆棱市" },
            { label: "林口縣", value: "林口縣" },
            { label: "東寧縣", value: "東寧縣" },
            { label: "愛民區", value: "愛民區" },
            { label: "東安區", value: "東安區" },
            { label: "陽明區", value: "陽明區" },
            { label: "西安區", value: "西安區" },
            { label: "綏芬河市", value: "綏芬河市" }
          ]
        },
        {
          label: "佳木斯市",
          value: "佳木斯市",
          children: [
            { label: "同江市", value: "同江市" },
            { label: "富錦市", value: "富錦市" },
            { label: "樺川縣", value: "樺川縣" },
            { label: "撫遠縣", value: "撫遠縣" },
            { label: "樺南縣", value: "樺南縣" },
            { label: "湯原縣", value: "湯原縣" },
            { label: "前進區", value: "前進區" },
            { label: "向陽區", value: "向陽區" },
            { label: "東風區", value: "東風區" },
            { label: "郊區", value: "郊區" }
          ]
        },
        {
          label: "七台河市",
          value: "七台河市",
          children: [
            { label: "勃利縣", value: "勃利縣" },
            { label: "桃山區", value: "桃山區" },
            { label: "新興區", value: "新興區" },
            { label: "茄子河區", value: "茄子河區" },
            { label: "金沙新區", value: "金沙新區" }
          ]
        },
        {
          label: "黑河市",
          value: "黑河市",
          children: [
            { label: "北安市", value: "北安市" },
            { label: "五大連池市", value: "五大連池市" },
            { label: "遜克縣", value: "遜克縣" },
            { label: "孫吳縣", value: "孫吳縣" },
            { label: "嫩江縣", value: "嫩江縣" },
            { label: "愛輝區", value: "愛輝區" }
          ]
        },
        {
          label: "綏化市",
          value: "綏化市",
          children: [
            { label: "安達市", value: "安達市" },
            { label: "肇東市", value: "肇東市" },
            { label: "海倫市", value: "海倫市" },
            { label: "綏棱縣", value: "綏棱縣" },
            { label: "蘭西縣", value: "蘭西縣" },
            { label: "明水縣", value: "明水縣" },
            { label: "青岡縣", value: "青岡縣" },
            { label: "慶安縣", value: "慶安縣" },
            { label: "望奎縣", value: "望奎縣" },
            { label: "北林區", value: "北林區" }
          ]
        },
        {
          label: "大興安嶺地區",
          value: "大興安嶺地區",
          children: [
            { label: "呼瑪縣", value: "呼瑪縣" },
            { label: "塔河縣", value: "塔河縣" },
            { label: "漠河縣", value: "漠河縣" },
            { label: "加格達奇區", value: "加格達奇區" },
            { label: "松嶺區", value: "松嶺區" },
            { label: "呼中區", value: "呼中區" },
            { label: "新林區", value: "新林區" }
          ]
        }
      ]
    },
    {
      label: "內蒙古",
      value: "內蒙古",
      children: [
        {
          label: "呼和浩特市",
          value: "呼和浩特市",
          children: [
            { label: "土默特左旗", value: "土默特左旗" },
            { label: "和林格爾縣", value: "和林格爾縣" },
            { label: "武川縣", value: "武川縣" },
            { label: "托克托縣", value: "托克托縣" },
            { label: "清水河縣", value: "清水河縣" },
            { label: "玉泉區", value: "玉泉區" },
            { label: "賽罕區", value: "賽罕區" },
            { label: "回民區", value: "回民區" },
            { label: "新城區", value: "新城區" }
          ]
        },
        {
          label: "包頭市",
          value: "包頭市",
          children: [
            { label: "固陽縣", value: "固陽縣" },
            { label: "土默特右旗", value: "土默特右旗" },
            { label: "達茂聯合旗", value: "達茂聯合旗" },
            { label: "石拐區", value: "石拐區" },
            { label: "白雲礦區", value: "白雲礦區" },
            { label: "東河區", value: "東河區" },
            { label: "九原區", value: "九原區" },
            { label: "青山區", value: "青山區" },
            { label: "昆都侖區", value: "昆都侖區" }
          ]
        },
        {
          label: "烏海市",
          value: "烏海市",
          children: [
            { label: "海勃灣區", value: "海勃灣區" },
            { label: "海南區", value: "海南區" },
            { label: "烏達區", value: "烏達區" }
          ]
        },
        {
          label: "赤峰市",
          value: "赤峰市",
          children: [
            { label: "寧城縣", value: "寧城縣" },
            { label: "敖漢旗", value: "敖漢旗" },
            { label: "喀喇沁旗", value: "喀喇沁旗" },
            { label: "翁牛特旗", value: "翁牛特旗" },
            { label: "巴林右旗", value: "巴林右旗" },
            { label: "林西縣", value: "林西縣" },
            { label: "克什克騰旗", value: "克什克騰旗" },
            { label: "巴林左旗", value: "巴林左旗" },
            { label: "阿魯科爾沁旗", value: "阿魯科爾沁旗" },
            { label: "元寶山區", value: "元寶山區" },
            { label: "松山區", value: "松山區" },
            { label: "紅山區", value: "紅山區" }
          ]
        },
        {
          label: "烏蘭察布市",
          value: "烏蘭察布市",
          children: [
            { label: "集寧區", value: "集寧區" },
            { label: "豐鎮市", value: "豐鎮市" },
            { label: "興和縣", value: "興和縣" },
            { label: "卓資縣", value: "卓資縣" },
            { label: "商都縣", value: "商都縣" },
            { label: "涼城縣", value: "涼城縣" },
            { label: "化德縣", value: "化德縣" },
            { label: "察哈爾右翼前旗", value: "察哈爾右翼前旗" },
            { label: "察哈爾右翼中旗", value: "察哈爾右翼中旗" },
            { label: "察哈爾右翼後旗", value: "察哈爾右翼後旗" },
            { label: "四子王旗", value: "四子王旗" }
          ]
        },
        {
          label: "錫林郭勒盟",
          value: "錫林郭勒盟",
          children: [
            { label: "錫林浩特市", value: "錫林浩特市" },
            { label: "二連浩特市", value: "二連浩特市" },
            { label: "多倫縣", value: "多倫縣" },
            { label: "阿巴嘎旗", value: "阿巴嘎旗" },
            { label: "西烏珠穆沁旗", value: "西烏珠穆沁旗" },
            { label: "東烏珠穆沁旗", value: "東烏珠穆沁旗" },
            { label: "蘇尼特右旗", value: "蘇尼特右旗" },
            { label: "蘇尼特左旗", value: "蘇尼特左旗" },
            { label: "太僕寺旗", value: "太僕寺旗" },
            { label: "正鑲白旗", value: "正鑲白旗" },
            { label: "正藍旗", value: "正藍旗" },
            { label: "鑲黃旗", value: "鑲黃旗" }
          ]
        },
        {
          label: "呼倫貝爾市",
          value: "呼倫貝爾市",
          children: [
            { label: "海拉爾區", value: "海拉爾區" },
            { label: "滿洲里市", value: "滿洲里市" },
            { label: "牙克石市", value: "牙克石市" },
            { label: "扎蘭屯市", value: "扎蘭屯市" },
            { label: "根河市", value: "根河市" },
            { label: "額爾古納市", value: "額爾古納市" },
            { label: "陳巴爾虎旗", value: "陳巴爾虎旗" },
            { label: "阿榮旗", value: "阿榮旗" },
            { label: "新巴爾虎左旗", value: "新巴爾虎左旗" },
            { label: "新巴爾虎右旗", value: "新巴爾虎右旗" },
            { label: "鄂倫春旗", value: "鄂倫春旗" },
            { label: "莫力達瓦旗", value: "莫力達瓦旗" },
            { label: "鄂溫克族旗", value: "鄂溫克族旗" }
          ]
        },
        {
          label: "鄂爾多斯市",
          value: "鄂爾多斯市",
          children: [
            { label: "東勝區", value: "東勝區" },
            { label: "准格爾旗", value: "准格爾旗" },
            { label: "伊金霍洛旗", value: "伊金霍洛旗" },
            { label: "烏審旗", value: "烏審旗" },
            { label: "杭錦旗", value: "杭錦旗" },
            { label: "鄂托克旗", value: "鄂托克旗" },
            { label: "鄂托克前旗", value: "鄂托克前旗" },
            { label: "達拉特旗", value: "達拉特旗" },
            { label: "康巴什新區", value: "康巴什新區" }
          ]
        },
        {
          label: "巴彥淖爾市",
          value: "巴彥淖爾市",
          children: [
            { label: "臨河區", value: "臨河區" },
            { label: "五原縣", value: "五原縣" },
            { label: "磴口縣", value: "磴口縣" },
            { label: "杭錦後旗", value: "杭錦後旗" },
            { label: "烏拉特中旗", value: "烏拉特中旗" },
            { label: "烏拉特後旗 ", value: "烏拉特後旗 " },
            { label: "烏拉特前旗", value: "烏拉特前旗" }
          ]
        },
        {
          label: "阿拉善盟",
          value: "阿拉善盟",
          children: [
            { label: "阿拉善右旗", value: "阿拉善右旗" },
            { label: "阿拉善左旗", value: "阿拉善左旗" },
            { label: "額濟納旗", value: "額濟納旗" }
          ]
        },
        {
          label: "興安盟",
          value: "興安盟",
          children: [
            { label: "烏蘭浩特市", value: "烏蘭浩特市" },
            { label: "阿爾山市", value: "阿爾山市" },
            { label: "突泉縣", value: "突泉縣" },
            { label: "扎賚特旗", value: "扎賚特旗" },
            { label: "科爾沁右翼前旗", value: "科爾沁右翼前旗" },
            { label: "科爾沁右翼中旗", value: "科爾沁右翼中旗" }
          ]
        },
        {
          label: "通遼市",
          value: "通遼市",
          children: [
            { label: "霍林郭勒市", value: "霍林郭勒市" },
            { label: "開魯縣", value: "開魯縣" },
            { label: "庫倫旗", value: "庫倫旗" },
            { label: "奈曼旗", value: "奈曼旗" },
            { label: "扎魯特旗", value: "扎魯特旗" },
            { label: "科爾沁左翼中旗", value: "科爾沁左翼中旗" },
            { label: "科爾沁左翼後旗", value: "科爾沁左翼後旗" },
            { label: "科爾沁區", value: "科爾沁區" }
          ]
        }
      ]
    },
    {
      label: "江蘇",
      value: "江蘇",
      children: [
        {
          label: "南京市",
          value: "南京市",
          children: [
            { label: "江寧區", value: "江寧區" },
            { label: "高淳區", value: "高淳區" },
            { label: "六合區", value: "六合區" },
            { label: "溧水區", value: "溧水區" },
            { label: "玄武區", value: "玄武區" },
            { label: "秦淮區", value: "秦淮區" },
            { label: "建鄴區", value: "建鄴區" },
            { label: "鼓樓區", value: "鼓樓區" },
            { label: "棲霞區", value: "棲霞區" },
            { label: "雨花台區", value: "雨花台區" },
            { label: "浦口區", value: "浦口區" }
          ]
        },
        {
          label: "徐州市",
          value: "徐州市",
          children: [
            { label: "銅山區", value: "銅山區" },
            { label: "睢寧縣", value: "睢寧縣" },
            { label: "沛縣", value: "沛縣" },
            { label: "豐縣", value: "豐縣" },
            { label: "賈汪區", value: "賈汪區" },
            { label: "金山橋開發區", value: "金山橋開發區" },
            { label: "銅山經濟技術開發區", value: "銅山經濟技術開發區" },
            { label: "八段工業園區", value: "八段工業園區" },
            { label: "鼓樓區", value: "鼓樓區" },
            { label: "邳州市", value: "邳州市" },
            { label: "泉山區", value: "泉山區" },
            { label: "新沂市", value: "新沂市" },
            { label: "雲龍區", value: "雲龍區" }
          ]
        },
        {
          label: "連雲港市",
          value: "連雲港市",
          children: [
            { label: "贛榆區", value: "贛榆區" },
            { label: "灌雲縣", value: "灌雲縣" },
            { label: "東海縣", value: "東海縣" },
            { label: "灌南縣", value: "灌南縣" },
            { label: "連雲區", value: "連雲區" },
            { label: "海州區", value: "海州區" }
          ]
        },
        {
          label: "淮安市",
          value: "淮安市",
          children: [
            { label: "楚州區", value: "楚州區" },
            { label: "洪澤縣", value: "洪澤縣" },
            { label: "金湖縣", value: "金湖縣" },
            { label: "盱眙縣", value: "盱眙縣" },
            { label: "經濟開發區", value: "經濟開發區" },
            { label: "清河區", value: "清河區" },
            { label: "淮陰區", value: "淮陰區" },
            { label: "清浦區", value: "清浦區" },
            { label: "漣水縣", value: "漣水縣" }
          ]
        },
        {
          label: "宿遷市",
          value: "宿遷市",
          children: [
            { label: "宿豫區", value: "宿豫區" },
            { label: "泗洪縣", value: "泗洪縣" },
            { label: "宿城區", value: "宿城區" },
            { label: "沭陽縣", value: "沭陽縣" },
            { label: "泗陽縣", value: "泗陽縣" },
            { label: "宿遷經濟開發區", value: "宿遷經濟開發區" }
          ]
        },
        {
          label: "鹽城市",
          value: "鹽城市",
          children: [
            { label: "東台市", value: "東台市" },
            { label: "大豐區", value: "大豐區" },
            { label: "建湖縣", value: "建湖縣" },
            { label: "響水縣", value: "響水縣" },
            { label: "阜寧縣", value: "阜寧縣" },
            { label: "濱海縣", value: "濱海縣" },
            { label: "射陽縣", value: "射陽縣" },
            { label: "亭湖區", value: "亭湖區" },
            { label: "鹽都區", value: "鹽都區" }
          ]
        },
        {
          label: "揚州市",
          value: "揚州市",
          children: [
            { label: "廣陵區", value: "廣陵區" },
            { label: "邗江區", value: "邗江區" },
            { label: "寶應縣", value: "寶應縣" },
            { label: "儀征市", value: "儀征市" },
            { label: "高郵市", value: "高郵市" },
            { label: "江都區", value: "江都區" }
          ]
        },
        {
          label: "泰州市",
          value: "泰州市",
          children: [
            { label: "泰興市", value: "泰興市" },
            { label: "靖江市", value: "靖江市" },
            { label: "興化市", value: "興化市" },
            { label: "高港區", value: "高港區" },
            { label: "海陵區", value: "海陵區" },
            { label: "姜堰區", value: "姜堰區" }
          ]
        },
        {
          label: "南通市",
          value: "南通市",
          children: [
            { label: "通州區", value: "通州區" },
            { label: "如東縣", value: "如東縣" },
            { label: "海安縣", value: "海安縣" },
            { label: "港閘區", value: "港閘區" },
            { label: "崇川區", value: "崇川區" },
            { label: "南通經濟技術開發區", value: "南通經濟技術開發區" },
            { label: "如皋市", value: "如皋市" },
            { label: "海門市", value: "海門市" },
            { label: "啟東市", value: "啟東市" }
          ]
        },
        {
          label: "鎮江市",
          value: "鎮江市",
          children: [
            { label: "揚中市", value: "揚中市" },
            { label: "丹徒區", value: "丹徒區" },
            { label: "潤州區", value: "潤州區" },
            { label: "京口區", value: "京口區" },
            { label: "鎮江新區", value: "鎮江新區" },
            { label: "丹陽市", value: "丹陽市" },
            { label: "句容市", value: "句容市" }
          ]
        },
        {
          label: "常州市",
          value: "常州市",
          children: [
            { label: "金壇區", value: "金壇區" },
            { label: "溧陽市", value: "溧陽市" },
            { label: "新北區", value: "新北區" },
            { label: "鐘樓區", value: "鐘樓區" },
            { label: "天寧區", value: "天寧區" },
            { label: "武進區", value: "武進區" }
          ]
        },
        {
          label: "無錫市",
          value: "無錫市",
          children: [
            { label: "崇安區", value: "崇安區" },
            { label: "南長區", value: "南長區" },
            { label: "北塘區", value: "北塘區" },
            { label: "錫山區", value: "錫山區" },
            { label: "惠山區", value: "惠山區" },
            { label: "新區", value: "新區" },
            { label: "江陰市", value: "江陰市" },
            { label: "宜興市", value: "宜興市" },
            { label: "濱湖區", value: "濱湖區" }
          ]
        },
        {
          label: "蘇州市",
          value: "蘇州市",
          children: [
            { label: "常熟市", value: "常熟市" },
            { label: "張家港市", value: "張家港市" },
            { label: "相城區", value: "相城區" },
            { label: "金閶區", value: "金閶區" },
            { label: "虎丘區", value: "虎丘區" },
            { label: "平江區", value: "平江區" },
            { label: "滄浪區", value: "滄浪區" },
            { label: "工業園區", value: "工業園區" },
            { label: "高新區", value: "高新區" },
            { label: "太倉市", value: "太倉市" },
            { label: "吳江區", value: "吳江區" },
            { label: "吳中區", value: "吳中區" },
            { label: "崑山市", value: "崑山市" }
          ]
        }
      ]
    },
    {
      label: "山東",
      value: "山東",
      children: [
        {
          label: "濟南市",
          value: "濟南市",
          children: [
            { label: "長清區", value: "長清區" },
            { label: "平陰縣", value: "平陰縣" },
            { label: "濟陽縣", value: "濟陽縣" },
            { label: "商河縣", value: "商河縣" },
            { label: "高新區", value: "高新區" },
            { label: "歷城區", value: "歷城區" },
            { label: "天橋區", value: "天橋區" },
            { label: "槐蔭區", value: "槐蔭區" },
            { label: "歷下區", value: "歷下區" },
            { label: "市中區", value: "市中區" },
            { label: "章丘市", value: "章丘市" }
          ]
        },
        {
          label: "青島市",
          value: "青島市",
          children: [
            { label: "萊西市", value: "萊西市" },
            { label: "四方區", value: "四方區" },
            { label: "市北區", value: "市北區" },
            { label: "市南區", value: "市南區" },
            { label: "李滄區", value: "李滄區" },
            { label: "黃島區", value: "黃島區" },
            { label: "即墨市", value: "即墨市" },
            { label: "城陽區", value: "城陽區" },
            { label: "嶗山區", value: "嶗山區" },
            { label: "膠州市", value: "膠州市" },
            { label: "平度市", value: "平度市" }
          ]
        },
        {
          label: "淄博市",
          value: "淄博市",
          children: [
            { label: "高青縣", value: "高青縣" },
            { label: "沂源縣", value: "沂源縣" },
            { label: "桓台縣", value: "桓台縣" },
            { label: "周村區", value: "周村區" },
            { label: "淄川區", value: "淄川區" },
            { label: "博山區", value: "博山區" },
            { label: "臨淄區", value: "臨淄區" },
            { label: "張店區", value: "張店區" }
          ]
        },
        {
          label: "棗莊市",
          value: "棗莊市",
          children: [
            { label: "山亭區", value: "山亭區" },
            { label: "台兒庄區", value: "台兒庄區" },
            { label: "嶧城區", value: "嶧城區" },
            { label: "薛城區", value: "薛城區" },
            { label: "市中區", value: "市中區" },
            { label: "滕州市", value: "滕州市" }
          ]
        },
        {
          label: "東營市",
          value: "東營市",
          children: [
            { label: "河口區", value: "河口區" },
            { label: "廣饒縣", value: "廣饒縣" },
            { label: "利津縣", value: "利津縣" },
            { label: "墾利區", value: "墾利區" },
            { label: "東營區", value: "東營區" }
          ]
        },
        {
          label: "濰坊市",
          value: "濰坊市",
          children: [
            { label: "青州市", value: "青州市" },
            { label: "諸城市", value: "諸城市" },
            { label: "安丘市", value: "安丘市" },
            { label: "高密市", value: "高密市" },
            { label: "昌邑市", value: "昌邑市" },
            { label: "昌樂縣", value: "昌樂縣" },
            { label: "臨朐縣", value: "臨朐縣" },
            { label: "坊子區", value: "坊子區" },
            { label: "濰城區", value: "濰城區" },
            { label: "奎文區", value: "奎文區" },
            { label: "高新區", value: "高新區" },
            { label: "寒亭區", value: "寒亭區" },
            { label: "壽光市", value: "壽光市" }
          ]
        },
        {
          label: "煙台市",
          value: "煙台市",
          children: [
            { label: "萊陽市", value: "萊陽市" },
            { label: "招遠市", value: "招遠市" },
            { label: "蓬萊市", value: "蓬萊市" },
            { label: "棲霞市", value: "棲霞市" },
            { label: "海陽市", value: "海陽市" },
            { label: "長島縣", value: "長島縣" },
            { label: "芝罘區", value: "芝罘區" },
            { label: "萊山區", value: "萊山區" },
            { label: "福山區", value: "福山區" },
            { label: "牟平區", value: "牟平區" },
            { label: "龍口市", value: "龍口市" },
            { label: "萊州市", value: "萊州市" },
            { label: "開發區", value: "開發區" }
          ]
        },
        {
          label: "威海市",
          value: "威海市",
          children: [
            { label: "乳山市", value: "乳山市" },
            { label: "環翠區", value: "環翠區" },
            { label: "榮成市", value: "榮成市" },
            { label: "文登市", value: "文登市" }
          ]
        },
        {
          label: "萊蕪市",
          value: "萊蕪市",
          children: [
            { label: "萊城區", value: "萊城區" },
            { label: "鋼城區", value: "鋼城區" }
          ]
        },
        {
          label: "德州市",
          value: "德州市",
          children: [
            { label: "樂陵市", value: "樂陵市" },
            { label: "禹城市", value: "禹城市" },
            { label: "陵縣", value: "陵縣" },
            { label: "寧津縣", value: "寧津縣" },
            { label: "武城縣", value: "武城縣" },
            { label: "慶雲縣", value: "慶雲縣" },
            { label: "平原縣", value: "平原縣" },
            { label: "臨邑縣", value: "臨邑縣" },
            { label: "夏津縣", value: "夏津縣" },
            { label: "德城區", value: "德城區" },
            { label: "齊河縣", value: "齊河縣" }
          ]
        },
        {
          label: "臨沂市",
          value: "臨沂市",
          children: [
            { label: "沂南縣", value: "沂南縣" },
            { label: "沂水縣", value: "沂水縣" },
            { label: "費縣", value: "費縣" },
            { label: "平邑縣", value: "平邑縣" },
            { label: "蒙陰縣", value: "蒙陰縣" },
            { label: "臨沭縣", value: "臨沭縣" },
            { label: "莒南縣", value: "莒南縣" },
            { label: "郯城縣", value: "郯城縣" },
            { label: "羅庄區", value: "羅庄區" },
            { label: "蘭山區", value: "蘭山區" },
            { label: "河東區", value: "河東區" },
            { label: "蘭陵縣", value: "蘭陵縣" }
          ]
        },
        {
          label: "聊城市",
          value: "聊城市",
          children: [
            { label: "臨清市", value: "臨清市" },
            { label: "陽谷縣", value: "陽谷縣" },
            { label: "茌平縣", value: "茌平縣" },
            { label: "莘縣", value: "莘縣" },
            { label: "東阿縣", value: "東阿縣" },
            { label: "冠縣", value: "冠縣" },
            { label: "高唐縣", value: "高唐縣" },
            { label: "東昌府區", value: "東昌府區" }
          ]
        },
        {
          label: "濱州市",
          value: "濱州市",
          children: [
            { label: "鄒平縣", value: "鄒平縣" },
            { label: "沾化縣", value: "沾化縣" },
            { label: "惠民縣", value: "惠民縣" },
            { label: "博興縣", value: "博興縣" },
            { label: "陽信縣", value: "陽信縣" },
            { label: "無棣縣", value: "無棣縣" },
            { label: "北海新區", value: "北海新區" },
            { label: "濱城區", value: "濱城區" }
          ]
        },
        {
          label: "菏澤市",
          value: "菏澤市",
          children: [
            { label: "單縣", value: "單縣" },
            { label: "曹縣", value: "曹縣" },
            { label: "定陶縣", value: "定陶縣" },
            { label: "巨野縣", value: "巨野縣" },
            { label: "成武縣", value: "成武縣" },
            { label: "東明縣", value: "東明縣" },
            { label: "鄆城縣", value: "鄆城縣" },
            { label: "鄄城縣", value: "鄄城縣" },
            { label: "牡丹區", value: "牡丹區" }
          ]
        },
        {
          label: "日照市",
          value: "日照市",
          children: [
            { label: "五蓮縣", value: "五蓮縣" },
            { label: "莒縣", value: "莒縣" },
            { label: "嵐山區", value: "嵐山區" },
            { label: "新市區", value: "新市區" },
            { label: "東港區", value: "東港區" }
          ]
        },
        {
          label: "泰安市",
          value: "泰安市",
          children: [
            { label: "東平縣", value: "東平縣" },
            { label: "寧陽縣", value: "寧陽縣" },
            { label: "岱嶽區", value: "岱嶽區" },
            { label: "泰山區", value: "泰山區" },
            { label: "肥城市", value: "肥城市" },
            { label: "新泰市", value: "新泰市" }
          ]
        },
        {
          label: "濟寧市",
          value: "濟寧市",
          children: [
            { label: "梁山縣", value: "梁山縣" },
            { label: "兗州市", value: "兗州市" },
            { label: "微山縣", value: "微山縣" },
            { label: "汶上縣", value: "汶上縣" },
            { label: "泗水縣", value: "泗水縣" },
            { label: "嘉祥縣", value: "嘉祥縣" },
            { label: "魚台縣", value: "魚台縣" },
            { label: "金鄉縣", value: "金鄉縣" },
            { label: "任城區", value: "任城區" },
            { label: "鄒城市", value: "鄒城市" },
            { label: "市中區", value: "市中區" },
            { label: "曲阜市", value: "曲阜市" },
            { label: "高新區", value: "高新區" }
          ]
        }
      ]
    },
    {
      label: "安徽",
      value: "安徽",
      children: [
        {
          label: "銅陵市",
          value: "銅陵市",
          children: [
            { label: "郊區", value: "郊區" },
            { label: "義安區", value: "義安區" },
            { label: "銅官區", value: "銅官區" },
            { label: "樅陽縣", value: "樅陽縣" }
          ]
        },
        {
          label: "合肥市",
          value: "合肥市",
          children: [
            { label: "肥東縣", value: "肥東縣" },
            { label: "廬江縣", value: "廬江縣" },
            { label: "包河區", value: "包河區" },
            { label: "蜀山區", value: "蜀山區" },
            { label: "瑤海區", value: "瑤海區" },
            { label: "廬陽區", value: "廬陽區" },
            { label: "經濟技術開發區", value: "經濟技術開發區" },
            { label: "高新技術開發區", value: "高新技術開發區" },
            { label: "北城新區", value: "北城新區" },
            { label: "濱湖新區", value: "濱湖新區" },
            { label: "政務文化新區", value: "政務文化新區" },
            { label: "新站綜合開發試驗區", value: "新站綜合開發試驗區" },
            { label: "肥西縣", value: "肥西縣" },
            { label: "巢湖市", value: "巢湖市" },
            { label: "長豐縣", value: "長豐縣" }
          ]
        },
        {
          label: "淮南市",
          value: "淮南市",
          children: [
            { label: "鳳台縣", value: "鳳台縣" },
            { label: "田家庵區", value: "田家庵區" },
            { label: "大通區", value: "大通區" },
            { label: "謝家集區", value: "謝家集區" },
            { label: "八公山區", value: "八公山區" },
            { label: "潘集區", value: "潘集區" },
            { label: "淮南高新技術開發區", value: "淮南高新技術開發區" },
            { label: "壽縣", value: "壽縣" }
          ]
        },
        {
          label: "淮北市",
          value: "淮北市",
          children: [
            { label: "杜集區", value: "杜集區" },
            { label: "烈山區", value: "烈山區" },
            { label: "濉溪縣", value: "濉溪縣" },
            { label: "相山區", value: "相山區" }
          ]
        },
        {
          label: "蕪湖市",
          value: "蕪湖市",
          children: [
            { label: "蕪湖縣", value: "蕪湖縣" },
            { label: "繁昌縣", value: "繁昌縣" },
            { label: "南陵縣", value: "南陵縣" },
            { label: "無為縣", value: "無為縣" },
            { label: "鏡湖區", value: "鏡湖區" },
            { label: "弋江區", value: "弋江區" },
            { label: "鳩江區", value: "鳩江區" },
            { label: "三山區", value: "三山區" }
          ]
        },
        {
          label: "蚌埠市",
          value: "蚌埠市",
          children: [
            { label: "懷遠縣", value: "懷遠縣" },
            { label: "固鎮縣", value: "固鎮縣" },
            { label: "五河縣", value: "五河縣" },
            { label: "蚌山區", value: "蚌山區" },
            { label: "淮上區", value: "淮上區" },
            { label: "龍子湖區", value: "龍子湖區" },
            { label: "禹會區", value: "禹會區" }
          ]
        },
        {
          label: "馬鞍山市",
          value: "馬鞍山市",
          children: [
            { label: "當塗縣", value: "當塗縣" },
            { label: "含山縣", value: "含山縣" },
            { label: "和縣", value: "和縣" },
            { label: "博望區", value: "博望區" },
            { label: "花山區", value: "花山區" },
            { label: "雨山區", value: "雨山區" }
          ]
        },
        {
          label: "安慶市",
          value: "安慶市",
          children: [
            { label: "桐城市", value: "桐城市" },
            { label: "宿松縣", value: "宿松縣" },
            { label: "太湖縣", value: "太湖縣" },
            { label: "懷寧縣", value: "懷寧縣" },
            { label: "岳西縣", value: "岳西縣" },
            { label: "望江縣", value: "望江縣" },
            { label: "潛山縣", value: "潛山縣" },
            { label: "大觀區", value: "大觀區" },
            { label: "宜秀區", value: "宜秀區" },
            { label: "迎江區", value: "迎江區" }
          ]
        },
        {
          label: "黃山市",
          value: "黃山市",
          children: [
            { label: "休寧縣", value: "休寧縣" },
            { label: "歙縣", value: "歙縣" },
            { label: "黟縣", value: "黟縣" },
            { label: "祁門縣", value: "祁門縣" },
            { label: "黃山區", value: "黃山區" },
            { label: "徽州區", value: "徽州區" },
            { label: "屯溪區", value: "屯溪區" }
          ]
        },
        {
          label: "滁州市",
          value: "滁州市",
          children: [
            { label: "明光市", value: "明光市" },
            { label: "全椒縣", value: "全椒縣" },
            { label: "來安縣", value: "來安縣" },
            { label: "定遠縣", value: "定遠縣" },
            { label: "鳳陽縣", value: "鳳陽縣" },
            { label: "南譙區", value: "南譙區" },
            { label: "琅琊區", value: "琅琊區" },
            { label: "天長市", value: "天長市" }
          ]
        },
        {
          label: "阜陽市",
          value: "阜陽市",
          children: [
            { label: "界首市", value: "界首市" },
            { label: "太和縣", value: "太和縣" },
            { label: "阜南縣", value: "阜南縣" },
            { label: "潁上縣", value: "潁上縣" },
            { label: "臨泉縣", value: "臨泉縣" },
            { label: "經濟開發區", value: "經濟開發區" },
            { label: "潁泉區", value: "潁泉區" },
            { label: "潁州區", value: "潁州區" },
            { label: "潁東區", value: "潁東區" }
          ]
        },
        {
          label: "亳州市",
          value: "亳州市",
          children: [
            { label: "利辛縣", value: "利辛縣" },
            { label: "蒙城縣", value: "蒙城縣" },
            { label: "渦陽縣", value: "渦陽縣" },
            { label: "譙城區", value: "譙城區" }
          ]
        },
        {
          label: "宿州市",
          value: "宿州市",
          children: [
            { label: "靈璧縣", value: "靈璧縣" },
            { label: "泗縣", value: "泗縣" },
            { label: "蕭縣", value: "蕭縣" },
            { label: "碭山縣", value: "碭山縣" },
            { label: "經濟開發區", value: "經濟開發區" },
            { label: "埇橋區", value: "埇橋區" }
          ]
        },
        {
          label: "池州市",
          value: "池州市",
          children: [
            { label: "東至縣", value: "東至縣" },
            { label: "石台縣", value: "石台縣" },
            { label: "青陽縣", value: "青陽縣" },
            { label: "貴池區", value: "貴池區" }
          ]
        },
        {
          label: "六安市",
          value: "六安市",
          children: [
            { label: "霍山縣", value: "霍山縣" },
            { label: "金寨縣", value: "金寨縣" },
            { label: "霍邱縣", value: "霍邱縣" },
            { label: "舒城縣", value: "舒城縣" },
            { label: "金安區", value: "金安區" },
            { label: "裕安區", value: "裕安區" }
          ]
        },
        {
          label: "宣城市",
          value: "宣城市",
          children: [
            { label: "涇縣", value: "涇縣" },
            { label: "旌德縣", value: "旌德縣" },
            { label: "寧國市", value: "寧國市" },
            { label: "郎溪縣", value: "郎溪縣" },
            { label: "廣德縣", value: "廣德縣" },
            { label: "績溪縣", value: "績溪縣" },
            { label: "宣州區", value: "宣州區" }
          ]
        }
      ]
    },
    {
      label: "浙江",
      value: "浙江",
      children: [
        {
          label: "寧波市",
          value: "寧波市",
          children: [
            { label: "慈溪市", value: "慈溪市" },
            { label: "奉化市", value: "奉化市" },
            { label: "寧海縣", value: "寧海縣" },
            { label: "象山縣", value: "象山縣" },
            { label: "海曙區", value: "海曙區" },
            { label: "江東區", value: "江東區" },
            { label: "高新科技開發區", value: "高新科技開發區" },
            { label: "北侖區", value: "北侖區" },
            { label: "鎮海區", value: "鎮海區" },
            { label: "鄞州區", value: "鄞州區" },
            { label: "江北區", value: "江北區" },
            { label: "餘姚市", value: "餘姚市" }
          ]
        },
        {
          label: "杭州市",
          value: "杭州市",
          children: [
            { label: "餘杭區", value: "餘杭區" },
            { label: "蕭山區", value: "蕭山區" },
            { label: "富陽區", value: "富陽區" },
            { label: "桐廬縣", value: "桐廬縣" },
            { label: "建德市", value: "建德市" },
            { label: "淳安縣", value: "淳安縣" },
            { label: "江干區", value: "江干區" },
            { label: "濱江區", value: "濱江區" },
            { label: "上城區", value: "上城區" },
            { label: "下城區", value: "下城區" },
            { label: "拱墅區", value: "拱墅區" },
            { label: "西湖區", value: "西湖區" },
            { label: "下沙區", value: "下沙區" },
            { label: "臨安市", value: "臨安市" }
          ]
        },
        {
          label: "溫州市",
          value: "溫州市",
          children: [
            { label: "文成縣", value: "文成縣" },
            { label: "平陽縣", value: "平陽縣" },
            { label: "泰順縣", value: "泰順縣" },
            { label: "洞頭區", value: "洞頭區" },
            { label: "蒼南縣", value: "蒼南縣" },
            { label: "龍灣區", value: "龍灣區" },
            { label: "茶山高教園區", value: "茶山高教園區" },
            { label: "瑞安市", value: "瑞安市" },
            { label: "樂清市", value: "樂清市" },
            { label: "鹿城區", value: "鹿城區" },
            { label: "甌海區", value: "甌海區" },
            { label: "永嘉縣", value: "永嘉縣" }
          ]
        },
        {
          label: "嘉興市",
          value: "嘉興市",
          children: [
            { label: "海寧市", value: "海寧市" },
            { label: "海鹽縣", value: "海鹽縣" },
            { label: "南湖區", value: "南湖區" },
            { label: "秀洲區", value: "秀洲區" },
            { label: "桐鄉市", value: "桐鄉市" },
            { label: "平湖市", value: "平湖市" },
            { label: "嘉善縣", value: "嘉善縣" }
          ]
        },
        {
          label: "湖州市",
          value: "湖州市",
          children: [
            { label: "長興縣", value: "長興縣" },
            { label: "德清縣", value: "德清縣" },
            { label: "安吉縣", value: "安吉縣" },
            { label: "南潯區", value: "南潯區" },
            { label: "吳興區", value: "吳興區" }
          ]
        },
        {
          label: "紹興市",
          value: "紹興市",
          children: [
            { label: "諸暨市", value: "諸暨市" },
            { label: "上虞區", value: "上虞區" },
            { label: "嵊州市", value: "嵊州市" },
            { label: "新昌縣", value: "新昌縣" },
            { label: "柯橋區", value: "柯橋區" },
            { label: "越城區", value: "越城區" }
          ]
        },
        {
          label: "金華市",
          value: "金華市",
          children: [
            { label: "金東區", value: "金東區" },
            { label: "蘭溪市", value: "蘭溪市" },
            { label: "婺城區", value: "婺城區" },
            { label: "義烏市", value: "義烏市" },
            { label: "東陽市", value: "東陽市" },
            { label: "永康市", value: "永康市" },
            { label: "武義縣", value: "武義縣" },
            { label: "浦江縣", value: "浦江縣" },
            { label: "磐安縣", value: "磐安縣" }
          ]
        },
        {
          label: "衢州市",
          value: "衢州市",
          children: [
            { label: "江山市", value: "江山市" },
            { label: "常山縣", value: "常山縣" },
            { label: "開化縣", value: "開化縣" },
            { label: "龍游縣", value: "龍游縣" },
            { label: "柯城區", value: "柯城區" },
            { label: "衢江區", value: "衢江區" }
          ]
        },
        {
          label: "麗水市",
          value: "麗水市",
          children: [
            { label: "龍泉市", value: "龍泉市" },
            { label: "縉雲縣", value: "縉雲縣" },
            { label: "遂昌縣", value: "遂昌縣" },
            { label: "松陽縣", value: "松陽縣" },
            { label: "景寧縣", value: "景寧縣" },
            { label: "雲和縣", value: "雲和縣" },
            { label: "青田縣", value: "青田縣" },
            { label: "慶元縣", value: "慶元縣" },
            { label: "蓮都區", value: "蓮都區" }
          ]
        },
        {
          label: "台州市",
          value: "台州市",
          children: [
            { label: "臨海市", value: "臨海市" },
            { label: "三門縣", value: "三門縣" },
            { label: "天台縣", value: "天台縣" },
            { label: "仙居縣", value: "仙居縣" },
            { label: "黃岩區", value: "黃岩區" },
            { label: "椒江區", value: "椒江區" },
            { label: "路橋區", value: "路橋區" },
            { label: "溫嶺市", value: "溫嶺市" },
            { label: "玉環縣", value: "玉環縣" }
          ]
        },
        {
          label: "舟山市",
          value: "舟山市",
          children: [
            { label: "岱山縣", value: "岱山縣" },
            { label: "嵊泗縣", value: "嵊泗縣" },
            { label: "普陀區", value: "普陀區" },
            { label: "定海區", value: "定海區" }
          ]
        }
      ]
    },
    {
      label: "福建",
      value: "福建",
      children: [
        {
          label: "福州市",
          value: "福州市",
          children: [
            { label: "長樂市", value: "長樂市" },
            { label: "平潭縣", value: "平潭縣" },
            { label: "連江縣", value: "連江縣" },
            { label: "羅源縣", value: "羅源縣" },
            { label: "永泰縣", value: "永泰縣" },
            { label: "閩清縣", value: "閩清縣" },
            { label: "台江區", value: "台江區" },
            { label: "鼓樓區", value: "鼓樓區" },
            { label: "晉安區", value: "晉安區" },
            { label: "倉山區", value: "倉山區" },
            { label: "馬尾區", value: "馬尾區" },
            { label: "福清市", value: "福清市" },
            { label: "閩侯縣", value: "閩侯縣" }
          ]
        },
        {
          label: "廈門市",
          value: "廈門市",
          children: [
            { label: "思明區", value: "思明區" },
            { label: "湖裡區", value: "湖裡區" },
            { label: "翔安區", value: "翔安區" },
            { label: "海滄區", value: "海滄區" },
            { label: "集美區", value: "集美區" },
            { label: "同安區", value: "同安區" }
          ]
        },
        {
          label: "三明市",
          value: "三明市",
          children: [
            { label: "永安市", value: "永安市" },
            { label: "明溪縣", value: "明溪縣" },
            { label: "將樂縣", value: "將樂縣" },
            { label: "大田縣", value: "大田縣" },
            { label: "寧化縣", value: "寧化縣" },
            { label: "建寧縣", value: "建寧縣" },
            { label: "沙縣", value: "沙縣" },
            { label: "尤溪縣", value: "尤溪縣" },
            { label: "清流縣", value: "清流縣" },
            { label: "泰寧縣", value: "泰寧縣" },
            { label: "梅列區", value: "梅列區" },
            { label: "三元區", value: "三元區" }
          ]
        },
        {
          label: "莆田市",
          value: "莆田市",
          children: [
            { label: "仙游縣", value: "仙游縣" },
            { label: "涵江區", value: "涵江區" },
            { label: "秀嶼區", value: "秀嶼區" },
            { label: "城廂區", value: "城廂區" },
            { label: "荔城區", value: "荔城區" }
          ]
        },
        {
          label: "泉州市",
          value: "泉州市",
          children: [
            { label: "石獅市", value: "石獅市" },
            { label: "南安市", value: "南安市" },
            { label: "惠安縣", value: "惠安縣" },
            { label: "安溪縣", value: "安溪縣" },
            { label: "德化縣", value: "德化縣" },
            { label: "永春縣", value: "永春縣" },
            { label: "泉港區", value: "泉港區" },
            { label: "金門縣", value: "金門縣" },
            { label: "洛江區", value: "洛江區" },
            { label: "鯉城區", value: "鯉城區" },
            { label: "豐澤區", value: "豐澤區" },
            { label: "晉江市", value: "晉江市" }
          ]
        },
        {
          label: "漳州市",
          value: "漳州市",
          children: [
            { label: "龍海市", value: "龍海市" },
            { label: "平和縣", value: "平和縣" },
            { label: "南靖縣", value: "南靖縣" },
            { label: "詔安縣", value: "詔安縣" },
            { label: "漳浦縣", value: "漳浦縣" },
            { label: "華安縣", value: "華安縣" },
            { label: "雲霄縣", value: "雲霄縣" },
            { label: "東山縣", value: "東山縣" },
            { label: "長泰縣", value: "長泰縣" },
            { label: "薌城區", value: "薌城區" },
            { label: "龍文區", value: "龍文區" }
          ]
        },
        {
          label: "南平市",
          value: "南平市",
          children: [
            { label: "建甌市", value: "建甌市" },
            { label: "邵武市", value: "邵武市" },
            { label: "武夷山市", value: "武夷山市" },
            { label: "建陽市", value: "建陽市" },
            { label: "松溪縣", value: "松溪縣" },
            { label: "順昌縣", value: "順昌縣" },
            { label: "浦城縣", value: "浦城縣" },
            { label: "政和縣", value: "政和縣" },
            { label: "光澤縣", value: "光澤縣" },
            { label: "延平區", value: "延平區" }
          ]
        },
        {
          label: "龍岩市",
          value: "龍岩市",
          children: [
            { label: "漳平市", value: "漳平市" },
            { label: "長汀縣", value: "長汀縣" },
            { label: "武平縣", value: "武平縣" },
            { label: "永定縣", value: "永定縣" },
            { label: "上杭縣", value: "上杭縣" },
            { label: "連城縣", value: "連城縣" },
            { label: "新羅區", value: "新羅區" }
          ]
        },
        {
          label: "寧德市",
          value: "寧德市",
          children: [
            { label: "福安市", value: "福安市" },
            { label: "福鼎市", value: "福鼎市" },
            { label: "壽寧縣", value: "壽寧縣" },
            { label: "霞浦縣", value: "霞浦縣" },
            { label: "柘榮縣", value: "柘榮縣" },
            { label: "屏南縣", value: "屏南縣" },
            { label: "古田縣", value: "古田縣" },
            { label: "周寧縣", value: "周寧縣" },
            { label: "蕉城區", value: "蕉城區" },
            { label: "東僑開發區", value: "東僑開發區" }
          ]
        }
      ]
    },
    {
      label: "湖北",
      value: "湖北",
      children: [
        {
          label: "武漢市",
          value: "武漢市",
          children: [
            { label: "江岸區", value: "江岸區" },
            { label: "武昌區", value: "武昌區" },
            { label: "江漢區", value: "江漢區" },
            { label: "硚口區", value: "硚口區" },
            { label: "武漢經濟技術開發區", value: "武漢經濟技術開發區" },
            { label: "蔡甸區", value: "蔡甸區" },
            { label: "江夏區", value: "江夏區" },
            { label: "新洲區", value: "新洲區" },
            { label: "黃陂區", value: "黃陂區" },
            { label: "漢陽區", value: "漢陽區" },
            { label: "青山區", value: "青山區" },
            { label: "洪山區", value: "洪山區" },
            { label: "漢南區", value: "漢南區" },
            { label: "東西湖區", value: "東西湖區" }
          ]
        },
        {
          label: "黃石市",
          value: "黃石市",
          children: [
            { label: "黃石港區", value: "黃石港區" },
            { label: "鐵山區", value: "鐵山區" },
            { label: "大冶市", value: "大冶市" },
            { label: "陽新縣", value: "陽新縣" },
            { label: "下陸區", value: "下陸區" },
            { label: "西塞山區", value: "西塞山區" },
            { label: "經濟技術開發區", value: "經濟技術開發區" }
          ]
        },
        {
          label: "襄陽市",
          value: "襄陽市",
          children: [
            { label: "老河口市", value: "老河口市" },
            { label: "棗陽市", value: "棗陽市" },
            { label: "宜城市", value: "宜城市" },
            { label: "南漳縣", value: "南漳縣" },
            { label: "保康縣", value: "保康縣" },
            { label: "谷城縣", value: "谷城縣" },
            { label: "樊城區", value: "樊城區" },
            { label: "襄城區", value: "襄城區" },
            { label: "襄州區", value: "襄州區" }
          ]
        },
        {
          label: "十堰市",
          value: "十堰市",
          children: [
            { label: "丹江口市", value: "丹江口市" },
            { label: "房縣", value: "房縣" },
            { label: "竹山縣", value: "竹山縣" },
            { label: "竹溪縣", value: "竹溪縣" },
            { label: "鄖縣", value: "鄖縣" },
            { label: "鄖西縣", value: "鄖西縣" },
            { label: "茅箭區", value: "茅箭區" },
            { label: "張灣區", value: "張灣區" }
          ]
        },
        {
          label: "荊州市",
          value: "荊州市",
          children: [
            { label: "江陵縣", value: "江陵縣" },
            { label: "洪湖市", value: "洪湖市" },
            { label: "石首市", value: "石首市" },
            { label: "松滋市", value: "松滋市" },
            { label: "監利縣", value: "監利縣" },
            { label: "公安縣", value: "公安縣" },
            { label: "沙市區", value: "沙市區" },
            { label: "荊州區", value: "荊州區" }
          ]
        },
        {
          label: "宜昌市",
          value: "宜昌市",
          children: [
            { label: "當陽市", value: "當陽市" },
            { label: "枝江市", value: "枝江市" },
            { label: "夷陵區", value: "夷陵區" },
            { label: "秭歸縣", value: "秭歸縣" },
            { label: "興山縣", value: "興山縣" },
            { label: "遠安縣", value: "遠安縣" },
            { label: "五峰土家族自治縣", value: "五峰土家族自治縣" },
            { label: "長陽土家族自治縣", value: "長陽土家族自治縣" },
            { label: "宜都市", value: "宜都市" },
            { label: "猇亭區", value: "猇亭區" },
            { label: "點軍區", value: "點軍區" },
            { label: "伍家崗區", value: "伍家崗區" },
            { label: "西陵區", value: "西陵區" }
          ]
        },
        {
          label: "孝感市",
          value: "孝感市",
          children: [
            { label: "漢川市", value: "漢川市" },
            { label: "雲夢縣", value: "雲夢縣" },
            { label: "大悟縣", value: "大悟縣" },
            { label: "孝昌縣", value: "孝昌縣" },
            { label: "孝南區", value: "孝南區" },
            { label: "應城市", value: "應城市" },
            { label: "安陸市", value: "安陸市" }
          ]
        },
        {
          label: "黃岡市",
          value: "黃岡市",
          children: [
            { label: "紅安縣", value: "紅安縣" },
            { label: "羅田縣", value: "羅田縣" },
            { label: "黃梅縣", value: "黃梅縣" },
            { label: "英山縣", value: "英山縣" },
            { label: "團風縣", value: "團風縣" },
            { label: "黃州區", value: "黃州區" },
            { label: "蘄春縣", value: "蘄春縣" },
            { label: "麻城市", value: "麻城市" },
            { label: "武穴市", value: "武穴市" },
            { label: "浠水縣", value: "浠水縣" }
          ]
        },
        {
          label: "咸寧市",
          value: "咸寧市",
          children: [
            { label: "嘉魚縣", value: "嘉魚縣" },
            { label: "通山縣", value: "通山縣" },
            { label: "崇陽縣", value: "崇陽縣" },
            { label: "通城縣", value: "通城縣" },
            { label: "咸安區", value: "咸安區" },
            { label: "赤壁市", value: "赤壁市" }
          ]
        },
        {
          label: "恩施州",
          value: "恩施州",
          children: [
            { label: "恩施市", value: "恩施市" },
            { label: "利川市", value: "利川市" },
            { label: "建始縣", value: "建始縣" },
            { label: "來鳳縣", value: "來鳳縣" },
            { label: "巴東縣", value: "巴東縣" },
            { label: "鶴峰縣", value: "鶴峰縣" },
            { label: "宣恩縣", value: "宣恩縣" },
            { label: "咸豐縣", value: "咸豐縣" }
          ]
        },
        {
          label: "鄂州市",
          value: "鄂州市",
          children: [
            { label: "梁子湖區", value: "梁子湖區" },
            { label: "華容區", value: "華容區" },
            { label: "鄂城區", value: "鄂城區" }
          ]
        },
        {
          label: "荊門市",
          value: "荊門市",
          children: [
            { label: "京山縣", value: "京山縣" },
            { label: "鍾祥市", value: "鍾祥市" },
            { label: "沙洋縣", value: "沙洋縣" },
            { label: "掇刀區", value: "掇刀區" },
            { label: "東寶區", value: "東寶區" }
          ]
        },
        {
          label: "隨州市",
          value: "隨州市",
          children: [
            { label: "廣水市", value: "廣水市" },
            { label: "曾都區", value: "曾都區" },
            { label: "隨縣", value: "隨縣" }
          ]
        },
        { label: "潛江市", value: "潛江市" },
        { label: "天門市", value: "天門市" },
        { label: "仙桃市", value: "仙桃市" },
        { label: "神農架林區", value: "神農架林區" }
      ]
    },
    {
      label: "湖南",
      value: "湖南",
      children: [
        {
          label: "長沙市",
          value: "長沙市",
          children: [
            { label: "望城區", value: "望城區" },
            { label: "芙蓉區", value: "芙蓉區" },
            { label: "嶽麓區", value: "嶽麓區" },
            { label: "雨花區", value: "雨花區" },
            { label: "開福區", value: "開福區" },
            { label: "天心區", value: "天心區" },
            { label: "瀏陽市", value: "瀏陽市" },
            { label: "長沙縣", value: "長沙縣" },
            { label: "寧鄉縣", value: "寧鄉縣" }
          ]
        },
        {
          label: "株洲市",
          value: "株洲市",
          children: [
            { label: "醴陵市", value: "醴陵市" },
            { label: "株洲縣", value: "株洲縣" },
            { label: "攸縣", value: "攸縣" },
            { label: "茶陵縣", value: "茶陵縣" },
            { label: "炎陵縣", value: "炎陵縣" },
            { label: "天元區", value: "天元區" },
            { label: "石峰區", value: "石峰區" },
            { label: "蘆淞區", value: "蘆淞區" },
            { label: "荷塘區", value: "荷塘區" }
          ]
        },
        {
          label: "湘潭市",
          value: "湘潭市",
          children: [
            { label: "湘鄉市", value: "湘鄉市" },
            { label: "湘潭縣", value: "湘潭縣" },
            { label: "韶山市", value: "韶山市" },
            { label: "雨湖區", value: "雨湖區" },
            { label: "岳塘區", value: "岳塘區" }
          ]
        },
        {
          label: "衡陽市",
          value: "衡陽市",
          children: [
            { label: "常寧市", value: "常寧市" },
            { label: "衡陽縣", value: "衡陽縣" },
            { label: "耒陽市", value: "耒陽市" },
            { label: "衡東縣", value: "衡東縣" },
            { label: "衡南縣", value: "衡南縣" },
            { label: "衡山縣", value: "衡山縣" },
            { label: "祁東縣", value: "祁東縣" },
            { label: "南嶽區", value: "南嶽區" },
            { label: "蒸湘區", value: "蒸湘區" },
            { label: "石鼓區", value: "石鼓區" },
            { label: "珠暉區", value: "珠暉區" },
            { label: "雁峰區", value: "雁峰區" }
          ]
        },
        {
          label: "邵陽市",
          value: "邵陽市",
          children: [
            { label: "武岡市", value: "武岡市" },
            { label: "邵東縣", value: "邵東縣" },
            { label: "洞口縣", value: "洞口縣" },
            { label: "新邵縣", value: "新邵縣" },
            { label: "綏寧縣", value: "綏寧縣" },
            { label: "新寧縣", value: "新寧縣" },
            { label: "邵陽縣", value: "邵陽縣" },
            { label: "隆回縣", value: "隆回縣" },
            { label: "城步縣", value: "城步縣" },
            { label: "大祥區", value: "大祥區" },
            { label: "雙清區", value: "雙清區" },
            { label: "北塔區", value: "北塔區" }
          ]
        },
        {
          label: "岳陽市",
          value: "岳陽市",
          children: [
            { label: "臨湘市", value: "臨湘市" },
            { label: "汨羅市", value: "汨羅市" },
            { label: "岳陽縣", value: "岳陽縣" },
            { label: "湘陰縣", value: "湘陰縣" },
            { label: "華容縣", value: "華容縣" },
            { label: "平江縣", value: "平江縣" },
            { label: "君山區", value: "君山區" },
            { label: "雲溪區", value: "雲溪區" },
            { label: "岳陽樓區", value: "岳陽樓區" }
          ]
        },
        {
          label: "常德市",
          value: "常德市",
          children: [
            { label: "津市市", value: "津市市" },
            { label: "澧縣", value: "澧縣" },
            { label: "臨澧縣", value: "臨澧縣" },
            { label: "桃源縣", value: "桃源縣" },
            { label: "漢壽縣", value: "漢壽縣" },
            { label: "石門縣", value: "石門縣" },
            { label: "安鄉縣", value: "安鄉縣" },
            { label: "鼎城區", value: "鼎城區" },
            { label: "武陵區", value: "武陵區" }
          ]
        },
        {
          label: "張家界市",
          value: "張家界市",
          children: [
            { label: "慈利縣", value: "慈利縣" },
            { label: "桑植縣", value: "桑植縣" },
            { label: "武陵源區", value: "武陵源區" },
            { label: "永定區", value: "永定區" }
          ]
        },
        {
          label: "郴州市",
          value: "郴州市",
          children: [
            { label: "資興市", value: "資興市" },
            { label: "宜章縣", value: "宜章縣" },
            { label: "安仁縣", value: "安仁縣" },
            { label: "汝城縣", value: "汝城縣" },
            { label: "嘉禾縣", value: "嘉禾縣" },
            { label: "臨武縣", value: "臨武縣" },
            { label: "桂東縣", value: "桂東縣" },
            { label: "永興縣", value: "永興縣" },
            { label: "桂陽縣", value: "桂陽縣" },
            { label: "北湖區", value: "北湖區" },
            { label: "蘇仙區", value: "蘇仙區" }
          ]
        },
        {
          label: "益陽市",
          value: "益陽市",
          children: [
            { label: "南縣", value: "南縣" },
            { label: "桃江縣", value: "桃江縣" },
            { label: "安化縣", value: "安化縣" },
            { label: "沅江市", value: "沅江市" },
            { label: "赫山區", value: "赫山區" },
            { label: "資陽區", value: "資陽區" }
          ]
        },
        {
          label: "永州市",
          value: "永州市",
          children: [
            { label: "祁陽縣", value: "祁陽縣" },
            { label: "雙牌縣", value: "雙牌縣" },
            { label: "道縣", value: "道縣" },
            { label: "江永縣", value: "江永縣" },
            { label: "江華縣", value: "江華縣" },
            { label: "寧遠縣", value: "寧遠縣" },
            { label: "新田縣", value: "新田縣" },
            { label: "藍山縣", value: "藍山縣" },
            { label: "東安縣", value: "東安縣" },
            { label: "零陵區", value: "零陵區" },
            { label: "冷水灘區", value: "冷水灘區" }
          ]
        },
        {
          label: "懷化市",
          value: "懷化市",
          children: [
            { label: "洪江市", value: "洪江市" },
            { label: "會同縣", value: "會同縣" },
            { label: "漵浦縣", value: "漵浦縣" },
            { label: "辰溪縣", value: "辰溪縣" },
            { label: "靖州縣", value: "靖州縣" },
            { label: "通道縣", value: "通道縣" },
            { label: "芷江縣", value: "芷江縣" },
            { label: "新晃縣", value: "新晃縣" },
            { label: "麻陽縣", value: "麻陽縣" },
            { label: "沅陵縣", value: "沅陵縣" },
            { label: "中方縣", value: "中方縣" },
            { label: "鶴城區", value: "鶴城區" }
          ]
        },
        {
          label: "婁底市",
          value: "婁底市",
          children: [
            { label: "冷水江市", value: "冷水江市" },
            { label: "漣源市", value: "漣源市" },
            { label: "新化縣", value: "新化縣" },
            { label: "雙峰縣", value: "雙峰縣" },
            { label: "婁星區", value: "婁星區" }
          ]
        },
        {
          label: "湘西州",
          value: "湘西州",
          children: [
            { label: "吉首市", value: "吉首市" },
            { label: "古丈縣", value: "古丈縣" },
            { label: "龍山縣", value: "龍山縣" },
            { label: "永順縣", value: "永順縣" },
            { label: "瀘溪縣", value: "瀘溪縣" },
            { label: "鳳凰縣", value: "鳳凰縣" },
            { label: "花垣縣", value: "花垣縣" },
            { label: "保靖縣", value: "保靖縣" }
          ]
        }
      ]
    },
    {
      label: "廣東",
      value: "廣東",
      children: [
        {
          label: "廣州市",
          value: "廣州市",
          children: [
            { label: "天河區", value: "天河區" },
            { label: "海珠區", value: "海珠區" },
            { label: "荔灣區", value: "荔灣區" },
            { label: "越秀區", value: "越秀區" },
            { label: "番禺區", value: "番禺區" },
            { label: "花都區", value: "花都區" },
            { label: "蘿崗區", value: "蘿崗區" },
            { label: "白雲區", value: "白雲區" },
            { label: "南沙區", value: "南沙區" },
            { label: "黃埔區", value: "黃埔區" },
            { label: "增城區", value: "增城區" },
            { label: "從化區", value: "從化區" },
            { label: "廣州大學城", value: "廣州大學城" }
          ]
        },
        {
          label: "深圳市",
          value: "深圳市",
          children: [
            { label: "南山區", value: "南山區" },
            { label: "羅湖區", value: "羅湖區" },
            { label: "福田區", value: "福田區" },
            { label: "寶安區", value: "寶安區" },
            { label: "光明新區", value: "光明新區" },
            { label: "坪山新區", value: "坪山新區" },
            { label: "大鵬新區", value: "大鵬新區" },
            { label: "龍崗區", value: "龍崗區" },
            { label: "鹽田區", value: "鹽田區" },
            { label: "龍華新區", value: "龍華新區" }
          ]
        },
        {
          label: "珠海市",
          value: "珠海市",
          children: [
            { label: "斗門區", value: "斗門區" },
            { label: "金灣區", value: "金灣區" },
            { label: "香洲區", value: "香洲區" }
          ]
        },
        {
          label: "汕頭市",
          value: "汕頭市",
          children: [
            { label: "南澳縣", value: "南澳縣" },
            { label: "龍湖區", value: "龍湖區" },
            { label: "金平區", value: "金平區" },
            { label: "澄海區", value: "澄海區" },
            { label: "潮陽區", value: "潮陽區" },
            { label: "潮南區", value: "潮南區" },
            { label: "濠江區", value: "濠江區" }
          ]
        },
        {
          label: "韶關市",
          value: "韶關市",
          children: [
            { label: "南雄市", value: "南雄市" },
            { label: "樂昌市", value: "樂昌市" },
            { label: "仁化縣", value: "仁化縣" },
            { label: "始興縣", value: "始興縣" },
            { label: "翁源縣", value: "翁源縣" },
            { label: "新豐縣", value: "新豐縣" },
            { label: "乳源瑤族自治縣", value: "乳源瑤族自治縣" },
            { label: "曲江區", value: "曲江區" },
            { label: "武江區", value: "武江區" },
            { label: "湞江區", value: "湞江區" }
          ]
        },
        {
          label: "河源市",
          value: "河源市",
          children: [
            { label: "和平縣", value: "和平縣" },
            { label: "龍川縣", value: "龍川縣" },
            { label: "紫金縣", value: "紫金縣" },
            { label: "連平縣", value: "連平縣" },
            { label: "源城區", value: "源城區" },
            { label: "東源縣", value: "東源縣" }
          ]
        },
        {
          label: "梅州市",
          value: "梅州市",
          children: [
            { label: "興寧市", value: "興寧市" },
            { label: "梅縣", value: "梅縣" },
            { label: "蕉嶺縣", value: "蕉嶺縣" },
            { label: "大埔縣", value: "大埔縣" },
            { label: "豐順縣", value: "豐順縣" },
            { label: "五華縣", value: "五華縣" },
            { label: "平遠縣", value: "平遠縣" },
            { label: "梅江區", value: "梅江區" }
          ]
        },
        {
          label: "惠州市",
          value: "惠州市",
          children: [
            { label: "龍門縣", value: "龍門縣" },
            { label: "惠陽區", value: "惠陽區" },
            { label: "大亞灣區", value: "大亞灣區" },
            { label: "惠城區", value: "惠城區" },
            { label: "惠東縣", value: "惠東縣" },
            { label: "博羅縣", value: "博羅縣" }
          ]
        },
        {
          label: "汕尾市",
          value: "汕尾市",
          children: [
            { label: "陸河縣", value: "陸河縣" },
            { label: "海豐縣", value: "海豐縣" },
            { label: "城區", value: "城區" },
            { label: "陸豐市", value: "陸豐市" }
          ]
        },
        {
          label: "東莞市",
          value: "東莞市",
          children: [
            { label: "中堂鎮", value: "中堂鎮" },
            { label: "東坑鎮", value: "東坑鎮" },
            { label: "道滘鎮", value: "道滘鎮" },
            { label: "沙田鎮", value: "沙田鎮" },
            { label: "高埗鎮", value: "高埗鎮" },
            { label: "石龍鎮", value: "石龍鎮" },
            { label: "石排鎮", value: "石排鎮" },
            { label: "企石鎮", value: "企石鎮" },
            { label: "石碣鎮", value: "石碣鎮" },
            { label: "洪梅鎮", value: "洪梅鎮" },
            { label: "麻涌鎮", value: "麻涌鎮" },
            { label: "橋頭鎮", value: "橋頭鎮" },
            { label: "望牛墩鎮", value: "望牛墩鎮" },
            { label: "茶山鎮", value: "茶山鎮" },
            { label: "謝崗鎮", value: "謝崗鎮" },
            { label: "松山湖", value: "松山湖" },
            { label: "莞城區", value: "莞城區" },
            { label: "南城區", value: "南城區" },
            { label: "長安鎮", value: "長安鎮" },
            { label: "寮步鎮", value: "寮步鎮" },
            { label: "大嶺山鎮", value: "大嶺山鎮" },
            { label: "常平鎮", value: "常平鎮" },
            { label: "厚街鎮", value: "厚街鎮" },
            { label: "萬江區", value: "萬江區" },
            { label: "樟木頭鎮", value: "樟木頭鎮" },
            { label: "大朗鎮", value: "大朗鎮" },
            { label: "塘廈鎮", value: "塘廈鎮" },
            { label: "鳳崗鎮", value: "鳳崗鎮" },
            { label: "清溪鎮", value: "清溪鎮" },
            { label: "橫瀝鎮", value: "橫瀝鎮" },
            { label: "東城區", value: "東城區" },
            { label: "黃江鎮", value: "黃江鎮" },
            { label: "虎門鎮", value: "虎門鎮" }
          ]
        },
        {
          label: "中山市",
          value: "中山市",
          children: [
            { label: "南朗鎮", value: "南朗鎮" },
            { label: "小欖鎮", value: "小欖鎮" },
            { label: "古鎮", value: "古鎮" },
            { label: "坦洲鎮", value: "坦洲鎮" },
            { label: "黃圃鎮", value: "黃圃鎮" },
            { label: "三鄉鎮", value: "三鄉鎮" },
            { label: "東鳳鎮", value: "東鳳鎮" },
            { label: "橫欄鎮", value: "橫欄鎮" },
            { label: "三角鎮", value: "三角鎮" },
            { label: "南頭鎮", value: "南頭鎮" },
            { label: "沙溪鎮", value: "沙溪鎮" },
            { label: "五桂山鎮", value: "五桂山鎮" },
            { label: "阜沙鎮", value: "阜沙鎮" },
            { label: "東升鎮", value: "東升鎮" },
            { label: "板芙鎮", value: "板芙鎮" },
            { label: "神灣鎮", value: "神灣鎮" },
            { label: "港口鎮", value: "港口鎮" },
            { label: "大涌鎮", value: "大涌鎮" },
            { label: "火炬開發區", value: "火炬開發區" },
            { label: "民眾鎮", value: "民眾鎮" },
            { label: "沙朗鎮", value: "沙朗鎮" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "江門市",
          value: "江門市",
          children: [
            { label: "台山市", value: "台山市" },
            { label: "新會區", value: "新會區" },
            { label: "鶴山市", value: "鶴山市" },
            { label: "江海區", value: "江海區" },
            { label: "蓬江區", value: "蓬江區" },
            { label: "開平市", value: "開平市" },
            { label: "恩平市", value: "恩平市" }
          ]
        },
        {
          label: "佛山市",
          value: "佛山市",
          children: [
            { label: "順德區", value: "順德區" },
            { label: "禪城區", value: "禪城區" },
            { label: "高明區", value: "高明區" },
            { label: "三水區", value: "三水區" },
            { label: "南海區", value: "南海區" }
          ]
        },
        {
          label: "陽江市",
          value: "陽江市",
          children: [
            { label: "陽春市", value: "陽春市" },
            { label: "陽西縣", value: "陽西縣" },
            { label: "江城區", value: "江城區" },
            { label: "陽東縣", value: "陽東縣" }
          ]
        },
        {
          label: "湛江市",
          value: "湛江市",
          children: [
            { label: "雷州市", value: "雷州市" },
            { label: "吳川市", value: "吳川市" },
            { label: "徐聞縣", value: "徐聞縣" },
            { label: "坡頭區", value: "坡頭區" },
            { label: "赤坎區", value: "赤坎區" },
            { label: "霞山區", value: "霞山區" },
            { label: "經濟技術開發區", value: "經濟技術開發區" },
            { label: "麻章區", value: "麻章區" },
            { label: "遂溪縣", value: "遂溪縣" },
            { label: "廉江市", value: "廉江市" }
          ]
        },
        {
          label: "茂名市",
          value: "茂名市",
          children: [
            { label: "信宜市", value: "信宜市" },
            { label: "茂南區", value: "茂南區" },
            { label: "電白縣", value: "電白縣" },
            { label: "高州市", value: "高州市" },
            { label: "化州市", value: "化州市" },
            { label: "茂港區", value: "茂港區" }
          ]
        },
        {
          label: "肇慶市",
          value: "肇慶市",
          children: [
            { label: "廣寧縣", value: "廣寧縣" },
            { label: "德慶縣", value: "德慶縣" },
            { label: "懷集縣", value: "懷集縣" },
            { label: "封開縣", value: "封開縣" },
            { label: "鼎湖區", value: "鼎湖區" },
            { label: "端州區", value: "端州區" },
            { label: "四會市", value: "四會市" },
            { label: "高要市", value: "高要市" }
          ]
        },
        {
          label: "雲浮市",
          value: "雲浮市",
          children: [
            { label: "雲安縣", value: "雲安縣" },
            { label: "新興縣", value: "新興縣" },
            { label: "鬱南縣", value: "鬱南縣" },
            { label: "雲城區", value: "雲城區" },
            { label: "羅定市", value: "羅定市" }
          ]
        },
        {
          label: "清遠市",
          value: "清遠市",
          children: [
            { label: "連州市", value: "連州市" },
            { label: "佛岡縣", value: "佛岡縣" },
            { label: "陽山縣", value: "陽山縣" },
            { label: "清新縣", value: "清新縣" },
            { label: "連山縣", value: "連山縣" },
            { label: "連南縣", value: "連南縣" },
            { label: "清城區", value: "清城區" },
            { label: "英德市", value: "英德市" }
          ]
        },
        {
          label: "潮州市",
          value: "潮州市",
          children: [
            { label: "饒平縣", value: "饒平縣" },
            { label: "楓溪區", value: "楓溪區" },
            { label: "湘橋區", value: "湘橋區" },
            { label: "潮安區", value: "潮安區" }
          ]
        },
        {
          label: "揭陽市",
          value: "揭陽市",
          children: [
            { label: "揭西縣", value: "揭西縣" },
            { label: "惠來縣", value: "惠來縣" },
            { label: "東山區", value: "東山區" },
            { label: "普寧市", value: "普寧市" },
            { label: "榕城區", value: "榕城區" },
            { label: "揭東縣", value: "揭東縣" }
          ]
        }
      ]
    },
    {
      label: "廣西",
      value: "廣西",
      children: [
        {
          label: "南寧市",
          value: "南寧市",
          children: [
            { label: "武鳴區", value: "武鳴區" },
            { label: "邕寧區", value: "邕寧區" },
            { label: "賓陽縣", value: "賓陽縣" },
            { label: "橫縣", value: "橫縣" },
            { label: "上林縣", value: "上林縣" },
            { label: "隆安縣", value: "隆安縣" },
            { label: "馬山縣", value: "馬山縣" },
            { label: "良慶區", value: "良慶區" },
            { label: "江南區", value: "江南區" },
            { label: "興寧區", value: "興寧區" },
            { label: "青秀區", value: "青秀區" },
            { label: "西鄉塘區", value: "西鄉塘區" }
          ]
        },
        {
          label: "柳州市",
          value: "柳州市",
          children: [
            { label: "柳江縣", value: "柳江縣" },
            { label: "柳城縣", value: "柳城縣" },
            { label: "鹿寨縣", value: "鹿寨縣" },
            { label: "融安縣", value: "融安縣" },
            { label: "三江縣", value: "三江縣" },
            { label: "融水縣", value: "融水縣" },
            { label: "魚峰區", value: "魚峰區" },
            { label: "城中區", value: "城中區" },
            { label: "柳南區", value: "柳南區" },
            { label: "柳北區", value: "柳北區" }
          ]
        },
        {
          label: "桂林市",
          value: "桂林市",
          children: [
            { label: "陽朔縣", value: "陽朔縣" },
            { label: "臨桂縣", value: "臨桂縣" },
            { label: "靈川縣", value: "靈川縣" },
            { label: "全州縣", value: "全州縣" },
            { label: "平樂縣", value: "平樂縣" },
            { label: "興安縣", value: "興安縣" },
            { label: "灌陽縣", value: "灌陽縣" },
            { label: "荔浦縣", value: "荔浦縣" },
            { label: "資源縣", value: "資源縣" },
            { label: "永福縣", value: "永福縣" },
            { label: "龍勝縣", value: "龍勝縣" },
            { label: "恭城縣", value: "恭城縣" },
            { label: "象山區", value: "象山區" },
            { label: "雁山區", value: "雁山區" },
            { label: "秀峰區", value: "秀峰區" },
            { label: "疊彩區", value: "疊彩區" },
            { label: "七星區", value: "七星區" }
          ]
        },
        {
          label: "梧州市",
          value: "梧州市",
          children: [
            { label: "岑溪市", value: "岑溪市" },
            { label: "蒼梧縣", value: "蒼梧縣" },
            { label: "藤縣", value: "藤縣" },
            { label: "蒙山縣", value: "蒙山縣" },
            { label: "萬秀區", value: "萬秀區" },
            { label: "蝶山區", value: "蝶山區" },
            { label: "長洲區", value: "長洲區" }
          ]
        },
        {
          label: "北海市",
          value: "北海市",
          children: [
            { label: "合浦縣", value: "合浦縣" },
            { label: "鐵山港區", value: "鐵山港區" },
            { label: "海城區", value: "海城區" },
            { label: "銀海區", value: "銀海區" }
          ]
        },
        {
          label: "防城港市",
          value: "防城港市",
          children: [
            { label: "東興市", value: "東興市" },
            { label: "上思縣", value: "上思縣" },
            { label: "防城區", value: "防城區" },
            { label: "港口區", value: "港口區" }
          ]
        },
        {
          label: "欽州市",
          value: "欽州市",
          children: [
            { label: "浦北縣", value: "浦北縣" },
            { label: "靈山縣", value: "靈山縣" },
            { label: "欽北區", value: "欽北區" },
            { label: "欽南區", value: "欽南區" }
          ]
        },
        {
          label: "貴港市",
          value: "貴港市",
          children: [
            { label: "桂平市", value: "桂平市" },
            { label: "平南縣", value: "平南縣" },
            { label: "覃塘區", value: "覃塘區" },
            { label: "港南區", value: "港南區" },
            { label: "港北區", value: "港北區" }
          ]
        },
        {
          label: "玉林市",
          value: "玉林市",
          children: [
            { label: "北流市", value: "北流市" },
            { label: "容縣", value: "容縣" },
            { label: "博白縣", value: "博白縣" },
            { label: "陸川縣", value: "陸川縣" },
            { label: "興業縣", value: "興業縣" },
            { label: "玉州區", value: "玉州區" }
          ]
        },
        {
          label: "賀州市",
          value: "賀州市",
          children: [
            { label: "鐘山縣", value: "鐘山縣" },
            { label: "昭平縣", value: "昭平縣" },
            { label: "富川縣", value: "富川縣" },
            { label: "平桂管理區", value: "平桂管理區" },
            { label: "八步區", value: "八步區" }
          ]
        },
        {
          label: "百色市",
          value: "百色市",
          children: [
            { label: "右江區", value: "右江區" },
            { label: "平果縣", value: "平果縣" },
            { label: "樂業縣", value: "樂業縣" },
            { label: "田陽縣", value: "田陽縣" },
            { label: "西林縣", value: "西林縣" },
            { label: "田林縣", value: "田林縣" },
            { label: "德保縣", value: "德保縣" },
            { label: "靖西縣", value: "靖西縣" },
            { label: "田東縣", value: "田東縣" },
            { label: "那坡縣", value: "那坡縣" },
            { label: "隆林縣", value: "隆林縣" },
            { label: "凌雲縣", value: "凌雲縣" }
          ]
        },
        {
          label: "河池市",
          value: "河池市",
          children: [
            { label: "宜州市", value: "宜州市" },
            { label: "天峨縣", value: "天峨縣" },
            { label: "鳳山縣", value: "鳳山縣" },
            { label: "南丹縣", value: "南丹縣" },
            { label: "東蘭縣", value: "東蘭縣" },
            { label: "巴馬縣", value: "巴馬縣" },
            { label: "環江縣", value: "環江縣" },
            { label: "羅城縣", value: "羅城縣" },
            { label: "大化縣", value: "大化縣" },
            { label: "都安縣", value: "都安縣" },
            { label: "金城江區", value: "金城江區" }
          ]
        },
        {
          label: "來賓市",
          value: "來賓市",
          children: [
            { label: "興賓區", value: "興賓區" },
            { label: "合山市", value: "合山市" },
            { label: "忻城縣", value: "忻城縣" },
            { label: "武宣縣", value: "武宣縣" },
            { label: "象州縣", value: "象州縣" },
            { label: "金秀縣", value: "金秀縣" }
          ]
        },
        {
          label: "崇左市",
          value: "崇左市",
          children: [
            { label: "江州區", value: "江州區" },
            { label: "憑祥市", value: "憑祥市" },
            { label: "扶綏縣", value: "扶綏縣" },
            { label: "大新縣", value: "大新縣" },
            { label: "天等縣", value: "天等縣" },
            { label: "寧明縣", value: "寧明縣" },
            { label: "龍州縣", value: "龍州縣" }
          ]
        }
      ]
    },
    {
      label: "江西",
      value: "江西",
      children: [
        {
          label: "南昌市",
          value: "南昌市",
          children: [
            { label: "南昌縣", value: "南昌縣" },
            { label: "進賢縣", value: "進賢縣" },
            { label: "安義縣", value: "安義縣" },
            { label: "新建縣", value: "新建縣" },
            { label: "灣里區", value: "灣里區" },
            { label: "青雲譜區", value: "青雲譜區" },
            { label: "西湖區", value: "西湖區" },
            { label: "東湖區", value: "東湖區" },
            { label: "高新區", value: "高新區" },
            { label: "昌北區", value: "昌北區" },
            { label: "青山湖區", value: "青山湖區" },
            { label: "紅谷灘新區", value: "紅谷灘新區" }
          ]
        },
        {
          label: "景德鎮市",
          value: "景德鎮市",
          children: [
            { label: "樂平市", value: "樂平市" },
            { label: "浮梁縣", value: "浮梁縣" },
            { label: "珠山區", value: "珠山區" },
            { label: "昌江區", value: "昌江區" }
          ]
        },
        {
          label: "萍鄉市",
          value: "萍鄉市",
          children: [
            { label: "湘東區", value: "湘東區" },
            { label: "蓮花縣", value: "蓮花縣" },
            { label: "上栗縣", value: "上栗縣" },
            { label: "蘆溪縣", value: "蘆溪縣" },
            { label: "安源區", value: "安源區" }
          ]
        },
        {
          label: "新余市",
          value: "新余市",
          children: [
            { label: "分宜縣", value: "分宜縣" },
            { label: "渝水區", value: "渝水區" }
          ]
        },
        {
          label: "九江市",
          value: "九江市",
          children: [
            { label: "九江縣", value: "九江縣" },
            { label: "瑞昌市", value: "瑞昌市" },
            { label: "星子縣", value: "星子縣" },
            { label: "武寧縣", value: "武寧縣" },
            { label: "彭澤縣", value: "彭澤縣" },
            { label: "永修縣", value: "永修縣" },
            { label: "修水縣", value: "修水縣" },
            { label: "湖口縣", value: "湖口縣" },
            { label: "德安縣", value: "德安縣" },
            { label: "都昌縣", value: "都昌縣" },
            { label: "共青城市", value: "共青城市" },
            { label: "經濟技術開發區", value: "經濟技術開發區" },
            { label: "八里湖新區", value: "八里湖新區" },
            { label: "廬山風景名勝區", value: "廬山風景名勝區" },
            { label: "廬山區", value: "廬山區" },
            { label: "潯陽區", value: "潯陽區" }
          ]
        },
        {
          label: "鷹潭市",
          value: "鷹潭市",
          children: [
            { label: "余江縣", value: "余江縣" },
            { label: "貴溪市", value: "貴溪市" },
            { label: "月湖區", value: "月湖區" },
            { label: "龍虎山風景旅遊區", value: "龍虎山風景旅遊區" }
          ]
        },
        {
          label: "上饒市",
          value: "上饒市",
          children: [
            { label: "德興市", value: "德興市" },
            { label: "廣豐縣", value: "廣豐縣" },
            { label: "鄱陽縣", value: "鄱陽縣" },
            { label: "婺源縣", value: "婺源縣" },
            { label: "余干縣", value: "余干縣" },
            { label: "橫峰縣", value: "橫峰縣" },
            { label: "弋陽縣", value: "弋陽縣" },
            { label: "鉛山縣", value: "鉛山縣" },
            { label: "玉山縣", value: "玉山縣" },
            { label: "萬年縣", value: "萬年縣" },
            { label: "信州區", value: "信州區" },
            { label: "上饒縣", value: "上饒縣" }
          ]
        },
        {
          label: "宜春市",
          value: "宜春市",
          children: [
            { label: "豐城市", value: "豐城市" },
            { label: "樟樹市", value: "樟樹市" },
            { label: "高安市", value: "高安市" },
            { label: "銅鼓縣", value: "銅鼓縣" },
            { label: "靖安縣", value: "靖安縣" },
            { label: "宜豐縣", value: "宜豐縣" },
            { label: "奉新縣", value: "奉新縣" },
            { label: "萬載縣", value: "萬載縣" },
            { label: "上高縣", value: "上高縣" },
            { label: "袁州區", value: "袁州區" }
          ]
        },
        {
          label: "撫州市",
          value: "撫州市",
          children: [
            { label: "南豐縣", value: "南豐縣" },
            { label: "樂安縣", value: "樂安縣" },
            { label: "金溪縣", value: "金溪縣" },
            { label: "南城縣", value: "南城縣" },
            { label: "東鄉縣", value: "東鄉縣" },
            { label: "資溪縣", value: "資溪縣" },
            { label: "宜黃縣", value: "宜黃縣" },
            { label: "崇仁縣", value: "崇仁縣" },
            { label: "黎川縣", value: "黎川縣" },
            { label: "廣昌縣", value: "廣昌縣" },
            { label: "臨川區", value: "臨川區" }
          ]
        },
        {
          label: "吉安市",
          value: "吉安市",
          children: [
            { label: "井岡山市", value: "井岡山市" },
            { label: "吉安縣", value: "吉安縣" },
            { label: "永豐縣", value: "永豐縣" },
            { label: "永新縣", value: "永新縣" },
            { label: "新干縣", value: "新干縣" },
            { label: "泰和縣", value: "泰和縣" },
            { label: "峽江縣", value: "峽江縣" },
            { label: "遂川縣", value: "遂川縣" },
            { label: "安福縣", value: "安福縣" },
            { label: "吉水縣", value: "吉水縣" },
            { label: "萬安縣", value: "萬安縣" },
            { label: "青原區", value: "青原區" },
            { label: "吉州區", value: "吉州區" }
          ]
        },
        {
          label: "贛州市",
          value: "贛州市",
          children: [
            { label: "南康市", value: "南康市" },
            { label: "瑞金市", value: "瑞金市" },
            { label: "石城縣", value: "石城縣" },
            { label: "安遠縣", value: "安遠縣" },
            { label: "贛縣", value: "贛縣" },
            { label: "寧都縣", value: "寧都縣" },
            { label: "尋烏縣", value: "尋烏縣" },
            { label: "興國縣", value: "興國縣" },
            { label: "定南縣", value: "定南縣" },
            { label: "上猶縣", value: "上猶縣" },
            { label: "于都縣", value: "于都縣" },
            { label: "龍南縣", value: "龍南縣" },
            { label: "崇義縣", value: "崇義縣" },
            { label: "大余縣", value: "大余縣" },
            { label: "信豐縣", value: "信豐縣" },
            { label: "全南縣", value: "全南縣" },
            { label: "會昌縣", value: "會昌縣" },
            { label: "章貢區", value: "章貢區" }
          ]
        }
      ]
    },
    {
      label: "四川",
      value: "四川",
      children: [
        {
          label: "成都市",
          value: "成都市",
          children: [
            { label: "高新西區", value: "高新西區" },
            { label: "新都區", value: "新都區" },
            { label: "溫江區", value: "溫江區" },
            { label: "龍泉驛區", value: "龍泉驛區" },
            { label: "青白江區", value: "青白江區" },
            { label: "彭州市", value: "彭州市" },
            { label: "崇州市", value: "崇州市" },
            { label: "邛崍市", value: "邛崍市" },
            { label: "都江堰市", value: "都江堰市" },
            { label: "郫縣", value: "郫縣" },
            { label: "新津縣", value: "新津縣" },
            { label: "雙流縣", value: "雙流縣" },
            { label: "大邑縣", value: "大邑縣" },
            { label: "蒲江縣", value: "蒲江縣" },
            { label: "金堂縣", value: "金堂縣" },
            { label: "青羊區", value: "青羊區" },
            { label: "錦江區", value: "錦江區" },
            { label: "金牛區", value: "金牛區" },
            { label: "武侯區", value: "武侯區" },
            { label: "成華區", value: "成華區" },
            { label: "高新區", value: "高新區" }
          ]
        },
        {
          label: "自貢市",
          value: "自貢市",
          children: [
            { label: "榮縣", value: "榮縣" },
            { label: "富順縣", value: "富順縣" },
            { label: "自流井區", value: "自流井區" },
            { label: "沿灘區", value: "沿灘區" },
            { label: "大安區", value: "大安區" },
            { label: "貢井區", value: "貢井區" }
          ]
        },
        {
          label: "攀枝花市",
          value: "攀枝花市",
          children: [
            { label: "米易縣", value: "米易縣" },
            { label: "鹽邊縣", value: "鹽邊縣" },
            { label: "仁和區", value: "仁和區" },
            { label: "西區", value: "西區" },
            { label: "東區", value: "東區" }
          ]
        },
        {
          label: "瀘州市",
          value: "瀘州市",
          children: [
            { label: "瀘縣", value: "瀘縣" },
            { label: "合江縣", value: "合江縣" },
            { label: "敘永縣", value: "敘永縣" },
            { label: "古藺縣", value: "古藺縣" },
            { label: "納溪區", value: "納溪區" },
            { label: "江陽區", value: "江陽區" },
            { label: "龍馬潭區", value: "龍馬潭區" }
          ]
        },
        {
          label: "綿陽市",
          value: "綿陽市",
          children: [
            { label: "鹽亭縣", value: "鹽亭縣" },
            { label: "三台縣", value: "三台縣" },
            { label: "平武縣", value: "平武縣" },
            { label: "北川縣", value: "北川縣" },
            { label: "安縣", value: "安縣" },
            { label: "梓潼縣", value: "梓潼縣" },
            { label: "江油市", value: "江油市" },
            { label: "涪城區", value: "涪城區" },
            { label: "遊仙區", value: "遊仙區" },
            { label: "高新區", value: "高新區" },
            { label: "經開區", value: "經開區" }
          ]
        },
        {
          label: "德陽市",
          value: "德陽市",
          children: [
            { label: "羅江縣", value: "羅江縣" },
            { label: "中江縣", value: "中江縣" },
            { label: "廣漢市", value: "廣漢市" },
            { label: "什邡市", value: "什邡市" },
            { label: "旌陽區", value: "旌陽區" },
            { label: "綿竹市", value: "綿竹市" }
          ]
        },
        {
          label: "廣元市",
          value: "廣元市",
          children: [
            { label: "青川縣", value: "青川縣" },
            { label: "旺蒼縣", value: "旺蒼縣" },
            { label: "劍閣縣", value: "劍閣縣" },
            { label: "蒼溪縣", value: "蒼溪縣" },
            { label: "昭化區", value: "昭化區" },
            { label: "朝天區", value: "朝天區" },
            { label: "利州區", value: "利州區" }
          ]
        },
        {
          label: "遂寧市",
          value: "遂寧市",
          children: [
            { label: "射洪縣", value: "射洪縣" },
            { label: "蓬溪縣", value: "蓬溪縣" },
            { label: "大英縣", value: "大英縣" },
            { label: "安居區", value: "安居區" },
            { label: "船山區", value: "船山區" }
          ]
        },
        {
          label: "內江市",
          value: "內江市",
          children: [
            { label: "資中縣", value: "資中縣" },
            { label: "隆昌縣", value: "隆昌縣" },
            { label: "威遠縣", value: "威遠縣" },
            { label: "市中區", value: "市中區" },
            { label: "東興區", value: "東興區" }
          ]
        },
        {
          label: "樂山市",
          value: "樂山市",
          children: [
            { label: "五通橋區", value: "五通橋區" },
            { label: "沙灣區", value: "沙灣區" },
            { label: "金口河區", value: "金口河區" },
            { label: "夾江縣", value: "夾江縣" },
            { label: "井研縣", value: "井研縣" },
            { label: "犍為縣", value: "犍為縣" },
            { label: "沐川縣", value: "沐川縣" },
            { label: "峨邊縣", value: "峨邊縣" },
            { label: "馬邊縣", value: "馬邊縣" },
            { label: "市中區", value: "市中區" },
            { label: "峨眉山市", value: "峨眉山市" }
          ]
        },
        {
          label: "宜賓市",
          value: "宜賓市",
          children: [
            { label: "宜賓縣", value: "宜賓縣" },
            { label: "南溪區", value: "南溪區" },
            { label: "江安縣", value: "江安縣" },
            { label: "長寧縣", value: "長寧縣" },
            { label: "興文縣", value: "興文縣" },
            { label: "珙縣", value: "珙縣" },
            { label: "高縣", value: "高縣" },
            { label: "屏山縣", value: "屏山縣" },
            { label: "筠連縣", value: "筠連縣" },
            { label: "翠屏區", value: "翠屏區" }
          ]
        },
        {
          label: "廣安市",
          value: "廣安市",
          children: [
            { label: "岳池縣", value: "岳池縣" },
            { label: "武勝縣", value: "武勝縣" },
            { label: "鄰水縣", value: "鄰水縣" },
            { label: "廣安區", value: "廣安區" },
            { label: "華鎣市", value: "華鎣市" },
            { label: "前鋒區", value: "前鋒區" }
          ]
        },
        {
          label: "南充市",
          value: "南充市",
          children: [
            { label: "儀隴縣", value: "儀隴縣" },
            { label: "蓬安縣", value: "蓬安縣" },
            { label: "營山縣", value: "營山縣" },
            { label: "南部縣", value: "南部縣" },
            { label: "順慶區", value: "順慶區" },
            { label: "高坪區", value: "高坪區" },
            { label: "嘉陵區", value: "嘉陵區" },
            { label: "西充縣", value: "西充縣" },
            { label: "閬中市", value: "閬中市" }
          ]
        },
        {
          label: "達州市",
          value: "達州市",
          children: [
            { label: "通川區", value: "通川區" },
            { label: "達川區", value: "達川區" },
            { label: "大竹縣", value: "大竹縣" },
            { label: "渠縣", value: "渠縣" },
            { label: "萬源市", value: "萬源市" },
            { label: "宣漢縣", value: "宣漢縣" },
            { label: "開江縣", value: "開江縣" }
          ]
        },
        {
          label: "巴中市",
          value: "巴中市",
          children: [
            { label: "南江縣", value: "南江縣" },
            { label: "平昌縣", value: "平昌縣" },
            { label: "通江縣", value: "通江縣" },
            { label: "巴州區", value: "巴州區" },
            { label: "恩陽區", value: "恩陽區" }
          ]
        },
        {
          label: "雅安市",
          value: "雅安市",
          children: [
            { label: "蘆山縣", value: "蘆山縣" },
            { label: "石棉縣", value: "石棉縣" },
            { label: "名山區", value: "名山區" },
            { label: "天全縣", value: "天全縣" },
            { label: "滎經縣", value: "滎經縣" },
            { label: "漢源縣", value: "漢源縣" },
            { label: "寶興縣", value: "寶興縣" },
            { label: "雨城區", value: "雨城區" }
          ]
        },
        {
          label: "眉山市",
          value: "眉山市",
          children: [
            { label: "仁壽縣", value: "仁壽縣" },
            { label: "彭山區", value: "彭山區" },
            { label: "洪雅縣", value: "洪雅縣" },
            { label: "丹棱縣", value: "丹棱縣" },
            { label: "青神縣", value: "青神縣" },
            { label: "東坡區", value: "東坡區" }
          ]
        },
        {
          label: "資陽市",
          value: "資陽市",
          children: [
            { label: "安岳縣", value: "安岳縣" },
            { label: "樂至縣", value: "樂至縣" },
            { label: "雁江區", value: "雁江區" },
            { label: "簡陽市", value: "簡陽市" }
          ]
        },
        {
          label: "阿壩州",
          value: "阿壩州",
          children: [
            { label: "馬爾康縣", value: "馬爾康縣" },
            { label: "九寨溝縣", value: "九寨溝縣" },
            { label: "紅原縣", value: "紅原縣" },
            { label: "阿壩縣", value: "阿壩縣" },
            { label: "理縣", value: "理縣" },
            { label: "若爾蓋縣", value: "若爾蓋縣" },
            { label: "金川縣", value: "金川縣" },
            { label: "小金縣", value: "小金縣" },
            { label: "黑水縣", value: "黑水縣" },
            { label: "松潘縣", value: "松潘縣" },
            { label: "壤塘縣", value: "壤塘縣" },
            { label: "茂縣", value: "茂縣" },
            { label: "汶川縣", value: "汶川縣" }
          ]
        },
        {
          label: "甘孜州",
          value: "甘孜州",
          children: [
            { label: "康定縣", value: "康定縣" },
            { label: "瀘定縣", value: "瀘定縣" },
            { label: "九龍縣", value: "九龍縣" },
            { label: "丹巴縣", value: "丹巴縣" },
            { label: "道孚縣", value: "道孚縣" },
            { label: "爐霍縣", value: "爐霍縣" },
            { label: "色達縣", value: "色達縣" },
            { label: "甘孜縣", value: "甘孜縣" },
            { label: "新龍縣", value: "新龍縣" },
            { label: "白玉縣", value: "白玉縣" },
            { label: "德格縣", value: "德格縣" },
            { label: "石渠縣", value: "石渠縣" },
            { label: "雅江縣", value: "雅江縣" },
            { label: "理塘縣", value: "理塘縣" },
            { label: "巴塘縣", value: "巴塘縣" },
            { label: "稻城縣", value: "稻城縣" },
            { label: "鄉城縣", value: "鄉城縣" },
            { label: "得榮縣", value: "得榮縣" }
          ]
        },
        {
          label: "涼山州",
          value: "涼山州",
          children: [
            { label: "美姑縣", value: "美姑縣" },
            { label: "昭覺縣", value: "昭覺縣" },
            { label: "會理縣", value: "會理縣" },
            { label: "會東縣", value: "會東縣" },
            { label: "普格縣", value: "普格縣" },
            { label: "寧南縣", value: "寧南縣" },
            { label: "德昌縣", value: "德昌縣" },
            { label: "冕寧縣", value: "冕寧縣" },
            { label: "鹽源縣", value: "鹽源縣" },
            { label: "金陽縣", value: "金陽縣" },
            { label: "布拖縣", value: "布拖縣" },
            { label: "雷波縣", value: "雷波縣" },
            { label: "越西縣", value: "越西縣" },
            { label: "喜德縣", value: "喜德縣" },
            { label: "甘洛縣", value: "甘洛縣" },
            { label: "木里縣", value: "木里縣" },
            { label: "西昌市", value: "西昌市" }
          ]
        }
      ]
    },
    {
      label: "海南",
      value: "海南",
      children: [
        {
          label: "海口市",
          value: "海口市",
          children: [
            { label: "秀英區", value: "秀英區" },
            { label: "龍華區", value: "龍華區" },
            { label: "瓊山區", value: "瓊山區" },
            { label: "美蘭區", value: "美蘭區" }
          ]
        },
        {
          label: "儋州市",
          value: "儋州市",
          children: [
            { label: "那大鎮", value: "那大鎮" },
            { label: "和慶鎮", value: "和慶鎮" },
            { label: "南豐鎮", value: "南豐鎮" },
            { label: "大成鎮", value: "大成鎮" },
            { label: "雅星鎮", value: "雅星鎮" },
            { label: "蘭洋鎮", value: "蘭洋鎮" },
            { label: "光村鎮", value: "光村鎮" },
            { label: "木棠鎮", value: "木棠鎮" },
            { label: "海頭鎮", value: "海頭鎮" },
            { label: "峨蔓鎮", value: "峨蔓鎮" },
            { label: "三都鎮", value: "三都鎮" },
            { label: "王五鎮", value: "王五鎮" },
            { label: "白馬井鎮", value: "白馬井鎮" },
            { label: "中和鎮", value: "中和鎮" },
            { label: "排浦鎮", value: "排浦鎮" },
            { label: "東成鎮", value: "東成鎮" },
            { label: "新州鎮", value: "新州鎮" },
            { label: "洋浦經濟開發區", value: "洋浦經濟開發區" },
            { label: "富克鎮", value: "富克鎮" },
            { label: "西培農場", value: "西培農場" },
            { label: "西聯農場", value: "西聯農場" },
            { label: "藍洋農場", value: "藍洋農場" },
            { label: "八一農場", value: "八一農場" },
            { label: "西華農場", value: "西華農場" },
            { label: "西慶農場", value: "西慶農場" },
            { label: "西流農場", value: "西流農場" },
            { label: "新盈農場", value: "新盈農場" },
            { label: "龍山農場", value: "龍山農場" },
            { label: "紅嶺農場", value: "紅嶺農場" },
            { label: "熱作學院", value: "熱作學院" }
          ]
        },
        {
          label: "瓊海市",
          value: "瓊海市",
          children: [
            { label: "嘉積鎮", value: "嘉積鎮" },
            { label: "萬泉鎮", value: "萬泉鎮" },
            { label: "石壁鎮", value: "石壁鎮" },
            { label: "中原鎮", value: "中原鎮" },
            { label: "博鰲鎮", value: "博鰲鎮" },
            { label: "陽江鎮", value: "陽江鎮" },
            { label: "龍江鎮", value: "龍江鎮" },
            { label: "潭門鎮", value: "潭門鎮" },
            { label: "塔洋鎮", value: "塔洋鎮" },
            { label: "長坡鎮", value: "長坡鎮" },
            { label: "大路鎮", value: "大路鎮" },
            { label: "會山鎮", value: "會山鎮" },
            { label: "彬村山華僑農場", value: "彬村山華僑農場" },
            { label: "東太農場", value: "東太農場" },
            { label: "東紅農場", value: "東紅農場" },
            { label: "東升農場", value: "東升農場" },
            { label: "南俸農場", value: "南俸農場" }
          ]
        },
        {
          label: "萬寧市",
          value: "萬寧市",
          children: [
            { label: "萬城鎮", value: "萬城鎮" },
            { label: "龍滾鎮", value: "龍滾鎮" },
            { label: "和樂鎮", value: "和樂鎮" },
            { label: "後安鎮", value: "後安鎮" },
            { label: "大茂鎮", value: "大茂鎮" },
            { label: "東澳鎮", value: "東澳鎮" },
            { label: "禮紀鎮", value: "禮紀鎮" },
            { label: "長豐鎮", value: "長豐鎮" },
            { label: "山根鎮", value: "山根鎮" },
            { label: "北大鎮", value: "北大鎮" },
            { label: "南橋鎮", value: "南橋鎮" },
            { label: "三更羅鎮", value: "三更羅鎮" },
            { label: "六連林場", value: "六連林場" },
            { label: "東興農場", value: "東興農場" },
            { label: "東和農場", value: "東和農場" },
            { label: "新中農場", value: "新中農場" },
            { label: "興隆華僑農場", value: "興隆華僑農場" },
            { label: "興隆鎮", value: "興隆鎮" },
            { label: "南林農場", value: "南林農場" }
          ]
        },
        {
          label: "東方市",
          value: "東方市",
          children: [
            { label: "八所鎮", value: "八所鎮" },
            { label: "東河鎮", value: "東河鎮" },
            { label: "大田鎮", value: "大田鎮" },
            { label: "感城鎮", value: "感城鎮" },
            { label: "板橋鎮", value: "板橋鎮" },
            { label: "三家鎮", value: "三家鎮" },
            { label: "四更鎮", value: "四更鎮" },
            { label: "新龍鎮", value: "新龍鎮" },
            { label: "天安鄉", value: "天安鄉" },
            { label: "江邊鄉", value: "江邊鄉" },
            { label: "廣壩農場", value: "廣壩農場" },
            { label: "東方華僑農場", value: "東方華僑農場" }
          ]
        },
        {
          label: "三亞市",
          value: "三亞市",
          children: [
            { label: "海棠灣鎮", value: "海棠灣鎮" },
            { label: "吉陽鎮", value: "吉陽鎮" },
            { label: "鳳凰鎮", value: "鳳凰鎮" },
            { label: "天涯鎮", value: "天涯鎮" },
            { label: "育才鎮", value: "育才鎮" },
            { label: "崖城鎮", value: "崖城鎮" },
            { label: "河西區", value: "河西區" },
            { label: "河東區", value: "河東區" },
            { label: "南田農場", value: "南田農場" },
            { label: "南新農場", value: "南新農場" },
            { label: "南島農場", value: "南島農場" },
            { label: "立才農場", value: "立才農場" },
            { label: "南濱農場", value: "南濱農場" }
          ]
        },
        {
          label: "文昌市",
          value: "文昌市",
          children: [
            { label: "文城鎮", value: "文城鎮" },
            { label: "重興鎮", value: "重興鎮" },
            { label: "蓬萊鎮", value: "蓬萊鎮" },
            { label: "會文鎮", value: "會文鎮" },
            { label: "東路鎮", value: "東路鎮" },
            { label: "潭牛鎮", value: "潭牛鎮" },
            { label: "東閣鎮", value: "東閣鎮" },
            { label: "文教鎮", value: "文教鎮" },
            { label: "東郊鎮", value: "東郊鎮" },
            { label: "龍樓鎮", value: "龍樓鎮" },
            { label: "昌灑鎮", value: "昌灑鎮" },
            { label: "翁田鎮", value: "翁田鎮" },
            { label: "抱羅鎮", value: "抱羅鎮" },
            { label: "馮坡鎮", value: "馮坡鎮" },
            { label: "錦山鎮", value: "錦山鎮" },
            { label: "鋪前鎮", value: "鋪前鎮" },
            { label: "公坡鎮", value: "公坡鎮" },
            { label: "邁號鎮", value: "邁號鎮" },
            { label: "清讕鎮", value: "清讕鎮" },
            { label: "南陽鎮", value: "南陽鎮" },
            { label: "新橋鎮", value: "新橋鎮" },
            { label: "頭苑鎮", value: "頭苑鎮" },
            { label: "寶芳鄉", value: "寶芳鄉" },
            { label: "龍馬鄉", value: "龍馬鄉" },
            { label: "湖山鄉", value: "湖山鄉" },
            { label: "東路農場", value: "東路農場" },
            { label: "南陽農場", value: "南陽農場" },
            { label: "羅豆農場", value: "羅豆農場" },
            { label: "橡膠研究所", value: "橡膠研究所" }
          ]
        },
        {
          label: "五指山市",
          value: "五指山市",
          children: [
            { label: "通什鎮", value: "通什鎮" },
            { label: "南聖鎮", value: "南聖鎮" },
            { label: "毛陽鎮", value: "毛陽鎮" },
            { label: "番陽鎮", value: "番陽鎮" },
            { label: "暢好鄉", value: "暢好鄉" },
            { label: "毛道鄉", value: "毛道鄉" },
            { label: "水滿鄉", value: "水滿鄉" },
            { label: "暢好農場", value: "暢好農場" }
          ]
        },
        {
          label: "臨高縣",
          value: "臨高縣",
          children: [
            { label: "臨城鎮", value: "臨城鎮" },
            { label: "波蓮鎮", value: "波蓮鎮" },
            { label: "東英鎮", value: "東英鎮" },
            { label: "博厚鎮", value: "博厚鎮" },
            { label: "皇桐鎮", value: "皇桐鎮" },
            { label: "多文鎮", value: "多文鎮" },
            { label: "和舍鎮", value: "和舍鎮" },
            { label: "南寶鎮", value: "南寶鎮" },
            { label: "新盈鎮", value: "新盈鎮" },
            { label: "調樓鎮", value: "調樓鎮" },
            { label: "加來鎮", value: "加來鎮" },
            { label: "紅華農場", value: "紅華農場" },
            { label: "加來農場", value: "加來農場" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "澄邁縣",
          value: "澄邁縣",
          children: [
            { label: "金江鎮", value: "金江鎮" },
            { label: "老城鎮", value: "老城鎮" },
            { label: "瑞溪鎮", value: "瑞溪鎮" },
            { label: "永發鎮", value: "永發鎮" },
            { label: "加樂鎮", value: "加樂鎮" },
            { label: "文儒鎮", value: "文儒鎮" },
            { label: "中興鎮", value: "中興鎮" },
            { label: "仁興鎮", value: "仁興鎮" },
            { label: "福山鎮", value: "福山鎮" },
            { label: "橋頭鎮", value: "橋頭鎮" },
            { label: "大豐鎮", value: "大豐鎮" },
            { label: "紅光農場", value: "紅光農場" },
            { label: "西達農場", value: "西達農場" },
            { label: "金安農場", value: "金安農場" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "定安縣",
          value: "定安縣",
          children: [
            { label: "定城鎮", value: "定城鎮" },
            { label: "新竹鎮", value: "新竹鎮" },
            { label: "龍湖鎮", value: "龍湖鎮" },
            { label: "雷鳴鎮", value: "雷鳴鎮" },
            { label: "龍門鎮", value: "龍門鎮" },
            { label: "龍河鎮", value: "龍河鎮" },
            { label: "嶺口鎮", value: "嶺口鎮" },
            { label: "翰林鎮", value: "翰林鎮" },
            { label: "富文鎮", value: "富文鎮" },
            { label: "黃竹鎮", value: "黃竹鎮" },
            { label: "金雞嶺農場", value: "金雞嶺農場" },
            { label: "中瑞農場", value: "中瑞農場" },
            { label: "南海農場", value: "南海農場" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "屯昌縣",
          value: "屯昌縣",
          children: [
            { label: "屯城鎮", value: "屯城鎮" },
            { label: "新興鎮", value: "新興鎮" },
            { label: "楓木鎮", value: "楓木鎮" },
            { label: "烏坡鎮", value: "烏坡鎮" },
            { label: "南呂鎮", value: "南呂鎮" },
            { label: "南坤鎮", value: "南坤鎮" },
            { label: "坡心鎮", value: "坡心鎮" },
            { label: "西昌鎮", value: "西昌鎮" },
            { label: "中建農場", value: "中建農場" },
            { label: "中坤農場", value: "中坤農場" },
            { label: "縣城內", value: "縣城內" }
          ]
        },
        {
          label: "昌江縣",
          value: "昌江縣",
          children: [
            { label: "石碌鎮", value: "石碌鎮" },
            { label: "叉河鎮", value: "叉河鎮" },
            { label: "十月田鎮", value: "十月田鎮" },
            { label: "烏烈鎮", value: "烏烈鎮" },
            { label: "昌化鎮", value: "昌化鎮" },
            { label: "海尾鎮", value: "海尾鎮" },
            { label: "七叉鎮", value: "七叉鎮" },
            { label: "王下鄉", value: "王下鄉" },
            { label: "海南礦業公司", value: "海南礦業公司" },
            { label: "霸王嶺林場", value: "霸王嶺林場" },
            { label: "紅林農場", value: "紅林農場" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "白沙縣",
          value: "白沙縣",
          children: [
            { label: "牙叉鎮", value: "牙叉鎮" },
            { label: "七坊鎮", value: "七坊鎮" },
            { label: "邦溪鎮", value: "邦溪鎮" },
            { label: "打安鎮", value: "打安鎮" },
            { label: "細水鄉", value: "細水鄉" },
            { label: "元門鄉", value: "元門鄉" },
            { label: "南開鄉", value: "南開鄉" },
            { label: "阜龍鄉", value: "阜龍鄉" },
            { label: "青松鄉", value: "青松鄉" },
            { label: "金波鄉", value: "金波鄉" },
            { label: "榮邦鄉", value: "榮邦鄉" },
            { label: "白沙農場", value: "白沙農場" },
            { label: "龍江農場", value: "龍江農場" },
            { label: "邦溪農場", value: "邦溪農場" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "瓊中縣",
          value: "瓊中縣",
          children: [
            { label: "營根鎮", value: "營根鎮" },
            { label: "灣嶺鎮", value: "灣嶺鎮" },
            { label: "黎母山鎮", value: "黎母山鎮" },
            { label: "和平鎮", value: "和平鎮" },
            { label: "長征鎮", value: "長征鎮" },
            { label: "紅毛鎮", value: "紅毛鎮" },
            { label: "中平鎮", value: "中平鎮" },
            { label: "上安鄉", value: "上安鄉" },
            { label: "什運鄉", value: "什運鄉" },
            { label: "吊羅山鄉", value: "吊羅山鄉" },
            { label: "黎母山林業公司", value: "黎母山林業公司" },
            { label: "陽江農場", value: "陽江農場" },
            { label: "烏石農場", value: "烏石農場" },
            { label: "加釵農場", value: "加釵農場" },
            { label: "長征農場", value: "長征農場" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "陵水縣",
          value: "陵水縣",
          children: [
            { label: "椰林鎮", value: "椰林鎮" },
            { label: "光坡鎮", value: "光坡鎮" },
            { label: "三才鎮", value: "三才鎮" },
            { label: "英州鎮", value: "英州鎮" },
            { label: "隆廣鎮", value: "隆廣鎮" },
            { label: "文羅鎮", value: "文羅鎮" },
            { label: "本號鎮", value: "本號鎮" },
            { label: "新村鎮", value: "新村鎮" },
            { label: "黎安鎮", value: "黎安鎮" },
            { label: "提蒙鄉", value: "提蒙鄉" },
            { label: "群英鄉", value: "群英鄉" },
            { label: "吊羅山林業公司", value: "吊羅山林業公司" },
            { label: "嶺門農場", value: "嶺門農場" },
            { label: "南平農場", value: "南平農場" },
            { label: "城區", value: "城區" },
            { label: "東華鎮", value: "東華鎮" },
            { label: "南平鎮", value: "南平鎮" }
          ]
        },
        {
          label: "保亭縣",
          value: "保亭縣",
          children: [
            { label: "保城鎮", value: "保城鎮" },
            { label: "什玲鎮", value: "什玲鎮" },
            { label: "加茂鎮", value: "加茂鎮" },
            { label: "響水鎮", value: "響水鎮" },
            { label: "新政鎮", value: "新政鎮" },
            { label: "三道鎮", value: "三道鎮" },
            { label: "六弓鄉", value: "六弓鄉" },
            { label: "南林鄉", value: "南林鄉" },
            { label: "毛感鄉", value: "毛感鄉" },
            { label: "保亭研究所", value: "保亭研究所" },
            { label: "新星農場", value: "新星農場" },
            { label: "金江農場", value: "金江農場" },
            { label: "三道農場", value: "三道農場" }
          ]
        },
        {
          label: "樂東縣",
          value: "樂東縣",
          children: [
            { label: "抱由鎮", value: "抱由鎮" },
            { label: "萬沖鎮", value: "萬沖鎮" },
            { label: "大安鎮", value: "大安鎮" },
            { label: "志仲鎮", value: "志仲鎮" },
            { label: "千家鎮", value: "千家鎮" },
            { label: "九所鎮", value: "九所鎮" },
            { label: "利國鎮", value: "利國鎮" },
            { label: "黃流鎮", value: "黃流鎮" },
            { label: "佛羅鎮", value: "佛羅鎮" },
            { label: "尖峰鎮", value: "尖峰鎮" },
            { label: "鶯歌海鎮", value: "鶯歌海鎮" },
            { label: "尖峰嶺林業公司", value: "尖峰嶺林業公司" },
            { label: "鶯歌海鹽場", value: "鶯歌海鹽場" },
            { label: "山榮農場", value: "山榮農場" },
            { label: "樂光農場", value: "樂光農場" },
            { label: "保國農場", value: "保國農場" },
            { label: "城區", value: "城區" }
          ]
        },
        {
          label: "三沙市",
          value: "三沙市",
          children: [
            { label: "西沙群島", value: "西沙群島" },
            { label: "南沙群島", value: "南沙群島" },
            { label: "中沙群島", value: "中沙群島" }
          ]
        }
      ]
    },
    {
      label: "貴州",
      value: "貴州",
      children: [
        {
          label: "貴陽市",
          value: "貴陽市",
          children: [
            { label: "清鎮市", value: "清鎮市" },
            { label: "開陽縣", value: "開陽縣" },
            { label: "修文縣", value: "修文縣" },
            { label: "息烽縣", value: "息烽縣" },
            { label: "烏當區", value: "烏當區" },
            { label: "南明區", value: "南明區" },
            { label: "白雲區", value: "白雲區" },
            { label: "雲岩區", value: "雲岩區" },
            { label: "花溪區", value: "花溪區" },
            { label: "小河區", value: "小河區" },
            { label: "觀山湖區", value: "觀山湖區" }
          ]
        },
        {
          label: "六盤水市",
          value: "六盤水市",
          children: [
            { label: "盤縣", value: "盤縣" },
            { label: "六枝特區", value: "六枝特區" },
            { label: "水城縣", value: "水城縣" },
            { label: "鐘山區", value: "鐘山區" }
          ]
        },
        {
          label: "遵義市",
          value: "遵義市",
          children: [
            { label: "赤水市", value: "赤水市" },
            { label: "仁懷市", value: "仁懷市" },
            { label: "遵義縣", value: "遵義縣" },
            { label: "桐梓縣", value: "桐梓縣" },
            { label: "綏陽縣", value: "綏陽縣" },
            { label: "習水縣", value: "習水縣" },
            { label: "鳳岡縣", value: "鳳岡縣" },
            { label: "正安縣", value: "正安縣" },
            { label: "湄潭縣", value: "湄潭縣" },
            { label: "餘慶縣", value: "餘慶縣" },
            { label: "道真縣", value: "道真縣" },
            { label: "務川縣", value: "務川縣" },
            { label: "紅花崗區", value: "紅花崗區" },
            { label: "匯川區", value: "匯川區" }
          ]
        },
        {
          label: "銅仁市",
          value: "銅仁市",
          children: [
            { label: "碧江區", value: "碧江區" },
            { label: "德江縣", value: "德江縣" },
            { label: "江口縣", value: "江口縣" },
            { label: "思南縣", value: "思南縣" },
            { label: "萬山區", value: "萬山區" },
            { label: "石阡縣", value: "石阡縣" },
            { label: "玉屏侗族自治縣", value: "玉屏侗族自治縣" },
            { label: "松桃苗族自治縣", value: "松桃苗族自治縣" },
            { label: "印江土家族苗族自治縣", value: "印江土家族苗族自治縣" },
            { label: "沿河土家族自治縣", value: "沿河土家族自治縣" }
          ]
        },
        {
          label: "畢節市",
          value: "畢節市",
          children: [
            { label: "黔西縣", value: "黔西縣" },
            { label: "大方縣", value: "大方縣" },
            { label: "織金縣", value: "織金縣" },
            { label: "金沙縣", value: "金沙縣" },
            { label: "赫章縣", value: "赫章縣" },
            { label: "納雍縣", value: "納雍縣" },
            {
              label: "威寧彝族回族苗族自治縣",
              value: "威寧彝族回族苗族自治縣"
            },
            { label: "七星關區", value: "七星關區" }
          ]
        },
        {
          label: "安順市",
          value: "安順市",
          children: [
            { label: "西秀區", value: "西秀區" },
            { label: "普定縣", value: "普定縣" },
            { label: "平壩縣", value: "平壩縣" },
            { label: "鎮寧布依族苗族自治縣", value: "鎮寧布依族苗族自治縣" },
            { label: "關嶺布依族苗族自治縣", value: "關嶺布依族苗族自治縣" },
            { label: "紫雲苗族布依族自治縣", value: "紫雲苗族布依族自治縣" }
          ]
        },
        {
          label: "黔西南州",
          value: "黔西南州",
          children: [
            { label: "興義市", value: "興義市" },
            { label: "望謨縣", value: "望謨縣" },
            { label: "興仁縣", value: "興仁縣" },
            { label: "普安縣", value: "普安縣" },
            { label: "冊亨縣", value: "冊亨縣" },
            { label: "晴隆縣", value: "晴隆縣" },
            { label: "貞豐縣", value: "貞豐縣" },
            { label: "安龍縣", value: "安龍縣" }
          ]
        },
        {
          label: "黔東南州",
          value: "黔東南州",
          children: [
            { label: "凱里市", value: "凱里市" },
            { label: "施秉市", value: "施秉市" },
            { label: "從江縣", value: "從江縣" },
            { label: "錦屏縣", value: "錦屏縣" },
            { label: "鎮遠縣", value: "鎮遠縣" },
            { label: "麻江縣", value: "麻江縣" },
            { label: "台江縣", value: "台江縣" },
            { label: "天柱縣", value: "天柱縣" },
            { label: "黃平縣", value: "黃平縣" },
            { label: "榕江縣", value: "榕江縣" },
            { label: "劍河縣", value: "劍河縣" },
            { label: "三穗縣", value: "三穗縣" },
            { label: "雷山縣", value: "雷山縣" },
            { label: "黎平縣", value: "黎平縣" },
            { label: "岑鞏縣", value: "岑鞏縣" },
            { label: "丹寨縣", value: "丹寨縣" }
          ]
        },
        {
          label: "黔南州",
          value: "黔南州",
          children: [
            { label: "都勻市", value: "都勻市" },
            { label: "福泉市", value: "福泉市" },
            { label: "貴定縣", value: "貴定縣" },
            { label: "惠水縣", value: "惠水縣" },
            { label: "羅甸縣", value: "羅甸縣" },
            { label: "甕安縣", value: "甕安縣" },
            { label: "荔波縣", value: "荔波縣" },
            { label: "龍里縣", value: "龍里縣" },
            { label: "平塘縣", value: "平塘縣" },
            { label: "長順縣", value: "長順縣" },
            { label: "獨山縣", value: "獨山縣" },
            { label: "三都縣", value: "三都縣" }
          ]
        }
      ]
    },
    {
      label: "雲南",
      value: "雲南",
      children: [
        {
          label: "昆明市",
          value: "昆明市",
          children: [
            { label: "東川區", value: "東川區" },
            { label: "安寧市", value: "安寧市" },
            { label: "富民縣", value: "富民縣" },
            { label: "嵩明縣", value: "嵩明縣" },
            { label: "晉寧縣", value: "晉寧縣" },
            { label: "宜良縣", value: "宜良縣" },
            { label: "祿勸縣", value: "祿勸縣" },
            { label: "石林縣", value: "石林縣" },
            { label: "尋甸縣", value: "尋甸縣" },
            { label: "盤龍區", value: "盤龍區" },
            { label: "五華區", value: "五華區" },
            { label: "官渡區", value: "官渡區" },
            { label: "西山區", value: "西山區" },
            { label: "呈貢區", value: "呈貢區" }
          ]
        },
        {
          label: "曲靖市",
          value: "曲靖市",
          children: [
            { label: "馬龍縣", value: "馬龍縣" },
            { label: "宣威市", value: "宣威市" },
            { label: "富源縣", value: "富源縣" },
            { label: "會澤縣", value: "會澤縣" },
            { label: "陸良縣", value: "陸良縣" },
            { label: "師宗縣", value: "師宗縣" },
            { label: "羅平縣", value: "羅平縣" },
            { label: "沾益縣", value: "沾益縣" },
            { label: "麒麟區", value: "麒麟區" }
          ]
        },
        {
          label: "玉溪市",
          value: "玉溪市",
          children: [
            { label: "紅塔區", value: "紅塔區" },
            { label: "華寧縣", value: "華寧縣" },
            { label: "澄江縣", value: "澄江縣" },
            { label: "易門縣", value: "易門縣" },
            { label: "通海縣", value: "通海縣" },
            { label: "江川縣", value: "江川縣" },
            { label: "元江縣", value: "元江縣" },
            { label: "新平縣", value: "新平縣" },
            { label: "峨山縣", value: "峨山縣" }
          ]
        },
        {
          label: "昭通市",
          value: "昭通市",
          children: [
            { label: "昭陽區", value: "昭陽區" },
            { label: "鎮雄縣", value: "鎮雄縣" },
            { label: "永善縣", value: "永善縣" },
            { label: "大關縣", value: "大關縣" },
            { label: "鹽津縣", value: "鹽津縣" },
            { label: "彝良縣", value: "彝良縣" },
            { label: "水富縣", value: "水富縣" },
            { label: "巧家縣", value: "巧家縣" },
            { label: "威信縣", value: "威信縣" },
            { label: "魯甸縣", value: "魯甸縣" },
            { label: "綏江縣", value: "綏江縣" }
          ]
        },
        {
          label: "普洱市",
          value: "普洱市",
          children: [
            { label: "思茅區", value: "思茅區" },
            { label: "寧洱縣", value: "寧洱縣" },
            { label: "景東縣", value: "景東縣" },
            { label: "鎮沅縣", value: "鎮沅縣" },
            { label: "景谷縣", value: "景谷縣" },
            { label: "墨江縣", value: "墨江縣" },
            { label: "瀾滄縣", value: "瀾滄縣" },
            { label: "西盟縣", value: "西盟縣" },
            { label: "江城縣", value: "江城縣" },
            { label: "孟連縣", value: "孟連縣" }
          ]
        },
        {
          label: "臨滄市",
          value: "臨滄市",
          children: [
            { label: "臨翔區", value: "臨翔區" },
            { label: "鎮康縣", value: "鎮康縣" },
            { label: "鳳慶縣", value: "鳳慶縣" },
            { label: "雲縣", value: "雲縣" },
            { label: "永德縣", value: "永德縣" },
            { label: "耿馬縣", value: "耿馬縣" },
            { label: "雙江縣", value: "雙江縣" },
            { label: "滄源縣", value: "滄源縣" }
          ]
        },
        {
          label: "保山市",
          value: "保山市",
          children: [
            { label: "隆陽區", value: "隆陽區" },
            { label: "施甸縣", value: "施甸縣" },
            { label: "昌寧縣", value: "昌寧縣" },
            { label: "龍陵縣", value: "龍陵縣" },
            { label: "騰衝縣", value: "騰衝縣" }
          ]
        },
        {
          label: "麗江市",
          value: "麗江市",
          children: [
            { label: "玉龍縣", value: "玉龍縣" },
            { label: "華坪縣", value: "華坪縣" },
            { label: "永勝縣", value: "永勝縣" },
            { label: "寧蒗縣", value: "寧蒗縣" },
            { label: "古城區", value: "古城區" }
          ]
        },
        {
          label: "文山州",
          value: "文山州",
          children: [
            { label: "文山市", value: "文山市" },
            { label: "麻栗坡縣", value: "麻栗坡縣" },
            { label: "硯山縣", value: "硯山縣" },
            { label: "廣南縣", value: "廣南縣" },
            { label: "馬關縣", value: "馬關縣" },
            { label: "富寧縣", value: "富寧縣" },
            { label: "西疇縣", value: "西疇縣" },
            { label: "丘北縣", value: "丘北縣" }
          ]
        },
        {
          label: "紅河州",
          value: "紅河州",
          children: [
            { label: "箇舊市", value: "箇舊市" },
            { label: "開遠市", value: "開遠市" },
            { label: "彌勒縣", value: "彌勒縣" },
            { label: "紅河縣", value: "紅河縣" },
            { label: "綠春縣", value: "綠春縣" },
            { label: "蒙自市", value: "蒙自市" },
            { label: "瀘西縣", value: "瀘西縣" },
            { label: "建水縣", value: "建水縣" },
            { label: "元陽縣", value: "元陽縣" },
            { label: "石屏縣", value: "石屏縣" },
            { label: "金平縣", value: "金平縣" },
            { label: "屏邊縣", value: "屏邊縣" },
            { label: "河口縣", value: "河口縣" }
          ]
        },
        {
          label: "西雙版納州",
          value: "西雙版納州",
          children: [
            { label: "景洪市", value: "景洪市" },
            { label: "勐海縣", value: "勐海縣" },
            { label: "勐臘縣", value: "勐臘縣" }
          ]
        },
        {
          label: "楚雄州",
          value: "楚雄州",
          children: [
            { label: "元謀縣", value: "元謀縣" },
            { label: "南華縣", value: "南華縣" },
            { label: "牟定縣", value: "牟定縣" },
            { label: "武定縣", value: "武定縣" },
            { label: "大姚縣", value: "大姚縣" },
            { label: "雙柏縣", value: "雙柏縣" },
            { label: "祿豐縣", value: "祿豐縣" },
            { label: "永仁縣", value: "永仁縣" },
            { label: "姚安縣", value: "姚安縣" },
            { label: "楚雄市", value: "楚雄市" }
          ]
        },
        {
          label: "大理州",
          value: "大理州",
          children: [
            { label: "劍川縣", value: "劍川縣" },
            { label: "彌渡縣", value: "彌渡縣" },
            { label: "雲龍縣", value: "雲龍縣" },
            { label: "洱源縣", value: "洱源縣" },
            { label: "鶴慶縣", value: "鶴慶縣" },
            { label: "賓川縣", value: "賓川縣" },
            { label: "祥雲縣", value: "祥雲縣" },
            { label: "永平縣", value: "永平縣" },
            { label: "巍山縣", value: "巍山縣" },
            { label: "漾濞縣", value: "漾濞縣" },
            { label: "南澗縣", value: "南澗縣" },
            { label: "大理市", value: "大理市" }
          ]
        },
        {
          label: "德宏州",
          value: "德宏州",
          children: [
            { label: "芒市", value: "芒市" },
            { label: "瑞麗市", value: "瑞麗市" },
            { label: "盈江縣", value: "盈江縣" },
            { label: "梁河縣", value: "梁河縣" },
            { label: "隴川縣", value: "隴川縣" }
          ]
        },
        {
          label: "怒江州",
          value: "怒江州",
          children: [
            { label: "瀘水縣", value: "瀘水縣" },
            { label: "福貢縣", value: "福貢縣" },
            { label: "蘭坪縣", value: "蘭坪縣" },
            { label: "貢山縣", value: "貢山縣" }
          ]
        },
        {
          label: "迪慶州",
          value: "迪慶州",
          children: [
            { label: "香格里拉縣", value: "香格里拉縣" },
            { label: "德欽縣", value: "德欽縣" },
            { label: "維西縣", value: "維西縣" }
          ]
        }
      ]
    },
    {
      label: "西藏",
      value: "西藏",
      children: [
        {
          label: "拉薩市",
          value: "拉薩市",
          children: [
            { label: "城關區", value: "城關區" },
            { label: "林周縣", value: "林周縣" },
            { label: "當雄縣", value: "當雄縣" },
            { label: "尼木縣", value: "尼木縣" },
            { label: "曲水縣", value: "曲水縣" },
            { label: "堆龍德慶縣", value: "堆龍德慶縣" },
            { label: "達孜縣", value: "達孜縣" },
            { label: "墨竹工卡縣", value: "墨竹工卡縣" }
          ]
        },
        {
          label: "那曲地區",
          value: "那曲地區",
          children: [
            { label: "索縣", value: "索縣" },
            { label: "那曲縣", value: "那曲縣" },
            { label: "嘉黎縣", value: "嘉黎縣" },
            { label: "比如縣", value: "比如縣" },
            { label: "聶榮縣", value: "聶榮縣" },
            { label: "安多縣", value: "安多縣" },
            { label: "申扎縣", value: "申扎縣" },
            { label: "班戈縣", value: "班戈縣" },
            { label: "巴青縣", value: "巴青縣" },
            { label: "尼瑪縣", value: "尼瑪縣" },
            { label: "雙湖縣", value: "雙湖縣" }
          ]
        },
        {
          label: "山南地區",
          value: "山南地區",
          children: [
            { label: "貢嘎縣", value: "貢嘎縣" },
            { label: "扎囊縣", value: "扎囊縣" },
            { label: "乃東縣", value: "乃東縣" },
            { label: "桑日縣", value: "桑日縣" },
            { label: "瓊結縣", value: "瓊結縣" },
            { label: "曲松縣", value: "曲松縣" },
            { label: "措美縣", value: "措美縣" },
            { label: "洛扎縣", value: "洛扎縣" },
            { label: "加查縣", value: "加查縣" },
            { label: "隆子縣", value: "隆子縣" },
            { label: "錯那縣", value: "錯那縣" },
            { label: "浪卡子縣", value: "浪卡子縣" }
          ]
        },
        {
          label: "昌都地區",
          value: "昌都地區",
          children: [
            { label: "昌都縣", value: "昌都縣" },
            { label: "江達縣", value: "江達縣" },
            { label: "貢覺縣", value: "貢覺縣" },
            { label: "類烏齊縣", value: "類烏齊縣" },
            { label: "丁青縣", value: "丁青縣" },
            { label: "察雅縣", value: "察雅縣" },
            { label: "八宿縣", value: "八宿縣" },
            { label: "左貢縣", value: "左貢縣" },
            { label: "芒康縣", value: "芒康縣" },
            { label: "洛隆縣", value: "洛隆縣" },
            { label: "邊壩縣", value: "邊壩縣" }
          ]
        },
        {
          label: "日喀則地區",
          value: "日喀則地區",
          children: [
            { label: "聶拉木縣", value: "聶拉木縣" },
            { label: "昂仁縣", value: "昂仁縣" },
            { label: "日喀則市", value: "日喀則市" },
            { label: "南木林縣", value: "南木林縣" },
            { label: "江孜縣", value: "江孜縣" },
            { label: "定日縣", value: "定日縣" },
            { label: "薩迦縣　", value: "薩迦縣　" },
            { label: "拉孜縣", value: "拉孜縣" },
            { label: "謝通門縣", value: "謝通門縣" },
            { label: "白朗縣", value: "白朗縣" },
            { label: "仁布縣", value: "仁布縣" },
            { label: "康馬縣", value: "康馬縣" },
            { label: "定結縣", value: "定結縣" },
            { label: "仲巴縣", value: "仲巴縣" },
            { label: "亞東縣", value: "亞東縣" },
            { label: "吉隆縣", value: "吉隆縣" },
            { label: "薩嘎縣", value: "薩嘎縣" },
            { label: "崗巴縣", value: "崗巴縣" }
          ]
        },
        {
          label: "阿里地區",
          value: "阿里地區",
          children: [
            { label: "噶爾縣", value: "噶爾縣" },
            { label: "普蘭縣", value: "普蘭縣" },
            { label: "札達縣　", value: "札達縣　" },
            { label: "日土縣", value: "日土縣" },
            { label: "革吉縣", value: "革吉縣" },
            { label: "改則縣", value: "改則縣" },
            { label: "措勤縣", value: "措勤縣" }
          ]
        },
        {
          label: "林芝地區",
          value: "林芝地區",
          children: [
            { label: "林芝縣", value: "林芝縣" },
            { label: "工布江達縣", value: "工布江達縣" },
            { label: "米林縣", value: "米林縣" },
            { label: "墨脫縣", value: "墨脫縣" },
            { label: "波密縣", value: "波密縣" },
            { label: "察隅縣", value: "察隅縣" },
            { label: "朗縣", value: "朗縣" }
          ]
        }
      ]
    },
    {
      label: "陝西",
      value: "陝西",
      children: [
        {
          label: "西安市",
          value: "西安市",
          children: [
            { label: "高陵縣", value: "高陵縣" },
            { label: "藍田縣", value: "藍田縣" },
            { label: "戶縣", value: "戶縣" },
            { label: "周至縣", value: "周至縣" },
            { label: "雁塔區", value: "雁塔區" },
            { label: "未央區", value: "未央區" },
            { label: "長安區", value: "長安區" },
            { label: "灞橋區", value: "灞橋區" },
            { label: "碑林區", value: "碑林區" },
            { label: "蓮湖區", value: "蓮湖區" },
            { label: "臨潼區", value: "臨潼區" },
            { label: "閻良區", value: "閻良區" },
            { label: "新城區", value: "新城區" },
            { label: "西安武警工程學院", value: "西安武警工程學院" }
          ]
        },
        {
          label: "銅川市",
          value: "銅川市",
          children: [
            { label: "印台區", value: "印台區" },
            { label: "宜君縣", value: "宜君縣" },
            { label: "王益區", value: "王益區" },
            { label: "耀州區", value: "耀州區" }
          ]
        },
        {
          label: "寶雞市",
          value: "寶雞市",
          children: [
            { label: "岐山縣", value: "岐山縣" },
            { label: "太白縣", value: "太白縣" },
            { label: "鳳翔縣", value: "鳳翔縣" },
            { label: "隴縣", value: "隴縣" },
            { label: "麟游縣", value: "麟游縣" },
            { label: "千陽縣", value: "千陽縣" },
            { label: "扶風縣", value: "扶風縣" },
            { label: "鳳縣", value: "鳳縣" },
            { label: "眉縣", value: "眉縣" },
            { label: "渭濱區", value: "渭濱區" },
            { label: "金台區", value: "金台區" },
            { label: "陳倉區", value: "陳倉區" }
          ]
        },
        {
          label: "咸陽市",
          value: "咸陽市",
          children: [
            { label: "興平市", value: "興平市" },
            { label: "禮泉縣", value: "禮泉縣" },
            { label: "涇陽縣", value: "涇陽縣" },
            { label: "永壽縣", value: "永壽縣" },
            { label: "三原縣", value: "三原縣" },
            { label: "彬縣", value: "彬縣" },
            { label: "旬邑縣", value: "旬邑縣" },
            { label: "長武縣", value: "長武縣" },
            { label: "乾縣", value: "乾縣" },
            { label: "武功縣", value: "武功縣" },
            { label: "淳化縣", value: "淳化縣" },
            { label: "秦都區", value: "秦都區" },
            { label: "渭城區", value: "渭城區" },
            { label: "楊陵區", value: "楊陵區" }
          ]
        },
        {
          label: "渭南市",
          value: "渭南市",
          children: [
            { label: "韓城市", value: "韓城市" },
            { label: "華陰市", value: "華陰市" },
            { label: "蒲城縣", value: "蒲城縣" },
            { label: "華縣", value: "華縣" },
            { label: "潼關縣", value: "潼關縣" },
            { label: "大荔縣", value: "大荔縣" },
            { label: "澄城縣", value: "澄城縣" },
            { label: "合陽縣", value: "合陽縣" },
            { label: "白水縣", value: "白水縣" },
            { label: "富平縣", value: "富平縣" },
            { label: "臨渭區", value: "臨渭區" }
          ]
        },
        {
          label: "延安市",
          value: "延安市",
          children: [
            { label: "安塞縣", value: "安塞縣" },
            { label: "洛川縣", value: "洛川縣" },
            { label: "子長縣", value: "子長縣" },
            { label: "黃陵縣", value: "黃陵縣" },
            { label: "延長縣", value: "延長縣" },
            { label: "宜川縣", value: "宜川縣" },
            { label: "延川縣", value: "延川縣" },
            { label: "甘泉縣", value: "甘泉縣" },
            { label: "富縣", value: "富縣" },
            { label: "志丹縣", value: "志丹縣" },
            { label: "黃龍縣", value: "黃龍縣" },
            { label: "吳起縣", value: "吳起縣" },
            { label: "寶塔區", value: "寶塔區" }
          ]
        },
        {
          label: "漢中市",
          value: "漢中市",
          children: [
            { label: "南鄭縣", value: "南鄭縣" },
            { label: "城固縣", value: "城固縣" },
            { label: "洋縣", value: "洋縣" },
            { label: "佛坪縣", value: "佛坪縣" },
            { label: "留壩縣", value: "留壩縣" },
            { label: "鎮巴縣", value: "鎮巴縣" },
            { label: "西鄉縣", value: "西鄉縣" },
            { label: "勉縣", value: "勉縣" },
            { label: "略陽縣", value: "略陽縣" },
            { label: "寧強縣", value: "寧強縣" },
            { label: "漢台區", value: "漢台區" },
            { label: "經濟開發區南區", value: "經濟開發區南區" }
          ]
        },
        {
          label: "榆林市",
          value: "榆林市",
          children: [
            { label: "清澗縣", value: "清澗縣" },
            { label: "綏德縣", value: "綏德縣" },
            { label: "佳縣", value: "佳縣" },
            { label: "神木縣", value: "神木縣" },
            { label: "府谷縣", value: "府谷縣" },
            { label: "子洲縣", value: "子洲縣" },
            { label: "橫山縣", value: "橫山縣" },
            { label: "米脂縣", value: "米脂縣" },
            { label: "吳堡縣", value: "吳堡縣" },
            { label: "定邊縣", value: "定邊縣" },
            { label: "靖邊縣", value: "靖邊縣" },
            { label: "榆陽區", value: "榆陽區" }
          ]
        },
        {
          label: "商洛市",
          value: "商洛市",
          children: [
            { label: "商州區", value: "商州區" },
            { label: "鎮安縣", value: "鎮安縣" },
            { label: "山陽縣", value: "山陽縣" },
            { label: "洛南縣", value: "洛南縣" },
            { label: "商南縣", value: "商南縣" },
            { label: "丹鳳縣", value: "丹鳳縣" },
            { label: "柞水縣", value: "柞水縣" }
          ]
        },
        {
          label: "安康市",
          value: "安康市",
          children: [
            { label: "紫陽縣", value: "紫陽縣" },
            { label: "嵐皋縣", value: "嵐皋縣" },
            { label: "旬陽縣", value: "旬陽縣" },
            { label: "鎮坪縣", value: "鎮坪縣" },
            { label: "平利縣", value: "平利縣" },
            { label: "寧陝縣", value: "寧陝縣" },
            { label: "漢陰縣", value: "漢陰縣" },
            { label: "石泉縣", value: "石泉縣" },
            { label: "白河縣", value: "白河縣" },
            { label: "漢濱區", value: "漢濱區" }
          ]
        }
      ]
    },
    {
      label: "甘肅",
      value: "甘肅",
      children: [
        {
          label: "蘭州市",
          value: "蘭州市",
          children: [
            { label: "永登縣", value: "永登縣" },
            { label: "榆中縣", value: "榆中縣" },
            { label: "皋蘭縣", value: "皋蘭縣" },
            { label: "西固區", value: "西固區" },
            { label: "紅古區", value: "紅古區" },
            { label: "七里河區", value: "七里河區" },
            { label: "安寧區", value: "安寧區" },
            { label: "城關區", value: "城關區" }
          ]
        },
        {
          label: "金昌市",
          value: "金昌市",
          children: [
            { label: "永昌縣", value: "永昌縣" },
            { label: "金川區", value: "金川區" }
          ]
        },
        {
          label: "白銀市",
          value: "白銀市",
          children: [
            { label: "白銀區", value: "白銀區" },
            { label: "平川區", value: "平川區" },
            { label: "靖遠縣", value: "靖遠縣" },
            { label: "景泰縣", value: "景泰縣" },
            { label: "會寧縣", value: "會寧縣" }
          ]
        },
        {
          label: "天水市",
          value: "天水市",
          children: [
            { label: "甘谷縣", value: "甘谷縣" },
            { label: "武山縣", value: "武山縣" },
            { label: "清水縣", value: "清水縣" },
            { label: "秦安縣", value: "秦安縣" },
            { label: "張家川縣", value: "張家川縣" },
            { label: "麥積區", value: "麥積區" },
            { label: "秦州區", value: "秦州區" }
          ]
        },
        {
          label: "嘉峪關市",
          value: "嘉峪關市",
          children: [
            { label: "雄關區", value: "雄關區" },
            { label: "長城區", value: "長城區" },
            { label: "鏡鐵區", value: "鏡鐵區" }
          ]
        },
        {
          label: "平涼市",
          value: "平涼市",
          children: [
            { label: "華亭縣", value: "華亭縣" },
            { label: "崇信縣", value: "崇信縣" },
            { label: "涇川縣", value: "涇川縣" },
            { label: "靈台縣", value: "靈台縣" },
            { label: "庄浪縣", value: "庄浪縣" },
            { label: "崆峒區", value: "崆峒區" },
            { label: "靜寧縣", value: "靜寧縣" }
          ]
        },
        {
          label: "慶陽市",
          value: "慶陽市",
          children: [
            { label: "西峰區", value: "西峰區" },
            { label: "鎮原縣", value: "鎮原縣" },
            { label: "合水縣", value: "合水縣" },
            { label: "華池縣", value: "華池縣" },
            { label: "環縣", value: "環縣" },
            { label: "寧縣", value: "寧縣" },
            { label: "正寧縣", value: "正寧縣" },
            { label: "慶城縣", value: "慶城縣" }
          ]
        },
        {
          label: "隴南市",
          value: "隴南市",
          children: [
            { label: "成縣", value: "成縣" },
            { label: "禮縣", value: "禮縣" },
            { label: "康縣", value: "康縣" },
            { label: "武都區", value: "武都區" },
            { label: "文縣", value: "文縣" },
            { label: "兩當縣", value: "兩當縣" },
            { label: "徽縣", value: "徽縣" },
            { label: "宕昌縣", value: "宕昌縣" },
            { label: "西和縣", value: "西和縣" }
          ]
        },
        {
          label: "武威市",
          value: "武威市",
          children: [
            { label: "涼州區", value: "涼州區" },
            { label: "古浪縣", value: "古浪縣" },
            { label: "天祝縣", value: "天祝縣" },
            { label: "民勤縣", value: "民勤縣" }
          ]
        },
        {
          label: "張掖市",
          value: "張掖市",
          children: [
            { label: "甘州區", value: "甘州區" },
            { label: "山丹縣", value: "山丹縣" },
            { label: "臨澤縣", value: "臨澤縣" },
            { label: "高台縣", value: "高台縣" },
            { label: "肅南縣", value: "肅南縣" },
            { label: "民樂縣", value: "民樂縣" }
          ]
        },
        {
          label: "酒泉市",
          value: "酒泉市",
          children: [
            { label: "玉門市", value: "玉門市" },
            { label: "敦煌市", value: "敦煌市" },
            { label: "金塔縣", value: "金塔縣" },
            { label: "阿克塞縣", value: "阿克塞縣" },
            { label: "肅北縣", value: "肅北縣" },
            { label: "瓜州縣", value: "瓜州縣" },
            { label: "肅州區", value: "肅州區" }
          ]
        },
        {
          label: "甘南州",
          value: "甘南州",
          children: [
            { label: "合作市", value: "合作市" },
            { label: "夏河縣", value: "夏河縣" },
            { label: "碌曲縣", value: "碌曲縣" },
            { label: "舟曲縣", value: "舟曲縣" },
            { label: "瑪曲縣", value: "瑪曲縣" },
            { label: "迭部縣", value: "迭部縣" },
            { label: "臨潭縣", value: "臨潭縣" },
            { label: "卓尼縣", value: "卓尼縣" }
          ]
        },
        {
          label: "臨夏州",
          value: "臨夏州",
          children: [
            { label: "臨夏縣", value: "臨夏縣" },
            { label: "康樂縣", value: "康樂縣" },
            { label: "永靖縣", value: "永靖縣" },
            { label: "和政縣", value: "和政縣" },
            { label: "東鄉族自治縣", value: "東鄉族自治縣" },
            { label: "積石山縣", value: "積石山縣" },
            { label: "臨夏市", value: "臨夏市" },
            { label: "廣河縣", value: "廣河縣" }
          ]
        },
        {
          label: "定西市",
          value: "定西市",
          children: [
            { label: "岷縣", value: "岷縣" },
            { label: "安定區", value: "安定區" },
            { label: "通渭縣", value: "通渭縣" },
            { label: "臨洮縣", value: "臨洮縣" },
            { label: "漳縣", value: "漳縣" },
            { label: "渭源縣", value: "渭源縣" },
            { label: "隴西縣", value: "隴西縣" }
          ]
        }
      ]
    },
    {
      label: "青海",
      value: "青海",
      children: [
        {
          label: "西寧市",
          value: "西寧市",
          children: [
            { label: "湟中縣", value: "湟中縣" },
            { label: "湟源縣", value: "湟源縣" },
            { label: "大通縣", value: "大通縣" },
            { label: "城中區", value: "城中區" },
            { label: "城東區", value: "城東區" },
            { label: "城西區", value: "城西區" },
            { label: "城北區", value: "城北區" }
          ]
        },
        {
          label: "海東地區",
          value: "海東地區",
          children: [
            { label: "平安縣", value: "平安縣" },
            { label: "樂都縣", value: "樂都縣" },
            { label: "民和縣", value: "民和縣" },
            { label: "互助縣", value: "互助縣" },
            { label: "化隆縣", value: "化隆縣" },
            { label: "循化縣", value: "循化縣" }
          ]
        },
        {
          label: "海北州",
          value: "海北州",
          children: [
            { label: "海晏縣", value: "海晏縣" },
            { label: "祁連縣", value: "祁連縣" },
            { label: "剛察縣", value: "剛察縣" },
            { label: "門源縣", value: "門源縣" }
          ]
        },
        {
          label: "黃南州",
          value: "黃南州",
          children: [
            { label: "尖扎縣", value: "尖扎縣" },
            { label: "同仁縣", value: "同仁縣" },
            { label: "澤庫縣", value: "澤庫縣" },
            { label: "河南縣", value: "河南縣" }
          ]
        },
        {
          label: "海南州",
          value: "海南州",
          children: [
            { label: "共和縣", value: "共和縣" },
            { label: "同德縣", value: "同德縣" },
            { label: "貴德縣", value: "貴德縣" },
            { label: "興海縣", value: "興海縣" },
            { label: "貴南縣", value: "貴南縣" }
          ]
        },
        {
          label: "果洛州",
          value: "果洛州",
          children: [
            { label: "瑪沁縣", value: "瑪沁縣" },
            { label: "甘德縣", value: "甘德縣" },
            { label: "達日縣", value: "達日縣" },
            { label: "班瑪縣", value: "班瑪縣" },
            { label: "久治縣", value: "久治縣" },
            { label: "瑪多縣", value: "瑪多縣" }
          ]
        },
        {
          label: "玉樹州",
          value: "玉樹州",
          children: [
            { label: "玉樹縣", value: "玉樹縣" },
            { label: "稱多縣", value: "稱多縣" },
            { label: "囊謙縣", value: "囊謙縣" },
            { label: "雜多縣", value: "雜多縣" },
            { label: "治多縣", value: "治多縣" },
            { label: "曲麻萊縣", value: "曲麻萊縣" }
          ]
        },
        {
          label: "海西州",
          value: "海西州",
          children: [
            { label: "德令哈市", value: "德令哈市" },
            { label: "烏蘭縣", value: "烏蘭縣" },
            { label: "天峻縣", value: "天峻縣" },
            { label: "都蘭縣", value: "都蘭縣" },
            { label: "大柴旦行委", value: "大柴旦行委" },
            {
              label: "冷湖行委",
              value: "冷湖行委",
              children: [{ label: "冷湖鎮", value: "18235" }]
            },
            { label: "茫崖行委", value: "茫崖行委" },
            { label: "格爾木市", value: "格爾木市" }
          ]
        }
      ]
    },
    {
      label: "寧夏",
      value: "寧夏",
      children: [
        {
          label: "銀川市",
          value: "銀川市",
          children: [
            { label: "靈武市", value: "靈武市" },
            { label: "永寧縣", value: "永寧縣" },
            { label: "賀蘭縣", value: "賀蘭縣" },
            { label: "興慶區", value: "興慶區" },
            { label: "金鳳區", value: "金鳳區" },
            { label: "西夏區", value: "西夏區" }
          ]
        },
        {
          label: "石嘴山市",
          value: "石嘴山市",
          children: [
            { label: "平羅縣", value: "平羅縣" },
            { label: "惠農區", value: "惠農區" },
            { label: "大武口區", value: "大武口區" }
          ]
        },
        {
          label: "吳忠市",
          value: "吳忠市",
          children: [
            { label: "青銅峽市", value: "青銅峽市" },
            { label: "同心縣", value: "同心縣" },
            { label: "鹽池縣", value: "鹽池縣" },
            { label: "紅寺堡開發區", value: "紅寺堡開發區" },
            { label: "利通區", value: "利通區" }
          ]
        },
        {
          label: "固原市",
          value: "固原市",
          children: [
            { label: "西吉縣", value: "西吉縣" },
            { label: "隆德縣", value: "隆德縣" },
            { label: "涇源縣", value: "涇源縣" },
            { label: "彭陽縣", value: "彭陽縣" },
            { label: "原州區", value: "原州區" }
          ]
        },
        {
          label: "中衛市",
          value: "中衛市",
          children: [
            { label: "中寧縣", value: "中寧縣" },
            { label: "海原縣", value: "海原縣" },
            { label: "沙坡頭區", value: "沙坡頭區" }
          ]
        }
      ]
    },
    {
      label: "新疆",
      value: "新疆",
      children: [
        {
          label: "烏魯木齊市",
          value: "烏魯木齊市",
          children: [
            { label: "烏魯木齊縣", value: "烏魯木齊縣" },
            { label: "頭屯河區", value: "頭屯河區" },
            { label: "達坂城區", value: "達坂城區" },
            { label: "米東區", value: "米東區" },
            {
              label: "天山區",
              value: "天山區",
              children: [{ label: "城區", value: "52684" }]
            },
            { label: "新市區", value: "新市區" },
            { label: "沙依巴克區", value: "沙依巴克區" },
            { label: "水磨溝區", value: "水磨溝區" }
          ]
        },
        {
          label: "克拉瑪依市",
          value: "克拉瑪依市",
          children: [
            { label: "克拉瑪依區", value: "克拉瑪依區" },
            { label: "獨山子區", value: "獨山子區" },
            {
              label: "白鹼灘區",
              value: "白鹼灘區",
              children: [{ label: "城區", value: "52690" }]
            },
            { label: "烏爾禾區", value: "烏爾禾區" }
          ]
        },
        {
          label: "石河子市",
          value: "石河子市",
          children: [{ label: "石河子市", value: "石河子市" }]
        },
        {
          label: "吐魯番地區",
          value: "吐魯番地區",
          children: [
            { label: "吐魯番市", value: "吐魯番市" },
            { label: "托克遜縣", value: "托克遜縣" },
            { label: "鄯善縣", value: "鄯善縣" }
          ]
        },
        {
          label: "哈密地區",
          value: "哈密地區",
          children: [
            { label: "哈密市", value: "哈密市" },
            { label: "巴里坤縣", value: "巴里坤縣" },
            { label: "伊吾縣", value: "伊吾縣" }
          ]
        },
        {
          label: "和田地區",
          value: "和田地區",
          children: [
            { label: "和田市", value: "和田市" },
            { label: "墨玉縣", value: "墨玉縣" },
            { label: "洛浦縣", value: "洛浦縣" },
            { label: "策勒縣", value: "策勒縣" },
            { label: "于田縣", value: "于田縣" },
            { label: "民豐縣", value: "民豐縣" },
            { label: "皮山縣", value: "皮山縣" },
            { label: "和田縣", value: "和田縣" }
          ]
        },
        {
          label: "阿克蘇地區",
          value: "阿克蘇地區",
          children: [
            { label: "阿克蘇市", value: "阿克蘇市" },
            { label: "溫宿縣", value: "溫宿縣" },
            { label: "沙雅縣", value: "沙雅縣" },
            { label: "拜城縣", value: "拜城縣" },
            { label: "阿瓦提縣", value: "阿瓦提縣" },
            { label: "庫車縣", value: "庫車縣" },
            { label: "柯坪縣", value: "柯坪縣" },
            { label: "新和縣", value: "新和縣" },
            { label: "烏什縣", value: "烏什縣" }
          ]
        },
        {
          label: "喀什地區",
          value: "喀什地區",
          children: [
            { label: "喀什市", value: "喀什市" },
            { label: "巴楚縣", value: "巴楚縣" },
            { label: "澤普縣", value: "澤普縣" },
            { label: "伽師縣", value: "伽師縣" },
            { label: "葉城縣", value: "葉城縣" },
            { label: "岳普湖縣", value: "岳普湖縣" },
            { label: "疏附縣", value: "疏附縣" },
            { label: "疏勒縣", value: "疏勒縣" },
            { label: "英吉沙縣", value: "英吉沙縣" },
            { label: "麥蓋提縣", value: "麥蓋提縣" },
            { label: "莎車縣", value: "莎車縣" },
            { label: "塔什庫爾干縣", value: "塔什庫爾干縣" }
          ]
        },
        {
          label: "克孜勒蘇州",
          value: "克孜勒蘇州",
          children: [
            { label: "阿圖什市", value: "阿圖什市" },
            { label: "阿合奇縣", value: "阿合奇縣" },
            { label: "烏恰縣", value: "烏恰縣" },
            { label: "阿克陶縣", value: "阿克陶縣" }
          ]
        },
        {
          label: "巴音郭楞州",
          value: "巴音郭楞州",
          children: [
            { label: "庫爾勒市", value: "庫爾勒市" },
            { label: "尉犁縣", value: "尉犁縣" },
            { label: "和靜縣", value: "和靜縣" },
            { label: "博湖縣", value: "博湖縣" },
            { label: "和碩縣", value: "和碩縣" },
            { label: "輪台縣", value: "輪台縣" },
            { label: "若羌縣", value: "若羌縣" },
            { label: "且末縣", value: "且末縣" },
            { label: "焉耆縣", value: "焉耆縣" }
          ]
        },
        {
          label: "昌吉州",
          value: "昌吉州",
          children: [
            { label: "昌吉市", value: "昌吉市" },
            { label: "阜康市", value: "阜康市" },
            { label: "奇台縣", value: "奇台縣" },
            { label: "瑪納斯縣", value: "瑪納斯縣" },
            { label: "吉木薩爾縣", value: "吉木薩爾縣" },
            { label: "呼圖壁縣", value: "呼圖壁縣" },
            { label: "木壘縣", value: "木壘縣" }
          ]
        },
        {
          label: "博爾塔拉州",
          value: "博爾塔拉州",
          children: [
            { label: "博樂市", value: "博樂市" },
            { label: "精河縣", value: "精河縣" },
            { label: "溫泉縣", value: "溫泉縣" },
            { label: "阿拉山口市", value: "阿拉山口市" }
          ]
        },
        {
          label: "伊犁州",
          value: "伊犁州",
          children: [
            { label: "伊寧市", value: "伊寧市" },
            { label: "特克斯縣", value: "特克斯縣" },
            { label: "尼勒克縣", value: "尼勒克縣" },
            { label: "昭蘇縣", value: "昭蘇縣" },
            { label: "新源縣", value: "新源縣" },
            { label: "霍城縣", value: "霍城縣" },
            { label: "察布查爾縣", value: "察布查爾縣" },
            { label: "鞏留縣", value: "鞏留縣" },
            { label: "奎屯市", value: "奎屯市" },
            { label: "伊寧縣", value: "伊寧縣" }
          ]
        },
        {
          label: "塔城地區",
          value: "塔城地區",
          children: [
            { label: "塔城市", value: "塔城市" },
            { label: "烏蘇市", value: "烏蘇市" },
            { label: "額敏縣", value: "額敏縣" },
            { label: "裕民縣", value: "裕民縣" },
            { label: "沙灣縣", value: "沙灣縣" },
            { label: "托里縣", value: "托里縣" },
            { label: "和布克賽爾縣", value: "和布克賽爾縣" }
          ]
        },
        {
          label: "阿勒泰地區",
          value: "阿勒泰地區",
          children: [
            { label: "阿勒泰市", value: "阿勒泰市" },
            { label: "富蘊縣", value: "富蘊縣" },
            { label: "青河縣", value: "青河縣" },
            { label: "吉木乃縣", value: "吉木乃縣" },
            { label: "布爾津縣", value: "布爾津縣" },
            { label: "福海縣", value: "福海縣" },
            { label: "哈巴河縣", value: "哈巴河縣" },
            { label: "北屯市", value: "北屯市" }
          ]
        },
        {
          label: "五家渠市",
          value: "五家渠市",
          children: [{ label: "五家渠市", value: "五家渠市" }]
        },
        {
          label: "阿拉爾市",
          value: "阿拉爾市",
          children: [{ label: "阿拉爾市", value: "阿拉爾市" }]
        },
        {
          label: "圖木舒克市",
          value: "圖木舒克市",
          children: [{ label: "圖木舒克市", value: "圖木舒克市" }]
        },
        {
          label: "鐵門關市",
          value: "鐵門關市",
          children: [{ label: "鐵門關市", value: "鐵門關市" }]
        }
      ]
    },
    {
      label: "台灣",
      value: "台灣",
      children: [
        {
          label: "台灣",
          value: "台灣",
          children: [{ label: "台灣市區內", value: "台灣市區內" }]
        }
      ]
    },
    {
      label: "釣魚島",
      value: "釣魚島",
      children: [
        {
          label: "釣魚島",
          value: "釣魚島",
          children: [
            { label: "釣魚島縣", value: "釣魚島縣" },
            { label: "釣魚島縣1", value: "釣魚島縣1" },
            { label: "釣魚島全區", value: "釣魚島全區" }
          ]
        }
      ]
    },
    {
      label: "港澳",
      value: "港澳",
      children: [
        {
          label: "香港特別行政區",
          value: "香港特別行政區",
          children: [
            { label: "中西區", value: "中西區" },
            { label: "東區", value: "東區" },
            { label: "九龍城區", value: "九龍城區" },
            { label: "觀塘區", value: "觀塘區" },
            { label: "深水埗區", value: "深水埗區" },
            { label: "灣仔區", value: "灣仔區" },
            { label: "黃大仙區", value: "黃大仙區" },
            { label: "油尖旺區", value: "油尖旺區" },
            { label: "離島區", value: "離島區" },
            { label: "葵青區", value: "葵青區" },
            { label: "北區", value: "北區" },
            { label: "西貢區", value: "西貢區" },
            { label: "沙田區", value: "沙田區" },
            { label: "屯門區", value: "屯門區" },
            { label: "大埔區", value: "大埔區" },
            { label: "荃灣區", value: "荃灣區" },
            { label: "元朗區", value: "元朗區" },
            { label: "香港", value: "香港" },
            { label: "九龍", value: "九龍" },
            { label: "新界", value: "新界" }
          ]
        },
        {
          label: "澳門特別行政區",
          value: "澳門特別行政區",
          children: [
            { label: "澳門特別行政區", value: "澳門特別行政區" },
            { label: "澳門半島", value: "澳門半島" },
            { label: "凼仔", value: "凼仔" },
            { label: "路凼城", value: "路凼城" },
            { label: "路環", value: "路環" }
          ]
        }
      ]
    },
    {
      label: "海外",
      value: "海外",
      children: [
        { value: "美國", en: "United States of America (USA)", label: "美國" },
        { value: "阿根廷", en: "Argentina", label: "阿根廷" },
        { value: "安道爾", en: "Andorra", label: "安道爾" },
        { value: "阿聯酋", en: "United Arab Emirates", label: "阿聯酋" },
        { value: "阿富汗", en: "Afghanistan", label: "阿富汗" },
        {
          value: "安地卡及巴布達",
          en: "Antigua & Barbuda",
          label: "安地卡及巴布達"
        },
        { value: "安圭拉", en: "Anguilla", label: "安圭拉" },
        { value: "阿爾巴尼亞", en: "Albania", label: "阿爾巴尼亞" },
        { value: "亞美尼亞", en: "Armenia", label: "亞美尼亞" },
        { value: "安哥拉", en: "Angola", label: "安哥拉" },
        { value: "南極洲", en: "Antarctica", label: "南極洲" },
        { value: "美屬薩摩亞", en: "American Samoa", label: "美屬薩摩亞" },
        { value: "奧地利", en: "Austria", label: "奧地利" },
        { value: "澳大利亞", en: "Australia", label: "澳大利亞" },
        { value: "阿魯巴", en: "Aruba", label: "阿魯巴" },
        { value: "奧蘭群島", en: "Aland Island", label: "奧蘭群島" },
        { value: "亞塞拜然", en: "Azerbaijan", label: "亞塞拜然" },
        { value: "波黑", en: "Bosnia & Herzegovina", label: "波黑" },
        { value: "巴貝多", en: "Barbados", label: "巴貝多" },
        { value: "孟加拉", en: "Bangladesh", label: "孟加拉" },
        { value: "比利時", en: "Belgium", label: "比利時" },
        { value: "布吉納法索", en: "Burkina", label: "布吉納法索" },
        { value: "保加利亞", en: "Bulgaria", label: "保加利亞" },
        { value: "巴林", en: "Bahrain", label: "巴林" },
        { value: "蒲隆地", en: "Burundi", label: "蒲隆地" },
        { value: "貝南", en: "Benin", label: "貝南" },
        {
          value: "聖巴泰勒米島",
          en: "Saint Barthélemy",
          label: "聖巴泰勒米島"
        },
        { value: "百慕大", en: "Bermuda", label: "百慕大" },
        { value: "文萊", en: "Brunei", label: "文萊" },
        { value: "玻利維亞", en: "Bolivia", label: "玻利維亞" },
        {
          value: "荷蘭加勒比區",
          en: "Caribbean Netherlands",
          label: "荷蘭加勒比區"
        },
        { value: "巴西", en: "Brazil", label: "巴西" },
        { value: "巴哈馬", en: "The Bahamas", label: "巴哈馬" },
        { value: "不丹", en: "Bhutan", label: "不丹" },
        { value: "布韋島", en: "Bouvet Island", label: "布韋島" },
        { value: "波札那", en: "Botswana", label: "波札那" },
        { value: "白俄羅斯", en: "Belarus", label: "白俄羅斯" },
        { value: "貝里斯", en: "Belize", label: "貝里斯" },
        { value: "加拿大", en: "Canada", label: "加拿大" },
        {
          value: "科科斯群島",
          en: "Cocos (Keeling) Islands",
          label: "科科斯群島"
        },
        {
          value: "剛果（金）",
          en: "Democratic Republic of the Congo",
          label: "剛果（金）"
        },
        { value: "中非", en: "Central African Republic", label: "中非" },
        {
          value: "剛果（布）",
          en: "Republic of the Congo",
          label: "剛果（布）"
        },
        { value: "瑞士", en: "Switzerland", label: "瑞士" },
        { value: "象牙海岸", en: "Cote d'Ivoire", label: "象牙海岸" },
        { value: "庫克群島", en: "Cook Islands", label: "庫克群島" },
        { value: "智利", en: "Chile", label: "智利" },
        { value: "喀麥隆", en: "Cameroon", label: "喀麥隆" },
        { value: "中國", en: "China", label: "中國" },
        { value: "哥倫比亞", en: "Colombia", label: "哥倫比亞" },
        { value: "哥斯大黎加", en: "Costa Rica", label: "哥斯大黎加" },
        { value: "古巴", en: "Cuba", label: "古巴" },
        { value: "維德角", en: "Cape Verde", label: "維德角" },
        { value: "庫拉索", en: "Curacao", label: "庫拉索" },
        { value: "聖誕島", en: "Christmas Island", label: "聖誕島" },
        { value: "塞普勒斯", en: "Cyprus", label: "塞普勒斯" },
        { value: "捷克", en: "Czech Republic", label: "捷克" },
        { value: "德國", en: "Germany", label: "德國" },
        { value: "吉布地", en: "Djibouti", label: "吉布地" },
        { value: "丹麥", en: "Denmark", label: "丹麥" },
        { value: "多米尼克", en: "Dominica", label: "多米尼克" },
        { value: "多米尼加", en: "Dominican Republic", label: "多米尼加" },
        { value: "阿爾及利亞", en: "Algeria", label: "阿爾及利亞" },
        { value: "厄瓜多", en: "Ecuador", label: "厄瓜多" },
        { value: "愛沙尼亞", en: "Estonia", label: "愛沙尼亞" },
        { value: "埃及", en: "Egypt", label: "埃及" },
        { value: "西撒哈拉", en: "Western Sahara", label: "西撒哈拉" },
        { value: "厄利垂亞", en: "Eritrea", label: "厄利垂亞" },
        { value: "西班牙", en: "Spain", label: "西班牙" },
        { value: "衣索比亞", en: "Ethiopia", label: "衣索比亞" },
        { value: "芬蘭", en: "Finland", label: "芬蘭" },
        { value: "斐濟群島", en: "Fiji", label: "斐濟群島" },
        {
          value: "馬爾維納斯群島（福克蘭）",
          en: "Falkland Islands",
          label: "馬爾維納斯群島（福克蘭）"
        },
        {
          value: "密克羅尼西亞聯邦",
          en: "Federated States of Micronesia",
          label: "密克羅尼西亞聯邦"
        },
        { value: "法羅群島", en: "Faroe Islands", label: "法羅群島" },
        { value: "法國 法國", en: "France", label: "法國 法國" },
        { value: "加彭", en: "Gabon", label: "加彭" },
        {
          value: "英國",
          en: "Great Britain (United Kingdom; England)",
          label: "英國"
        },
        { value: "格瑞那達", en: "Grenada", label: "格瑞那達" },
        { value: "喬治亞", en: "Georgia", label: "喬治亞" },
        { value: "法屬蓋亞那", en: "French Guiana", label: "法屬蓋亞那" },
        { value: "根西島", en: "Guernsey", label: "根西島" },
        { value: "迦納", en: "Ghana", label: "迦納" },
        { value: "直布羅陀", en: "Gibraltar", label: "直布羅陀" },
        { value: "格陵蘭", en: "Greenland", label: "格陵蘭" },
        { value: "甘比亞", en: "Gambia", label: "甘比亞" },
        { value: "幾內亞", en: "Guinea", label: "幾內亞" },
        { value: "瓜德羅普", en: "Guadeloupe", label: "瓜德羅普" },
        { value: "赤道幾內亞", en: "Equatorial Guinea", label: "赤道幾內亞" },
        { value: "希臘", en: "Greece", label: "希臘" },
        {
          value: "南喬治亞島和南桑威奇群島",
          en: "South Georgia and the South Sandwich Islands",
          label: "南喬治亞島和南桑威奇群島"
        },
        { value: "瓜地馬拉", en: "Guatemala", label: "瓜地馬拉" },
        { value: "關島", en: "Guam", label: "關島" },
        { value: "幾內亞比索", en: "Guinea-Bissau", label: "幾內亞比索" },
        { value: "蓋亞那", en: "Guyana", label: "蓋亞那" },
        {
          value: "赫德島和麥克唐納群島",
          en: "Heard Island and McDonald Islands",
          label: "赫德島和麥克唐納群島"
        },
        { value: "宏都拉斯", en: "Honduras", label: "宏都拉斯" },
        { value: "克羅埃西亞", en: "Croatia", label: "克羅埃西亞" },
        { value: "海地", en: "Haiti", label: "海地" },
        { value: "匈牙利", en: "Hungary", label: "匈牙利" },
        { value: "印尼", en: "Indonesia", label: "印尼" },
        { value: "愛爾蘭", en: "Ireland", label: "愛爾蘭" },
        { value: "以色列", en: "Israel", label: "以色列" },
        { value: "馬恩島", en: "Isle of Man", label: "馬恩島" },
        { value: "印度", en: "India", label: "印度" },
        {
          value: "英屬印度洋領地",
          en: "British Indian Ocean Territory",
          label: "英屬印度洋領地"
        },
        { value: "伊拉克", en: "Iraq", label: "伊拉克" },
        { value: "伊朗", en: "Iran", label: "伊朗" },
        { value: "冰島", en: "Iceland", label: "冰島" },
        { value: "義大利", en: "Italy", label: "義大利" },
        { value: "澤西島", en: "Jersey", label: "澤西島" },
        { value: "牙買加", en: "Jamaica", label: "牙買加" },
        { value: "約旦", en: "Jordan", label: "約旦" },
        { value: "日本", en: "Japan", label: "日本" },
        { value: "肯尼亞", en: "Kenya", label: "肯尼亞" },
        { value: "吉爾吉斯斯坦", en: "Kyrgyzstan", label: "吉爾吉斯斯坦" },
        { value: "柬埔寨", en: "Cambodia", label: "柬埔寨" },
        { value: "吉里巴斯", en: "Kiribati", label: "吉里巴斯" },
        { value: "葛摩", en: "The Comoros", label: "葛摩" },
        {
          value: "聖基茨和尼維斯",
          en: "St. Kitts & Nevis",
          label: "聖基茨和尼維斯"
        },
        { value: "朝鮮", en: "North Korea", label: "朝鮮" },
        { value: "韓國", en: "South Korea", label: "韓國" },
        { value: "科威特", en: "Kuwait", label: "科威特" },
        { value: "開曼群島", en: "Cayman Islands", label: "開曼群島" },
        { value: "哈薩克斯坦", en: "Kazakhstan", label: "哈薩克斯坦" },
        { value: "寮國", en: "Laos", label: "寮國" },
        { value: "黎巴嫩", en: "Lebanon", label: "黎巴嫩" },
        { value: "聖露西亞", en: "St. Lucia", label: "聖露西亞" },
        { value: "列支敦斯登", en: "Liechtenstein", label: "列支敦斯登" },
        { value: "斯里蘭卡", en: "Sri Lanka", label: "斯里蘭卡" },
        { value: "賴比瑞亞", en: "Liberia", label: "賴比瑞亞" },
        { value: "賴索托", en: "Lesotho", label: "賴索托" },
        { value: "立陶宛", en: "Lithuania", label: "立陶宛" },
        { value: "盧森堡", en: "Luxembourg", label: "盧森堡" },
        { value: "拉脫維亞", en: "Latvia", label: "拉脫維亞" },
        { value: "利比亞", en: "Libya", label: "利比亞" },
        { value: "摩洛哥", en: "Morocco", label: "摩洛哥" },
        { value: "摩納哥", en: "Monaco", label: "摩納哥" },
        { value: "摩爾多瓦", en: "Moldova", label: "摩爾多瓦" },
        { value: "黑山", en: "Montenegro", label: "黑山" },
        {
          value: "法屬聖馬丁",
          en: "Saint Martin (France)",
          label: "法屬聖馬丁"
        },
        { value: "馬達加斯加", en: "Madagascar", label: "馬達加斯加" },
        { value: "馬紹爾群島", en: "Marshall islands", label: "馬紹爾群島" },
        {
          value: "馬其頓",
          en: "Republic of Macedonia (FYROM)",
          label: "馬其頓"
        },
        { value: "馬里", en: "Mali", label: "馬里" },
        { value: "緬甸", en: "Myanmar (Burma)", label: "緬甸" },
        { value: "蒙古國", en: "Mongolia", label: "蒙古國" },
        {
          value: "北馬里亞納群島",
          en: "Northern Mariana Islands",
          label: "北馬里亞納群島"
        },
        { value: "馬提尼克", en: "Martinique", label: "馬提尼克" },
        { value: "茅利塔尼亞", en: "Mauritania", label: "茅利塔尼亞" },
        { value: "蒙塞拉特島", en: "Montserrat", label: "蒙塞拉特島" },
        { value: "馬耳他", en: "Malta", label: "馬耳他" },
        { value: "模里西斯", en: "Mauritius", label: "模里西斯" },
        { value: "馬爾地夫", en: "Maldives", label: "馬爾地夫" },
        { value: "馬拉維", en: "Malawi", label: "馬拉維" },
        { value: "墨西哥", en: "Mexico", label: "墨西哥" },
        { value: "馬來西亞", en: "Malaysia", label: "馬來西亞" },
        { value: "莫三比克", en: "Mozambique", label: "莫三比克" },
        { value: "納米比亞", en: "Namibia", label: "納米比亞" },
        { value: "新喀里多尼亞", en: "New Caledonia", label: "新喀里多尼亞" },
        { value: "尼日", en: "Niger", label: "尼日" },
        { value: "諾福克島", en: "Norfolk Island", label: "諾福克島" },
        { value: "奈及利亞", en: "Nigeria", label: "奈及利亞" },
        { value: "尼加拉瓜", en: "Nicaragua", label: "尼加拉瓜" },
        { value: "荷蘭", en: "Netherlands", label: "荷蘭" },
        { value: "挪威", en: "Norway", label: "挪威" },
        { value: "尼泊爾", en: "Nepal", label: "尼泊爾" },
        { value: "諾魯", en: "Nauru", label: "諾魯" },
        { value: "紐埃", en: "Niue", label: "紐埃" },
        { value: "紐西蘭", en: "New Zealand", label: "紐西蘭" },
        { value: "阿曼", en: "Oman", label: "阿曼" },
        { value: "巴拿馬", en: "Panama", label: "巴拿馬" },
        { value: "秘魯", en: "Peru", label: "秘魯" },
        {
          value: "法屬波利尼西亞",
          en: "French polynesia",
          label: "法屬波利尼西亞"
        },
        {
          value: "巴布亞新幾內亞",
          en: "Papua New Guinea",
          label: "巴布亞新幾內亞"
        },
        { value: "菲律賓", en: "The Philippines", label: "菲律賓" },
        { value: "巴基斯坦", en: "Pakistan", label: "巴基斯坦" },
        { value: "波蘭", en: "Poland", label: "波蘭" },
        {
          value: "聖皮埃爾和密克隆",
          en: "Saint-Pierre and Miquelon",
          label: "聖皮埃爾和密克隆"
        },
        {
          value: "皮特凱恩群島",
          en: "Pitcairn Islands",
          label: "皮特凱恩群島"
        },
        { value: "波多黎各", en: "Puerto Rico", label: "波多黎各" },
        { value: "巴勒斯坦", en: "Palestinian territories", label: "巴勒斯坦" },
        { value: "葡萄牙", en: "Portugal", label: "葡萄牙" },
        { value: "帕勞", en: "Palau", label: "帕勞" },
        { value: "巴拉圭", en: "Paraguay", label: "巴拉圭" },
        { value: "卡達", en: "Qatar", label: "卡達" },
        { value: "留尼汪", en: "Réunion", label: "留尼汪" },
        { value: "羅馬尼亞", en: "Romania", label: "羅馬尼亞" },
        { value: "塞爾維亞", en: "Serbia", label: "塞爾維亞" },
        { value: "俄羅斯", en: "Russian Federation", label: "俄羅斯" },
        { value: "盧安達", en: "Rwanda", label: "盧安達" },
        { value: "沙烏地阿拉伯", en: "Saudi Arabia", label: "沙烏地阿拉伯" },
        { value: "索羅門群島", en: "Solomon Islands", label: "索羅門群島" },
        { value: "塞席爾", en: "Seychelles", label: "塞席爾" },
        { value: "蘇丹", en: "Sudan", label: "蘇丹" },
        { value: "瑞典", en: "Sweden", label: "瑞典" },
        { value: "新加坡", en: "Singapore", label: "新加坡" },
        {
          value: "聖赫勒拿",
          en: "St. Helena & Dependencies",
          label: "聖赫勒拿"
        },
        { value: "斯洛維尼亞", en: "Slovenia", label: "斯洛維尼亞" },
        {
          value: "斯瓦爾巴群島和揚馬延島",
          en: "Svalbard and Jan Mayen",
          label: "斯瓦爾巴群島和揚馬延島"
        },
        { value: "斯洛伐克", en: "Slovakia", label: "斯洛伐克" },
        { value: "獅子山", en: "Sierra Leone", label: "獅子山" },
        { value: "聖馬利諾", en: "San Marino", label: "聖馬利諾" },
        { value: "塞內加爾", en: "Senegal", label: "塞內加爾" },
        { value: "索馬利亞", en: "Somalia", label: "索馬利亞" },
        { value: "蘇里南", en: "Surilabel", label: "蘇里南" },
        { value: "南蘇丹", en: "South Sudan", label: "南蘇丹" },
        {
          value: "聖多美和普林西比",
          en: "Sao Tome & Principe",
          label: "聖多美和普林西比"
        },
        { value: "薩爾瓦多", en: "El Salvador", label: "薩爾瓦多" },
        { value: "荷屬聖馬丁", en: "Sint Maarten", label: "荷屬聖馬丁" },
        { value: "敘利亞", en: "Syria", label: "敘利亞" },
        { value: "史瓦濟蘭", en: "Swaziland", label: "史瓦濟蘭" },
        {
          value: "特克斯和凱科斯群島",
          en: "Turks & Caicos Islands",
          label: "特克斯和凱科斯群島"
        },
        { value: "查德", en: "Chad", label: "查德" },
        {
          value: "法屬南部領地",
          en: "French Southern Territories",
          label: "法屬南部領地"
        },
        { value: "多哥", en: "Togo", label: "多哥" },
        { value: "泰國", en: "Thailand", label: "泰國" },
        { value: "塔吉克", en: "Tajikistan", label: "塔吉克" },
        { value: "托克勞", en: "Tokelau", label: "托克勞" },
        { value: "東帝汶", en: "Timor-Leste (East Timor)", label: "東帝汶" },
        { value: "土庫曼斯坦", en: "Turkmenistan", label: "土庫曼斯坦" },
        { value: "突尼西亞", en: "Tunisia", label: "突尼西亞" },
        { value: "湯加", en: "Tonga", label: "湯加" },
        { value: "土耳其", en: "Turkey", label: "土耳其" },
        {
          value: "千里達托貝哥",
          en: "Trinvaluead & Tobago",
          label: "千里達托貝哥"
        },
        { value: "吐瓦魯", en: "Tuvalu", label: "吐瓦魯" },
        { value: "坦尚尼亞", en: "Tanzania", label: "坦尚尼亞" },
        { value: "烏克蘭", en: "Ukraine", label: "烏克蘭" },
        { value: "烏干達", en: "Uganda", label: "烏干達" },
        {
          value: "美國本土外小島嶼",
          en: "United States Minor Outlying Islands",
          label: "美國本土外小島嶼"
        },
        { value: "烏拉圭", en: "Uruguay", label: "烏拉圭" },
        { value: "烏茲別克斯坦", en: "Uzbekistan", label: "烏茲別克斯坦" },
        { value: "梵蒂岡", en: "Vatican City (The Holy See)", label: "梵蒂岡" },
        {
          value: "聖文森及格瑞那丁",
          en: "St. Vincent & the Grenadines",
          label: "聖文森及格瑞那丁"
        },
        { value: "委內瑞拉", en: "Venezuela", label: "委內瑞拉" },
        {
          value: "英屬維爾京群島",
          en: "British Virgin Islands",
          label: "英屬維爾京群島"
        },
        {
          value: "美屬維爾京群島",
          en: "United States Virgin Islands",
          label: "美屬維爾京群島"
        },
        { value: "越南", en: "Vietnam", label: "越南" },
        { value: "萬那杜", en: "Vanuatu", label: "萬那杜" },
        {
          value: "瓦利斯和富圖納",
          en: "Wallis and Futuna",
          label: "瓦利斯和富圖納"
        },
        { value: "薩摩亞", en: "Samoa", label: "薩摩亞" },
        { value: "葉門", en: "Yemen", label: "葉門" },
        { value: "馬約特", en: "Mayotte", label: "馬約特" },
        { value: "南非", en: "South Africa", label: "南非" },
        { value: "尚比亞", en: "Zambia", label: "尚比亞" },
        { value: "辛巴威", en: "Zimbabwe", label: "辛巴威" }
      ]
    }
  ]
};

export default addressData;
</script>


// WEBPACK FOOTER //
// src/utils/dataAddress.vue